import r0 from "clsx";
import { jsxs as d, jsx as n, Fragment as t1 } from "react/jsx-runtime";
import * as W from "react";
import We, { forwardRef as o, createElement as a1, useEffect as o1, useLayoutEffect as De, useRef as q, useState as _, useImperativeHandle as U0, useCallback as X1, useMemo as Q, Children as Ue, isValidElement as J1, useId as qe, cloneElement as _e } from "react";
var Xe = Object.defineProperty, Ye = Object.defineProperties, Ke = Object.getOwnPropertyDescriptors, L1 = Object.getOwnPropertySymbols, q0 = Object.prototype.hasOwnProperty, _0 = Object.prototype.propertyIsEnumerable, h0 = (l, r, e) => r in l ? Xe(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, Qe = (l, r) => {
  for (var e in r || (r = {}))
    q0.call(r, e) && h0(l, e, r[e]);
  if (L1)
    for (var e of L1(r))
      _0.call(r, e) && h0(l, e, r[e]);
  return l;
}, Je = (l, r) => Ye(l, Ke(r)), e2 = (l, r) => {
  var e = {};
  for (var t in l)
    q0.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && L1)
    for (var t of L1(l))
      r.indexOf(t) < 0 && _0.call(l, t) && (e[t] = l[t]);
  return e;
}, l2 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = e2(e, ["title", "titleId"]);
  return d("svg", Je(Qe({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.207 10a.5.5 0 0 0-.354.854l3.793 3.792a.5.5 0 0 0 .707 0l3.793-3.792a.5.5 0 0 0-.353-.854H8.207Z", fill: "currentColor" })] }));
}, t2 = o(l2), Y1 = t2, X0 = {
  0: "0px",
  px: "1px",
  "0.25": "2px",
  "0.5": "4px",
  1: "8px",
  "1.5": "12px",
  2: "16px",
  3: "24px",
  4: "32px",
  5: "40px",
  6: "48px",
  8: "64px",
  10: "80px",
  12: "96px",
  16: "128px",
  20: "144px",
  22: "160px",
  full: "100%"
}, Y0 = {
  borderRadius: X0,
  borderWidth: {
    none: "0px",
    small: "1px",
    standard: "2px",
    // eslint-disable-next-line sort-keys
    large: "3px"
  }
}, u0 = {
  // Brand
  "yv-red": "#FF3D4D",
  "yv-red-dark": "#F04C59",
  "warm-neutral": "#F6EFEE",
  "warm-neutral-dark": "#373231",
  // Utility
  current: "currentColor",
  // Grayscale
  transparent: "rgba(0, 0, 0, 0);",
  "transparent-black": "rgba(255, 255, 255, 0.1);",
  "transparent-white": "rgba(255, 255, 255, 0.5);",
  white: "#fff",
  black: "#000000",
  "gray-5": "#F6F4F4",
  "gray-10": "#EDEBEB",
  "gray-15": "#DDDBDB",
  "gray-20": "#BFBDBD",
  "gray-25": "#828080",
  "gray-30": "#636161",
  "gray-35": "#474545",
  "gray-40": "#353333",
  "gray-45": "#232121",
  "gray-50": "#121212",
  // Teal
  "teal-10": "#E6F2F3",
  "teal-20": "#80BDC4",
  "teal-30": "#007B89",
  "teal-40": "#004A52",
  "teal-50": "#002529",
  // Blue
  "blue-10": "#E7F2FD",
  "blue-20": "#9EBCE1",
  "blue-30": "#3D79C2",
  "blue-40": "#29537A",
  "blue-50": "#1C2A3B",
  // Purple
  "purple-10": "#F2EEF3",
  "purple-20": "#BCA8C5",
  "purple-30": "#79518A",
  "purple-40": "#483550",
  "purple-50": "#241829",
  // Magenta
  "magenta-10": "#F5EAEE",
  "magenta-20": "#CC96AA",
  "magenta-30": "#992C55",
  "magenta-40": "#5C1A33",
  "magenta-50": "#2E0D19",
  // Orange
  "orange-10": "#FAECEB",
  "orange-20": "#E59F9A",
  "orange-30": "#CA3E35",
  "orange-40": "#7A2629",
  "orange-50": "#3D1310",
  // Yellow
  "yellow-10": "#FEF5EB",
  "yellow-20": "#F8CB94",
  "yellow-30": "#F19C33",
  "yellow-40": "#975C11",
  "yellow-50": "#4C2D08",
  // Green
  "green-10": "#EEF6F0",
  "green-20": "#ABD0B6",
  "green-30": "#57A16C",
  "green-40": "#346148",
  "green-50": "#1A3026",
  success: "#57A16C",
  "success-light": "#57A16C",
  "success-dark": "#4AAE67",
  info: "#3D79C2",
  "info-light": "#3D79C2",
  "info-dark": "#2A85F4",
  alert: "#CA3E35",
  "alert-light": "#CA3E35",
  "alert-light-hover": "#CF514A",
  "alert-dark": "#F23B22",
  "alert-dark-hover": "#F24F37",
  "alert-hover": "#CF514A",
  // Deprecate
  "alert-active": "#BE3A32",
  // Deprecate
  caution: "#F19C33",
  "caution-light": "#F19C33",
  "caution-dark": "#FFC24A",
  // Grayscale Light
  "canvas-light": "#fff",
  "canvas-secondary-light": "#F6F4F4",
  "text-light": "#121212",
  "text-muted-light": "#828080",
  "tertiary-light": "#D0D2D2",
  "overlay-light": "#121212BF",
  "overlay-text": "#121212",
  "disabled-light": "#D0D2D266",
  "surface-primary-light": "#F6F4F4",
  "surface-secondary-light": "#FFFFFF",
  "surface-tertiary-light": "#FCFAFA",
  "surface-quaternary-light": "#EDEBEB",
  // Grayscale Dark
  "canvas-dark": "#121212",
  "canvas-secondary-dark": "#232121",
  "text-dark": "#FFF",
  "text-muted-dark": "#BFBDBD",
  "tertiary-dark": "#4F5354",
  "overlay-dark": "#000000BF",
  "overlay-body-dark": "#2B3031",
  "disabled-dark": "#4F535466",
  "surface-primary-dark": "#232121",
  "surface-secondary-dark": "#232121",
  "surface-tertiary-dark": "#1C1A1A",
  "surface-quaternary-dark": "#353333",
  // Transparent Black
  "transparent-black-05": "#0000000D",
  "transparent-black-10": "#0000001A",
  "transparent-black-50": "#00000080",
  "transparent-black-95": "#000000F2",
  // Transparent Black
  "transparent-white-05": "#FFFFFF0D",
  "transparent-white-10": "#FFFFFF1A",
  "transparent-white-50": "#FFFFFF80",
  "transparent-white-95": "#FFFFFFF2"
}, i0 = {
  fontSize: {
    11: "0.6875rem",
    // 11px - xs
    12: "0.75rem",
    // 12px - xs
    13: "0.8125rem",
    // 13px - sm
    14: "0.875rem",
    // 14px - sm
    15: "0.9375rem",
    // 15px - md
    16: "1rem",
    // 16px - md
    17: "1.0625rem",
    // 17px - lg
    19: "1.1875rem",
    // 19px - lg
    20: "1.25rem",
    // 20px - xl
    21: "1.3125rem",
    // 21px - scripture md
    23: "1.4375rem",
    // 23px - xl
    25: "1.5625rem",
    // 25px - scripture lg
    28: "1.75rem",
    // 28px - 2xl
    30: "1.875rem",
    // 30px - scripture xl
    33: "2.0625rem",
    // 33px - 3xl
    40: "2.5rem",
    // 40px - 4xl, scripture xxl
    48: "3rem",
    // 48px - 5xl
    57: "3.5625rem",
    // 57px - 6xl
    69: "4.3125rem",
    // 69px - 7xl
    83: "5.1875rem",
    // 83px
    99: "6.1875rem",
    // 99px
    119: "7.4375rem",
    // 119px
    143: "8.9375rem"
    // 143px
  },
  fontWeight: {
    thin: 100,
    regular: 400,
    medium: 500,
    bold: 700
  },
  fontFamily: {
    "aktiv-grotesk": '"aktiv-grotesk", "Helvetica Neue", HelveticaNeue, Helvetica, Arial, sans-serif',
    "aktiv-grotesk-expanded": '"aktiv-grotesk-expanded", "aktiv-grotesk", "Helvetica Neue", HelveticaNeue, Helvetica, Arial, sans-serif',
    "untitled-serif": "Untitled Serif, Baskerville, Georgia, Times New Roman, serif"
  },
  lineHeight: {
    0: 0,
    tight: 1,
    comfy: 1.1,
    default: 1.25,
    loose: 1.5
  }
};
function r2() {
  for (var l = 0, r, e, t = ""; l < arguments.length; )
    (r = arguments[l++]) && (e = K0(r)) && (t && (t += " "), t += e);
  return t;
}
function K0(l) {
  if (typeof l == "string")
    return l;
  for (var r, e = "", t = 0; t < l.length; t++)
    l[t] && (r = K0(l[t])) && (e && (e += " "), e += r);
  return e;
}
var a0 = "-";
function i2(l) {
  var r = n2(l), e = l.conflictingClassGroups, t = l.conflictingClassGroupModifiers, a = t === void 0 ? {} : t;
  function i(f) {
    var g = f.split(a0);
    return g[0] === "" && g.length !== 1 && g.shift(), Q0(g, r) || a2(f);
  }
  function c(f, g) {
    var p = e[f] || [];
    return g && a[f] ? [].concat(p, a[f]) : p;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: c
  };
}
function Q0(l, r) {
  var c;
  if (l.length === 0)
    return r.classGroupId;
  var e = l[0], t = r.nextPart.get(e), a = t ? Q0(l.slice(1), t) : void 0;
  if (a)
    return a;
  if (r.validators.length !== 0) {
    var i = l.join(a0);
    return (c = r.validators.find(function(f) {
      var g = f.validator;
      return g(i);
    })) == null ? void 0 : c.classGroupId;
  }
}
var v0 = /^\[(.+)\]$/;
function a2(l) {
  if (v0.test(l)) {
    var r = v0.exec(l)[1], e = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (e)
      return "arbitrary.." + e;
  }
}
function n2(l) {
  var r = l.theme, e = l.prefix, t = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, a = o2(Object.entries(l.classGroups), e);
  return a.forEach(function(i) {
    var c = i[0], f = i[1];
    e0(f, t, c, r);
  }), t;
}
function e0(l, r, e, t) {
  l.forEach(function(a) {
    if (typeof a == "string") {
      var i = a === "" ? r : f0(r, a);
      i.classGroupId = e;
      return;
    }
    if (typeof a == "function") {
      if (d2(a)) {
        e0(a(t), r, e, t);
        return;
      }
      r.validators.push({
        validator: a,
        classGroupId: e
      });
      return;
    }
    Object.entries(a).forEach(function(c) {
      var f = c[0], g = c[1];
      e0(g, f0(r, f), e, t);
    });
  });
}
function f0(l, r) {
  var e = l;
  return r.split(a0).forEach(function(t) {
    e.nextPart.has(t) || e.nextPart.set(t, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), e = e.nextPart.get(t);
  }), e;
}
function d2(l) {
  return l.isThemeGetter;
}
function o2(l, r) {
  return r ? l.map(function(e) {
    var t = e[0], a = e[1], i = a.map(function(c) {
      return typeof c == "string" ? r + c : typeof c == "object" ? Object.fromEntries(Object.entries(c).map(function(f) {
        var g = f[0], p = f[1];
        return [r + g, p];
      })) : c;
    });
    return [t, i];
  }) : l;
}
function c2(l) {
  if (l < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var r = 0, e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  function a(i, c) {
    e.set(i, c), r++, r > l && (r = 0, t = e, e = /* @__PURE__ */ new Map());
  }
  return {
    get: function(c) {
      var f = e.get(c);
      if (f !== void 0)
        return f;
      if ((f = t.get(c)) !== void 0)
        return a(c, f), f;
    },
    set: function(c, f) {
      e.has(c) ? e.set(c, f) : a(c, f);
    }
  };
}
var J0 = "!";
function s2(l) {
  var r = l.separator || ":", e = r.length === 1, t = r[0], a = r.length;
  return function(c) {
    for (var f = [], g = 0, p = 0, b, w = 0; w < c.length; w++) {
      var k = c[w];
      if (g === 0) {
        if (k === t && (e || c.slice(w, w + a) === r)) {
          f.push(c.slice(p, w)), p = w + a;
          continue;
        }
        if (k === "/") {
          b = w;
          continue;
        }
      }
      k === "[" ? g++ : k === "]" && g--;
    }
    var m = f.length === 0 ? c : c.substring(p), I = m.startsWith(J0), x = I ? m.substring(1) : m, z = b && b > p ? b - p : void 0;
    return {
      modifiers: f,
      hasImportantModifier: I,
      baseClassName: x,
      maybePostfixModifierPosition: z
    };
  };
}
function h2(l) {
  if (l.length <= 1)
    return l;
  var r = [], e = [];
  return l.forEach(function(t) {
    var a = t[0] === "[";
    a ? (r.push.apply(r, e.sort().concat([t])), e = []) : e.push(t);
  }), r.push.apply(r, e.sort()), r;
}
function u2(l) {
  return {
    cache: c2(l.cacheSize),
    splitModifiers: s2(l),
    ...i2(l)
  };
}
var v2 = /\s+/;
function f2(l, r) {
  var e = r.splitModifiers, t = r.getClassGroupId, a = r.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return l.trim().split(v2).map(function(c) {
    var f = e(c), g = f.modifiers, p = f.hasImportantModifier, b = f.baseClassName, w = f.maybePostfixModifierPosition, k = t(w ? b.substring(0, w) : b), m = !!w;
    if (!k) {
      if (!w)
        return {
          isTailwindClass: !1,
          originalClassName: c
        };
      if (k = t(b), !k)
        return {
          isTailwindClass: !1,
          originalClassName: c
        };
      m = !1;
    }
    var I = h2(g).join(":"), x = p ? I + J0 : I;
    return {
      isTailwindClass: !0,
      modifierId: x,
      classGroupId: k,
      originalClassName: c,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(c) {
    if (!c.isTailwindClass)
      return !0;
    var f = c.modifierId, g = c.classGroupId, p = c.hasPostfixModifier, b = f + g;
    return i.has(b) ? !1 : (i.add(b), a(g, p).forEach(function(w) {
      return i.add(f + w);
    }), !0);
  }).reverse().map(function(c) {
    return c.originalClassName;
  }).join(" ");
}
function g0() {
  for (var l = arguments.length, r = new Array(l), e = 0; e < l; e++)
    r[e] = arguments[e];
  var t, a, i, c = f;
  function f(p) {
    var b = r[0], w = r.slice(1), k = w.reduce(function(m, I) {
      return I(m);
    }, b());
    return t = u2(k), a = t.cache.get, i = t.cache.set, c = g, g(p);
  }
  function g(p) {
    var b = a(p);
    if (b)
      return b;
    var w = f2(p, t);
    return i(p, w), w;
  }
  return function() {
    return c(r2.apply(null, arguments));
  };
}
function F(l) {
  var r = function(t) {
    return t[l] || [];
  };
  return r.isThemeGetter = !0, r;
}
var ee = /^\[(?:([a-z-]+):)?(.+)\]$/i, g2 = /^\d+\/\d+$/, p2 = /* @__PURE__ */ new Set(["px", "full", "screen"]), w2 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, b2 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, m2 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function i1(l) {
  return m1(l) || p2.has(l) || g2.test(l) || f1(l);
}
function f1(l) {
  return x1(l, "length", M2);
}
function x2(l) {
  return x1(l, "size", le);
}
function y2(l) {
  return x1(l, "position", le);
}
function C2(l) {
  return x1(l, "url", z2);
}
function V1(l) {
  return x1(l, "number", m1);
}
function m1(l) {
  return !Number.isNaN(Number(l));
}
function k2(l) {
  return l.endsWith("%") && m1(l.slice(0, -1));
}
function R1(l) {
  return p0(l) || x1(l, "number", p0);
}
function E(l) {
  return ee.test(l);
}
function I1() {
  return !0;
}
function v1(l) {
  return w2.test(l);
}
function Z2(l) {
  return x1(l, "", R2);
}
function x1(l, r, e) {
  var t = ee.exec(l);
  return t ? t[1] ? t[1] === r : e(t[2]) : !1;
}
function M2(l) {
  return b2.test(l);
}
function le() {
  return !1;
}
function z2(l) {
  return l.startsWith("url(");
}
function p0(l) {
  return Number.isInteger(Number(l));
}
function R2(l) {
  return m2.test(l);
}
function w0() {
  var l = F("colors"), r = F("spacing"), e = F("blur"), t = F("brightness"), a = F("borderColor"), i = F("borderRadius"), c = F("borderSpacing"), f = F("borderWidth"), g = F("contrast"), p = F("grayscale"), b = F("hueRotate"), w = F("invert"), k = F("gap"), m = F("gradientColorStops"), I = F("gradientColorStopPositions"), x = F("inset"), z = F("margin"), y = F("opacity"), S = F("padding"), A = F("saturate"), H = F("scale"), O = F("sepia"), N = F("skew"), M = F("space"), C = F("translate"), R = function() {
    return ["auto", "contain", "none"];
  }, B = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, P = function() {
    return ["auto", r];
  }, $ = function() {
    return ["", i1];
  }, j = function() {
    return ["auto", m1, E];
  }, y1 = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, n1 = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, g1 = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, p1 = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, c1 = function() {
    return ["", "0", E];
  }, C1 = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, s1 = function() {
    return [m1, V1];
  }, u1 = function() {
    return [m1, E];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [I1],
      spacing: [i1],
      blur: ["none", "", v1, f1],
      brightness: s1(),
      borderColor: [l],
      borderRadius: ["none", "", "full", v1, f1],
      borderSpacing: [r],
      borderWidth: $(),
      contrast: s1(),
      grayscale: c1(),
      hueRotate: u1(),
      invert: c1(),
      gap: [r],
      gradientColorStops: [l],
      gradientColorStopPositions: [k2, f1],
      inset: P(),
      margin: P(),
      opacity: s1(),
      padding: [r],
      saturate: s1(),
      scale: s1(),
      sepia: c1(),
      skew: u1(),
      space: [r],
      translate: [r]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", E]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [v1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C1()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C1()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(y1(), [E])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: B()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": B()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": B()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [x]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [x]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [x]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [x]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [x]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [x]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [x]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [x]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [x]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", R1]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", E]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: c1()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: c1()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", R1]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [I1]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [R1]
        }, E]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [I1]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [R1]
        }, E]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", E]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", E]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [k]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [k]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [k]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(p1())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(p1(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(p1(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [z]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [z]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [z]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [z]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [z]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [z]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [z]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [z]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [z]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [M]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [M]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", i1]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [v1]
        }, v1, f1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [r, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", i1]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [r, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", v1, f1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", V1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [I1]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", f1]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", m1, V1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", i1]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", E]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", E]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [l]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [l]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(n1(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", i1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", i1]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [l]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [r]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", f1]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", E]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(y1(), [y2])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", x2]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, C2]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [l]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [I]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [I]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [I]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [f]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [f]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [f]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [f]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [f]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [f]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [f]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [f]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [f]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(n1(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [f]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [f]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: n1()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(n1())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [i1]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [i1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [l]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: $()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [l]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [i1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [l]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", v1, Z2]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [I1]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": g1()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": g1()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [e]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [t]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [g]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", v1, E]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [p]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [b]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [w]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [A]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [O]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [e]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [t]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [g]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [p]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [b]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [w]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [A]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [O]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [c]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [c]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [c]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", E]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: u1()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", E]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: u1()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", E]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [H]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [H]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [H]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [R1, E]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", E]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", l]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", E]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [l]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [r]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [r]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [r]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [r]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [r]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [r]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [r]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [r]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [r]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [r]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [r]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [r]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [r]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [r]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [r]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [r]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [r]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [r]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", E]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [l, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [i1, V1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [l, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function I2(l, r) {
  for (var e in r)
    te(l, e, r[e]);
  return l;
}
var S2 = Object.prototype.hasOwnProperty, B2 = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function te(l, r, e) {
  if (!S2.call(l, r) || B2.has(typeof e) || e === null) {
    l[r] = e;
    return;
  }
  if (Array.isArray(e) && Array.isArray(l[r])) {
    l[r] = l[r].concat(e);
    return;
  }
  if (typeof e == "object" && typeof l[r] == "object") {
    if (l[r] === null) {
      l[r] = e;
      return;
    }
    for (var t in e)
      te(l[r], t, e[t]);
  }
}
function N2(l) {
  for (var r = arguments.length, e = new Array(r > 1 ? r - 1 : 0), t = 1; t < r; t++)
    e[t - 1] = arguments[t];
  return typeof l == "function" ? g0.apply(void 0, [w0, l].concat(e)) : g0.apply(void 0, [function() {
    return I2(w0(), l);
  }].concat(e));
}
const A2 = Object.keys(i0.fontSize), H2 = Object.keys(i0.fontWeight), V2 = Object.keys(i0.lineHeight), e1 = Object.keys(X0), $2 = Object.keys(Y0.borderWidth), L2 = Object.keys(Y0.borderRadius), O2 = N2({
  classGroups: {
    "font-size": [{ text: A2 }],
    "font-weight": [{ font: H2 }],
    leading: [{ leading: V2 }],
    mbe: [{ mbe: e1 }],
    mbs: [{ mbs: e1 }],
    mie: [{ mie: e1 }],
    mis: [{ mis: e1 }],
    mlb: [{ mlb: e1 }],
    mli: [{ mli: e1 }],
    pbe: [{ pbe: e1 }],
    pbs: [{ pbs: e1 }],
    pie: [{ pie: e1 }],
    pis: [{ pis: e1 }],
    plb: [{ plb: e1 }],
    pli: [{ pli: e1 }]
  },
  conflictingClassGroups: {
    m: ["mie", "mis", "mbe", "mbs", "mlb", "mli"],
    mlb: ["mbe", "mbs"],
    mli: ["mie", "mis"],
    mx: ["mie", "mis", "mli"],
    my: ["mbe", "mbs", "mlb"],
    p: ["pie", "pis", "pbe", "pbs", "plb", "pli"],
    plb: ["pbe", "pbs"],
    pli: ["pie", "pis"],
    px: ["pie", "pis", "pli"],
    py: ["pbe", "pbs", "plb"]
  },
  theme: {
    borderRadius: L2,
    borderWidth: $2
  }
});
function v(...l) {
  return O2(r0(l));
}
const K1 = (l) => {
  if (l) {
    if (typeof l != "string" && l)
      return r0(l.lightMode, l.darkMode);
    if (typeof l == "string")
      return l;
  }
}, b0 = (l) => {
  if (l) {
    if (typeof l != "string" && l)
      return r0(l.block, l.blockEnd, l.blockStart, l.inline, l.inlineEnd, l.inlineStart);
    if (typeof l == "string")
      return l;
  }
}, F2 = ({
  background: l,
  borderColor: r,
  borderRadius: e,
  borderWidth: t,
  className: a,
  component: i = "div",
  color: c,
  elevation: f = 0,
  height: g,
  margin: p,
  padding: b,
  width: w,
  ...k
}, m) => {
  const I = {
    0: "",
    1: "shadow-light-1 dark:shadow-dark-1",
    2: "shadow-light-2 dark:shadow-dark-2",
    4: "shadow-light-4 dark:shadow-dark-4",
    8: "shadow-light-8 dark:shadow-dark-8",
    12: "shadow-light-12 dark:shadow-dark-12"
  }, x = K1(c), z = K1(l), y = K1(r), S = b0(b), A = b0(p), H = v(
    e,
    t,
    I[f],
    A,
    S,
    x,
    z,
    y,
    w,
    g,
    a
  );
  return a1(i, {
    className: H,
    ...k,
    ref: m
  });
}, L = o(F2);
L.displayName = "Box";
const N1 = ({ innerRef: l, forwardedRef: r }) => (o1(() => {
  [l, r].forEach((e) => {
    e && (typeof e == "function" ? e(l.current || null) : e.current = l.current || null);
  });
}, [l, r]), l);
function P2() {
  De(() => {
    const l = window.getComputedStyle(document.body).overflow;
    return document.body.style.overflow = "hidden", () => document.body.style.overflow = l;
  }, []);
}
function re({ handler: l, ref: r }) {
  o1(() => {
    function e(t) {
      const a = r == null ? void 0 : r.current;
      !a || a.contains(t.target) || l(t);
    }
    return window.addEventListener("mouseup", e), () => window.removeEventListener("mouseup", e);
  }, [r, l]);
}
const m0 = {
  base: "font-bold",
  xs: "text-15 md:text-17 leading-default",
  sm: "text-17 md:text-19 leading-default md:leading-comfy",
  md: "text-19 md:text-23 leading-comfy",
  lg: "text-23 md:text-28 leading-comfy",
  xl: "text-28 md:text-33 leading-comfy",
  xxl: "text-33 md:text-40 leading-comfy"
}, $1 = {
  base: "font-medium leading-default",
  default: "text-15",
  xs: "text-11",
  sm: "text-13",
  md: "text-15",
  lg: "text-17",
  xl: "text-19 tracking-tight",
  xxl: "text-23 tracking-tight"
}, Q1 = {
  ...$1,
  base: "font-regular leading-loose",
  xl: "text-19",
  xxl: "text-23"
}, x0 = {
  base: "font-regular font-untitled-serif",
  sm: "text-18",
  md: "text-21",
  lg: "text-25",
  xl: "text-30",
  xxl: "text-40"
}, y0 = {
  base: "font-medium leading-default tracking-wider uppercase",
  xs: "text-11",
  sm: "text-13",
  md: "text-15",
  lg: "text-17",
  xl: "text-19",
  xxl: "text-23"
}, C0 = {
  base: "font-regular leading-default text-text-muted-light dark:text-text-muted-dark",
  sm: "text-11",
  md: "text-13",
  lg: "text-16"
}, k0 = {
  base: "font-bold leading-default",
  xs: "text-12",
  sm: "text-14",
  md: "text-16",
  lg: "text-20"
}, Z0 = {
  base: "font-medium leading-default",
  sm: "text-11",
  md: "text-13",
  lg: "text-16"
}, M0 = {
  base: "font-regular leading-loose",
  md: "text-16",
  lg: "text-19"
}, ie = ({ size: l, variant: r }) => {
  switch (r) {
    case "headline":
      return v(m0.base, m0[l]);
    case "label":
      return v($1.base, l ? $1[l] : $1.default);
    case "paragraph":
      return v(Q1.base, l ? Q1[l] : Q1.default);
    case "scripture":
      return v(x0.base, x0[l]);
    case "eyebrow":
      return v(y0.base, y0[l]);
    case "caption":
      return v(C0.base, C0[l]);
    case "buttonLabel":
      return v(k0.base, k0[l]);
    case "fieldLabel":
      return v(Z0.base, Z0[l]);
    case "fieldTextInput":
      return v(M0.base, M0[l]);
    default:
      return l;
  }
}, ae = {
  primary: "font-aktiv-grotesk",
  secondary: "font-untitled-serif"
}, j2 = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4"
}, E2 = ({ className: l, children: r, font: e = "primary", level: t = 1, size: a, variant: i, ...c }, f) => {
  const g = "text-text-light dark:text-text-dark", p = ae[e], b = ie({ size: a, variant: i });
  return /* @__PURE__ */ n(
    L,
    {
      className: v(g, b, p, l),
      component: j2[t],
      ref: f,
      ...c,
      children: r
    }
  );
}, M1 = o(E2);
M1.displayName = "Heading";
const T2 = ({ className: l, component: r = "p", children: e, font: t = "primary", size: a, variant: i, ...c }, f) => {
  const g = "text-text-light dark:text-text-dark", p = ae[t], b = ie({ size: a, variant: i });
  return /* @__PURE__ */ n(
    L,
    {
      className: v(g, b, p, l),
      component: r,
      ref: f,
      ...c,
      children: e
    }
  );
}, V = o(T2);
V.displayName = "Text";
const G2 = ({
  className: l,
  disabled: r,
  editable: e = !0,
  endIcon: t,
  error: a,
  hint: i,
  inputClassName: c,
  inputContainerClassName: f,
  label: g,
  name: p,
  onChange: b,
  placeholder: w,
  prefix: k,
  startIcon: m,
  suffix: I,
  value: x,
  ...z
}, y) => {
  const S = q(null), A = N1({ forwardedRef: y, innerRef: S }), [H, O] = _(!!x), [N, M] = _(!1);
  o1(() => {
    var P;
    O(!!((P = A == null ? void 0 : A.current) != null && P.value) || !!(x || w));
  }, [x, w, A]);
  const C = (P) => {
    var $;
    O(!!(($ = A == null ? void 0 : A.current) != null && $.value) || !!(x || w)), b && b(P);
  }, R = () => {
    r || !A.current || (A.current.focus(), M(!0));
  }, B = () => {
    M(!1);
  };
  return /* @__PURE__ */ d("div", { className: v(["flex items-start flex-col gap-0.5", l]), children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: v([
          "items-center self-stretch rounded-1 border-small border-solid cursor-text flex flex-row relative",
          f,
          r ? "bg-gray-10 dark:bg-gray-40" : null,
          a ? "border-alert dark:border-alert-dark" : "border-tertiary-light dark:border-tertiary-dark",
          e ? "focus-within:border-transparent focus-within:outline-2 focus-within:outline-info focus-within:outline focus-within:dark:border-transparent focus-within:dark:outline-info-dark" : "cursor-pointer outline-none focus-within:outline-none"
        ]),
        onClick: R,
        onFocus: R,
        children: [
          m ? /* @__PURE__ */ n("div", { className: "text-text-muted-light dark:text-text-muted-dark pis-1.5", children: m }) : null,
          /* @__PURE__ */ d("span", { className: "relative flex flex-1 overflow-hidden", children: [
            k && (N || H) ? /* @__PURE__ */ n(
              V,
              {
                className: v(
                  "text-text-muted-light dark:text-text-muted-dark select-none pointer-events-none",
                  m ? "pis-1 -mie-1" : "pis-2 -mie-2",
                  g ? "pbs-3 pbe-1" : "pbs-2 pbe-2"
                ),
                children: k
              }
            ) : null,
            /* @__PURE__ */ n(
              "input",
              {
                className: v([
                  "self-stretch bg-transparent flex-auto outline-none overflow-hidden h-[56px]",
                  m ? "pis-1" : "pis-2",
                  t ? "pie-1" : "pie-2",
                  g ? "pbs-3 pbe-1" : "plb-2",
                  e ? null : "cursor-pointer caret-transparent",
                  c
                ]),
                disabled: r,
                id: p,
                onBlur: B,
                onChange: C,
                placeholder: w,
                ref: A,
                value: x,
                ...z
              }
            ),
            I && (N || H) ? /* @__PURE__ */ n(
              V,
              {
                className: v(
                  "text-text-muted-light dark:text-text-muted-dark select-none pointer-events-none",
                  t ? "pie-1 -mis-1" : "pie-2 -mis-2",
                  g ? "pbs-3 pbe-1" : "plb-2"
                ),
                children: I
              }
            ) : null,
            g ? /* @__PURE__ */ n(
              "label",
              {
                className: v(
                  "items-center text-text-muted-light dark:text-text-muted-dark flex font-regular leading-loose pointer-events-none absolute block-start-2 select-none",
                  m ? "inline-start-1" : "inline-start-2",
                  N || H ? "text-13 -translate-y-1.5" : "text-16"
                ),
                htmlFor: p,
                children: g
              }
            ) : null
          ] }),
          t ? /* @__PURE__ */ n("div", { className: "text-text-muted-light dark:text-text-muted-dark pie-1.5", children: t }) : null
        ]
      }
    ),
    a || i ? /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
      a ? /* @__PURE__ */ n("span", { className: "text-alert dark:text-alert-dark", children: a }) : null,
      i ? /* @__PURE__ */ n("span", { className: "text-text-muted-light dark:text-text-muted-dark text-13 leading-default", children: i }) : null
    ] }) : null
  ] });
}, n0 = o(G2);
n0.displayName = "Input";
const W2 = ({ children: l, className: r, component: e, componentProps: t, disabled: a, divider: i, onClick: c, ...f }, g) => {
  const p = (b) => {
    c && (b.code === "Enter" || b.key === " ") && c();
  };
  return /* @__PURE__ */ n(
    "li",
    {
      className: v([
        "flex items-center box-border relative",
        i ? "after:last:content-none after:absolute after:inset-x-0 after:bottom-0 after:mx-2 after:bg-gray-10 after:dark:bg-gray-40 after:h-px" : null,
        r
      ]),
      ref: g,
      ...f,
      children: a1(e ?? "div", {
        children: l,
        ...t,
        className: v(
          "flex flex-1 py-2 gap-x-2 items-center pie-2 pis-2",
          // `href` only exists on some elements, so TS is throwing an error about `div` not having it.
          // But it needs to be checked.
          // @ts-expect-error
          c || t != null && t.href ? "cursor-pointer hover:bg-warm-neutral hover:dark:bg-warm-neutral-dark" : void 0,
          a ? "pointer-events-none" : "",
          t != null && t.className ? t.className : ""
        ),
        onClick: c,
        onKeyUp: p,
        onTouchEnd: c,
        tabIndex: c ? 0 : void 0
      })
    }
  );
}, z1 = o(W2);
z1.displayName = "ListItem";
var D2 = Object.defineProperty, U2 = Object.defineProperties, q2 = Object.getOwnPropertyDescriptors, O1 = Object.getOwnPropertySymbols, ne = Object.prototype.hasOwnProperty, de = Object.prototype.propertyIsEnumerable, z0 = (l, r, e) => r in l ? D2(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, _2 = (l, r) => {
  for (var e in r || (r = {}))
    ne.call(r, e) && z0(l, e, r[e]);
  if (O1)
    for (var e of O1(r))
      de.call(r, e) && z0(l, e, r[e]);
  return l;
}, X2 = (l, r) => U2(l, q2(r)), Y2 = (l, r) => {
  var e = {};
  for (var t in l)
    ne.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && O1)
    for (var t of O1(l))
      r.indexOf(t) < 0 && de.call(l, t) && (e[t] = l[t]);
  return e;
}, K2 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Y2(e, ["title", "titleId"]);
  return d("svg", X2(_2({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 4a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7.001 7.001 0 0 0-7-7 1 1 0 0 1-1-1Z", fill: "currentColor", children: n("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", from: "0 12 12", to: "360 12 12", dur: i.dur, repeatCount: "indefinite" }) })] }));
}, Q2 = o(K2), oe = Q2;
function A1({
  "aria-label": l = "Loading…",
  duration: r = 0.9,
  iconSize: e = "40px",
  className: t,
  color: a = "text-gray-15",
  height: i = "h-full",
  width: c = "w-full",
  iconProps: f = {},
  ...g
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      ...g,
      "aria-label": l,
      className: v(["items-center flex justify-center", a, i, c, t]),
      children: /* @__PURE__ */ n(oe, { ...f, dur: `${r}s`, height: e, width: e })
    }
  );
}
const J2 = ({
  isLoading: l = !1,
  label: r,
  name: e,
  options: t,
  disabled: a = !1,
  error: i,
  hint: c,
  noOptionsText: f,
  onChange: g,
  onSelect: p,
  value: b,
  ...w
}, k) => {
  const m = q(null), I = q(null), [x, z] = _(b), [y, S] = _(!1);
  U0(
    k,
    () => ({
      clearSelection() {
        z(null), g("");
      },
      ...m.current
    }),
    [g]
  );
  const A = (M) => {
    y || S(!0), !M.length && x && z(null), g(M);
  }, H = (M) => {
    p(M), g(M.label), z(M.label), S(!1);
  }, O = X1(
    (M) => {
      I.current && !I.current.contains(M.target) && (!x && b && g(""), x && b && g(x), S(!1));
    },
    [g, x, b]
  ), N = Q(() => t.filter((M) => M.label.toLowerCase().includes(b.toLowerCase())) ?? [], [t, b]);
  return o1(() => (document.addEventListener("click", O, !0), () => {
    document.removeEventListener("click", O, !0);
  }), [O]), /* @__PURE__ */ d(L, { className: "relative", ref: I, children: [
    l ? /* @__PURE__ */ n(A1, { className: "absolute z-1" }) : null,
    /* @__PURE__ */ n(
      n0,
      {
        "aria-controls": `${e ?? r}-options`,
        "aria-expanded": y,
        disabled: a || l,
        endIcon: /* @__PURE__ */ n(Y1, { size: "24" }),
        error: i,
        hint: c,
        label: r,
        name: e ?? r,
        onChange: (M) => {
          A(M.target.value);
        },
        onFocus: () => S(!0),
        ref: m,
        role: "combobox",
        value: b ?? "",
        ...w
      }
    ),
    y ? /* @__PURE__ */ n(L, { className: "absolute top-[calc(100%+1px)] w-full z-50", children: /* @__PURE__ */ n(
      L,
      {
        className: "max-h-[300px] overflow-y-auto bg-canvas-light dark:bg-canvas-secondary-dark rounded-1 py-0.5",
        id: `${e ?? r}-options`,
        role: "listbox",
        children: N.length ? N.map((M, C) => /* @__PURE__ */ n(
          "div",
          {
            "aria-selected": x !== M.value,
            className: "p-2 cursor-pointer hover:bg-gray-10 hover:dark:bg-gray-50",
            id: `${M.value}-${C}`,
            onClick: () => H(M),
            role: "option",
            children: M.label
          },
          `${M.value}-${C}`
        )) : /* @__PURE__ */ n(z1, { children: f }, "no-options")
      }
    ) }) : null
  ] });
}, el = o(J2);
el.displayName = "AutocompleteSelect";
var ll = Object.defineProperty, tl = Object.defineProperties, rl = Object.getOwnPropertyDescriptors, F1 = Object.getOwnPropertySymbols, ce = Object.prototype.hasOwnProperty, se = Object.prototype.propertyIsEnumerable, R0 = (l, r, e) => r in l ? ll(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, s = (l, r) => {
  for (var e in r || (r = {}))
    ce.call(r, e) && R0(l, e, r[e]);
  if (F1)
    for (var e of F1(r))
      se.call(r, e) && R0(l, e, r[e]);
  return l;
}, h = (l, r) => tl(l, rl(r)), u = (l, r) => {
  var e = {};
  for (var t in l)
    ce.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && F1)
    for (var t of F1(l))
      r.indexOf(t) < 0 && se.call(l, t) && (e[t] = l[t]);
  return e;
}, il = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.41 19.107c.643 0 1-.33 1.25-1.17l.679-2.07h4.275l.688 2.07c.24.83.616 1.17 1.267 1.17.688 0 1.143-.41 1.143-1.053 0-.25-.063-.545-.188-.928l-3.07-8.802c-.384-1.143-.92-1.607-1.928-1.607-1.018 0-1.563.473-1.946 1.607l-3.071 8.801c-.152.456-.214.732-.214.973 0 .607.455 1.01 1.116 1.01Zm2.464-5.034 1.553-4.928h.116l1.545 4.928h-3.214ZM3.564 18.076c.611 0 .937-.312 1.167-1.117l.367-1.132h3.187l.361 1.132c.23.784.583 1.117 1.194 1.117.66 0 1.09-.388 1.09-.992 0-.243-.062-.521-.187-.91l-2.09-6.144c-.382-1.132-.91-1.576-1.91-1.576-.999 0-1.54.451-1.915 1.576L2.73 16.174c-.16.465-.222.729-.222.958 0 .556.43.944 1.055.944Zm2.007-3.908 1.076-3.59h.11l1.063 3.59H5.57Z", fill: "currentColor" })] }));
}, al = o(il), nl = al, dl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5 11h2v6H5v-6ZM17 11h2v6h-2v-6ZM13 11h2v6h-2v-6ZM9 11h2v6H9v-6ZM4 18a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.94 4.483a2 2 0 0 1 2.12 0l6.73 4.207c1.066.666.594 2.31-.662 2.31H4.872c-1.256 0-1.728-1.644-.663-2.31l6.73-4.207ZM7.487 9h9.026L12 6.18 7.487 9Z", fill: "currentColor" })] }));
}, ol = o(dl), cl = ol, sl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v8.438a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8Z", fill: "#14457C" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.643 12.313a4.317 4.317 0 0 1-4.321 4.312A4.317 4.317 0 0 1 5 12.313 4.317 4.317 0 0 1 9.322 8a4.317 4.317 0 0 1 4.321 4.313Z", fill: "#D82332" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.39 12.313a4.317 4.317 0 0 1-4.322 4.312 4.317 4.317 0 0 1-4.322-4.312A4.317 4.317 0 0 1 15.068 8a4.317 4.317 0 0 1 4.322 4.313Z", fill: "#E69906" }), n("path", { d: "M12.195 15.469a4.298 4.298 0 0 0 1.448-3.222c0-1.28-.56-2.432-1.448-3.221a4.298 4.298 0 0 0-1.449 3.221c0 1.281.56 2.432 1.449 3.222Z", fill: "#DE6635" })] }));
}, hl = o(sl), ul = hl, vl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.402 8.931c-.298-.09-.5-.335-.505-.614V8.814c-.018-.34.222-.65.587-.759.389-.132.83-.02 1.08.272a.639.639 0 0 1 .16.432v1.74c0 .564-.013 1.128 0 1.693a.765.765 0 0 1-.325.624.998.998 0 0 1-.755.172 1.389 1.389 0 0 1-.242-.057Zm.383 3.032a.982.982 0 1 1 .008 0h-.008Z", fill: "currentColor" })] }));
}, fl = o(vl), gl = fl, pl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M18 18H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.121 10.813a1 1 0 0 0-1.414 1.414l3.48 3.48a1 1 0 0 0 1.414 0l3.52-3.52a1 1 0 0 0-1.414-1.414l-2.813 2.813-2.773-2.773Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.828 14.908V5a1 1 0 1 0-2 0v9.908c0 .05.042.092.093.092h1.815a.092.092 0 0 0 .092-.092Z", fill: "currentColor" })] }));
}, wl = o(pl), bl = wl, ml = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5.74 11.293a1 1 0 0 0-1.415 1.414l6.647 6.646a1.5 1.5 0 0 0 2.121 0l6.647-6.646a1 1 0 0 0-1.415-1.414l-4.898 4.899a.25.25 0 0 1-.427-.177V5a1 1 0 1 0-2 0v10.95a.25.25 0 0 1-.427.177L5.74 11.293Z", fill: "currentColor" })] }));
}, xl = o(ml), yl = xl, Cl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.707 5.74a1 1 0 1 0-1.414-1.415l-6.647 6.647a1.5 1.5 0 0 0 0 2.121l6.647 6.647a1 1 0 0 0 1.414-1.415l-4.899-4.898A.25.25 0 0 1 7.985 13H19a1 1 0 1 0 0-2H8.05a.25.25 0 0 1-.177-.427l4.834-4.833Z", fill: "currentColor" })] }));
}, kl = o(Cl), Zl = kl, Ml = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11.293 18.26a1 1 0 0 0 1.414 1.415l6.647-6.647a1.5 1.5 0 0 0 0-2.121L12.707 4.26a1 1 0 1 0-1.414 1.415l4.899 4.898a.25.25 0 0 1-.177.427H5a1 1 0 0 0 0 2h10.95a.25.25 0 0 1 .177.427l-4.834 4.833Z", fill: "currentColor" })] }));
}, zl = o(Ml), Rl = zl, Il = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M16.41 19.846c.48-.27.58-.902.258-1.35-.322-.448-.945-.544-1.435-.29-4.796 2.5-10.668-1.42-10.206-6.804l1.06.332a.501.501 0 0 0 .635-.588l-.86-3.934a.495.495 0 0 0-.822-.259l-2.96 2.74a.501.501 0 0 0 .185.845l.816.255C2.106 18 10.068 23.41 16.41 19.846ZM18.616 16.599 17.6 12.725a.501.501 0 0 1 .618-.607l.773.21c.25-5.33-5.63-9.025-10.325-6.481-.485.263-1.11.177-1.44-.266-.329-.443-.24-1.076.238-1.354C13.67.605 21.645 5.714 20.959 12.861l1.152.312c.372.1.492.564.217.833l-2.876 2.819a.501.501 0 0 1-.836-.226Z", fill: "currentColor" })] }));
}, Sl = o(Il), Bl = Sl, Nl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M18.26 12.707a1 1 0 1 0 1.415-1.414l-6.647-6.647a1.5 1.5 0 0 0-2.121 0L4.26 11.293a1 1 0 1 0 1.415 1.414l4.898-4.898a.25.25 0 0 1 .427.176V19a1 1 0 1 0 2 0V8.05a.25.25 0 0 1 .427-.177l4.833 4.834Z", fill: "currentColor" })] }));
}, Al = o(Nl), Hl = Al, Vl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 10H5a1 1 0 1 0 0 2h5.5a1.5 1.5 0 0 0 1.5-1.5V5a1 1 0 1 0-2 0v5ZM14 14h5a1 1 0 1 0 0-2h-5.5a1.5 1.5 0 0 0-1.5 1.5V19a1 1 0 1 0 2 0v-5Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.293 4.293a1 1 0 0 1 1.414 0l5.5 5.5-1.414 1.414-5.5-5.5a1 1 0 0 1 0-1.414Zm6.914 6.914a1 1 0 0 1-1.414 0l1.414-1.414a1 1 0 0 1 0 1.414Zm1.586 1.586a1 1 0 0 1 1.414 0l5.5 5.5a1 1 0 0 1-1.414 1.414l-5.5-5.5a1 1 0 0 1 0-1.414Z", fill: "currentColor" })] }));
}, $l = o(Vl), Ll = $l, Ol = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11.207 9.793 7.414 6H11a1 1 0 1 0 0-2H5.5A1.5 1.5 0 0 0 4 5.5V11a1 1 0 1 0 2 0V7.414l3.793 3.793a1 1 0 0 0 1.414-1.414ZM16.586 18H13a1 1 0 1 0 0 2h5.5a1.5 1.5 0 0 0 1.5-1.5V13a1 1 0 1 0-2 0v3.586l-3.793-3.793a1 1 0 0 0-1.414 1.414L16.586 18Z", fill: "currentColor" })] }));
}, Fl = o(Ol), Pl = Fl, jl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "m15.536 9.05-3.182-3.182a.5.5 0 0 0-.708 0L8.464 9.05A1 1 0 0 1 7.05 7.636l3.89-3.889a1.5 1.5 0 0 1 2.12 0l3.89 3.889a1 1 0 0 1-1.414 1.414ZM8.464 14.95l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 0 1 1.414 1.414l-3.89 3.889a1.5 1.5 0 0 1-2.12 0l-3.89-3.89a1 1 0 1 1 1.414-1.413Z", fill: "currentColor" })] }));
}, El = o(jl), Tl = El, Gl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.55 6.51a.5.5 0 0 0-.794-.405l-7.594 5.49a.5.5 0 0 0 0 .81l7.594 5.49a.5.5 0 0 0 .793-.405V12.35c.02.02.04.038.064.054l7.594 5.49A.5.5 0 0 0 20 17.49V6.51a.5.5 0 0 0-.793-.405l-7.594 5.49a.507.507 0 0 0-.064.054V6.51Z", fill: "currentColor" })] }));
}, Wl = o(Gl), Dl = Wl, Ul = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11 19c-.485 0-.728 0-.874.237-.147.238-.065.401.1.728.238.476.666.843 1.287.843h.974c.621 0 1.05-.367 1.288-.843.164-.327.246-.49.1-.728C13.727 19 13.484 19 13 19h-2Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m18.665 13.467.675.685.009.01c.366.38.992 1.329.508 2.486-.484 1.157-1.6 1.377-2.128 1.383H6.292c-.53-.006-1.647-.229-2.13-1.388-.482-1.16.148-2.108.518-2.49l.008-.008.69-.694c.392-.393.9-1.144.97-2.614.135-2.766.811-4.737 2.226-5.879 1.28-1.033 2.778-1.001 3.329-.99l.12.002c.033 0 .074 0 .121-.002.551-.011 2.049-.043 3.33.99 1.415 1.143 2.092 3.114 2.226 5.882.071 1.482.58 2.236.965 2.627Zm-2.994-2.529c-.24-4.958-2.302-4.945-3.513-4.937a21.516 21.516 0 0 1-.269 0c-1.21-.008-3.27-.02-3.511 4.934-.064 1.316-.404 2.3-.847 3.034a4.965 4.965 0 0 1-.712.915l-.682.685c-.206.213-.117.427.18.431h11.388c.296-.004.385-.217.18-.43l-.667-.677a4.744 4.744 0 0 1-.711-.924c-.437-.733-.773-1.717-.836-3.03Z", fill: "currentColor" })] }));
}, ql = o(Ul), _l = ql, Xl = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.761 20.239c1.023 1.023 2.283 1.42 3.594 1.597C8.576 22 10.1 22 11.867 22h.266c1.766 0 3.29 0 4.512-.164 1.31-.176 2.571-.574 3.594-1.597 1.023-1.023 1.42-2.283 1.597-3.594C22 15.424 22 13.9 22 12.133v-.266c0-1.766 0-3.29-.164-4.512-.176-1.31-.574-2.571-1.597-3.594-1.023-1.023-2.283-1.42-3.594-1.597C15.424 2 13.9 2 12.133 2h-.266c-1.766 0-3.29 0-4.512.164-1.31.176-2.571.574-3.594 1.597-1.023 1.023-1.42 2.283-1.597 3.594C2 8.576 2 10.1 2 11.867v.266c0 1.766 0 3.29.164 4.512.176 1.31.574 2.571 1.597 3.594Zm11.25-1.262H7.378c-2.439 0-3.304-3.237-1.053-3.242h9.256c1.27.001 2.86.004 3.739-1.523-.007.156-.011.318-.016.483-.032 1.143-.069 2.443-.773 3.257-.884 1.032-1.837 1.03-3.258 1.026h-.264Z", fill: "currentColor" })] }));
}, Yl = o(Xl), Kl = Yl, Ql = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 2.969h2.125c1.307 0 2.484 0 3.438.128 1.042.14 2.115.466 2.995 1.345.88.88 1.205 1.953 1.345 2.996.129.953.128 2.13.128 3.437v2.25c0 1.307 0 2.484-.128 3.438-.14 1.042-.466 2.115-1.345 2.995-.88.88-1.953 1.205-2.995 1.345-.954.129-2.131.128-3.438.128h-2.25c-1.307 0-2.484 0-3.437-.128-1.043-.14-2.116-.466-2.996-1.345-.88-.88-1.205-1.953-1.345-2.995-.128-.954-.128-2.131-.128-3.438v-2.25c0-1.307 0-2.484.128-3.437.14-1.043.466-2.116 1.345-2.996.88-.88 1.953-1.205 2.996-1.345.953-.128 2.13-.128 3.437-.128H11Zm-5.121 2.91C5 6.757 5 8.172 5 11v2c0 2.828 0 4.243.879 5.121C6.757 19 8.172 19 11 19h2c2.828 0 4.243 0 5.121-.879C19 17.243 19 15.828 19 13v-2c0-2.828 0-4.243-.879-5.121C17.243 5 15.828 5 13 5h-2c-2.828 0-4.243 0-5.121.879Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.314 17.5h5.87c1.207 0 1.988.057 2.71-.861.62-.782.567-2.097.606-3.139-.699 1.323-1.981 1.278-2.972 1.278H7.503c-1.732.004-1.066 2.721.81 2.721Z", fill: "currentColor" })] }));
}, Jl = o(Ql), et = Jl, lt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.344 21.836c-1.31-.177-2.567-.574-3.587-1.593-1.019-1.02-1.416-2.276-1.593-3.587C2 15.432 2 13.905 2 12.132v-.264c0-1.773 0-3.3.164-4.524.177-1.31.574-2.567 1.593-3.587 1.02-1.019 2.276-1.416 3.587-1.593C8.568 2 10.095 2 11.868 2h.264c1.773 0 3.3 0 4.524.164 1.31.177 2.567.574 3.587 1.593 1.019 1.02 1.416 2.276 1.593 3.587C22 8.568 22 10.095 22 11.868v.264c0 1.773 0 3.3-.164 4.524-.177 1.31-.574 2.567-1.593 3.587-1.02 1.019-2.276 1.416-3.587 1.593-1.224.164-2.751.164-4.524.164h-.264c-1.773 0-3.3 0-4.524-.164ZM5.172 5.172C4 6.343 4 8.229 4 12c0 3.771 0 5.657 1.172 6.828C6.343 20 8.229 20 12 20c3.771 0 5.657 0 6.828-1.172C20 17.657 20 15.771 20 12c0-3.771 0-5.657-1.172-6.828C17.657 4 15.771 4 12 4 8.229 4 6.343 4 5.172 5.172Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.978 18h6.404c1.317 0 2.169.057 2.956-.861.676-.782.62-2.097.662-3.139-.762 1.323-2.161 1.278-3.242 1.278H7.095c-1.89.004-1.163 2.721.883 2.721Z", fill: "currentColor" })] }));
}, tt = o(lt), rt = tt, it = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m9.377 16.656.04-.01.662-.168-.241 3.455c-.016.228-.036.507-.034.729.001.101.005.363.081.654.047.176.356 1.255 1.572 1.509 1.215.254 1.93-.611 2.044-.754a2.65 2.65 0 0 0 .336-.568c.09-.202.184-.465.26-.68l3.505-9.844.012-.035c.048-.132.145-.404.196-.662.061-.308.168-1.134-.447-1.885-.616-.75-1.446-.808-1.76-.809-.263 0-.55.042-.688.063l-.037.005-.611.09v-3.62c0-.177 0-.433-.02-.644-.009-.1-.036-.375-.155-.68-.116-.294-.532-1.107-1.568-1.287-1.036-.179-1.701.447-1.91.685a2.469 2.469 0 0 0-.375.588c-.09.192-.175.433-.235.6l-3.567 9.984-.014.04c-.054.149-.157.434-.21.7-.058.295-.191 1.203.52 1.984.71.781 1.628.734 1.926.703.27-.027.564-.103.718-.143Zm6.439-6.99c-.091-.112-.277-.085-.65-.03l-2.319.337c-.27.039-.405.059-.492-.017-.088-.076-.088-.213-.088-.486V4.172c0-.447 0-.671-.085-.686-.084-.015-.16.196-.31.618l-3.551 9.94c-.141.396-.212.593-.11.706.103.113.307.061.713-.042l2.662-.678c.31-.079.466-.118.566-.035.042.036.065.085.075.156.013.094.003.224-.01.407l-.38 5.463c-.039.552-.058.828.029.846.086.018.179-.242.364-.764l3.487-9.795c.127-.354.19-.532.099-.643Z", fill: "currentColor" })] }));
}, at = o(it), nt = at, dt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10.094c0-2.873 0-4.31.892-5.202C5.785 4 7.222 4 10.094 4h3.812c2.873 0 4.31 0 5.202.892.892.893.892 2.33.892 5.202v6.612c0 1.476 0 2.214-.483 2.512-.482.297-1.142-.034-2.46-.697l-4.11-2.065c-.445-.224-.667-.336-.907-.336s-.463.11-.91.332L6.937 18.54c-1.316.655-1.974.983-2.455.685C4 18.926 4 18.19 4 16.72v-6.627Z", fill: "currentColor" })] }));
}, ot = o(dt), ct = ot, st = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.906 6.031h-3.812c-1.494 0-2.41.005-3.073.094-.582.078-.68.19-.691.203h-.001l-.001.002c-.014.011-.125.109-.203.691-.09.663-.094 1.579-.094 3.073v6.627l4.195-2.087.085-.043c.314-.162.978-.504 1.733-.502.755.001 1.418.346 1.73.508l.086.044 4.109 2.065v-6.612c0-1.494-.005-2.41-.094-3.073-.078-.582-.19-.68-.203-.691v-.001l-.002-.001c-.011-.014-.109-.125-.691-.203-.663-.09-1.579-.094-3.073-.094ZM4.892 4.892C4 5.785 4 7.222 4 10.094v6.627c0 1.47 0 2.205.48 2.503.482.298 1.14-.03 2.456-.685l4.195-2.087c.446-.222.67-.333.909-.332.24 0 .462.112.908.336l4.109 2.065c1.319.663 1.978.994 2.46.697.483-.298.483-1.036.483-2.512v-6.612c0-2.873 0-4.31-.892-5.202C18.215 4 16.778 4 13.906 4h-3.812c-2.873 0-4.31 0-5.202.892Z", fill: "currentColor" })] }));
}, ht = o(st), ut = ht, vt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.996 4H9.88c-1.302 0-2.475 0-3.426.128-1.038.14-2.108.464-2.984 1.34-.877.877-1.202 1.947-1.341 2.985C2 9.403 2 10.577 2 11.88v.242c0 1.302 0 2.475.128 3.426.14 1.038.464 2.108 1.34 2.985.877.876 1.947 1.2 2.985 1.34C7.403 20 8.577 20 9.88 20h4.242c1.302 0 2.475 0 3.426-.128 1.038-.14 2.108-.464 2.985-1.34.876-.877 1.2-1.947 1.34-2.985.128-.95.128-2.124.128-3.426v-.242c0-1.302 0-2.475-.128-3.426-.14-1.038-.464-2.108-1.34-2.984-.877-.877-1.947-1.202-2.985-1.341C16.597 4 15.423 4 14.12 4h-.125Zm3.297 7.187a1 1 0 0 0 1.414-1.414l-2.48-2.48a1 1 0 0 0-1.414 0l-2.52 2.52a1 1 0 0 0 1.414 1.414l.879-.879V14a1 1 0 0 0 2 0v-3.52l.707.707ZM7.207 12.813a1 1 0 1 0-1.414 1.414l2.48 2.48a1 1 0 0 0 1.414 0l2.52-2.52a1 1 0 0 0-1.414-1.414l-.879.879V10a1 1 0 0 0-2 0v3.52l-.707-.707Z", fill: "currentColor" })] }));
}, ft = o(vt), gt = ft, pt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5.793 12.813a1 1 0 0 1 1.414 0l.707.707V10a1 1 0 1 1 2 0v3.652l.879-.879a1 1 0 0 1 1.414 1.414l-2.52 2.52a1 1 0 0 1-1.414 0l-2.48-2.48a1 1 0 0 1 0-1.414ZM17.293 11.187a1 1 0 0 0 1.414-1.414l-2.48-2.48a1 1 0 0 0-1.414 0l-2.52 2.52a1 1 0 0 0 1.414 1.414l.879-.879V14a1 1 0 0 0 2 0v-3.52l.707.707Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.88 4h4.24c1.303 0 2.476 0 3.427.128 1.038.14 2.108.464 2.985 1.34.876.877 1.2 1.947 1.34 2.985.128.95.128 2.124.128 3.426v.242c0 1.302 0 2.476-.128 3.426-.14 1.038-.464 2.108-1.34 2.985-.877.876-1.947 1.2-2.985 1.34-.95.128-2.124.128-3.426.128H9.879c-1.302 0-2.475 0-3.426-.128-1.038-.14-2.108-.464-2.984-1.34-.877-.877-1.202-1.947-1.341-2.985C2 14.597 2 13.423 2 12.12v-.242c0-1.302 0-2.475.128-3.426.14-1.038.464-2.108 1.34-2.984.877-.877 1.947-1.202 2.985-1.341C7.403 4 8.577 4 9.88 4ZM4.9 6.9c-.876.876-.876 2.285-.876 5.104v-.008c0 2.82 0 4.228.876 5.104.876.876 2.285.876 5.104.876h3.992c2.82 0 4.228 0 5.104-.876.876-.876.876-2.285.876-5.104v.008c0-2.82 0-4.228-.876-5.104-.876-.876-2.285-.876-5.104-.876h-3.992c-2.82 0-4.228 0-5.104.876Z", fill: "currentColor" })] }));
}, wt = o(pt), bt = wt, mt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9.25 13a1 1 0 0 1 1-1h3.5a1 1 0 1 1 0 2h-3.5a1 1 0 0 1-1-1Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.318 4h9.428c.325 0 .714 0 1.053.037.4.044.963.16 1.499.561a3 3 0 0 1 .604.604c.4.536.517 1.1.56 1.5.038.338.038.727.038 1.052v.158c-.002.039-.004.119-.015.216a2.098 2.098 0 0 1-.826 1.453A2.099 2.099 0 0 1 18.41 10l-.09.001H5.589c-.039-.002-.12-.004-.216-.015a2.098 2.098 0 0 1-1.453-.827A2.098 2.098 0 0 1 3.5 7.911l-.001-.09v-.067c0-.325 0-.714.037-1.053.044-.4.16-.963.561-1.499a3 3 0 0 1 .604-.604c.536-.4 1.1-.517 1.5-.56A9.96 9.96 0 0 1 7.253 4h.064Zm10.537 2.078C17.6 6 17.244 6 16.682 6H7.318c-.562 0-.918 0-1.173.078a.782.782 0 0 0-.244.121 1 1 0 0 0-.22.226c-.181.266-.181.65-.181 1.393 0 .077 0 .115.02.142a.1.1 0 0 0 .02.02c.027.02.065.02.142.02h12.636c.077 0 .115 0 .142-.02a.1.1 0 0 0 .02-.02c.02-.027.02-.065.02-.142 0-.744 0-1.127-.182-1.393A1 1 0 0 0 18.1 6.2a.783.783 0 0 0-.244-.12Zm-.49 1.936h-.002.002Zm-10.73 0h.002-.002Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 8h15v8.079c0 .4 0 .875-.055 1.285-.066.494-.244 1.177-.824 1.757-.58.58-1.263.758-1.757.825-.41.055-.886.054-1.285.054H8.42c-.4 0-.875 0-1.285-.054-.494-.067-1.177-.245-1.757-.825-.58-.58-.758-1.263-.825-1.757-.055-.41-.054-.886-.054-1.285V8Zm2 2v6c0 .943 0 1.414.293 1.707C7.086 18 7.557 18 8.5 18h7c.943 0 1.414 0 1.707-.293.293-.293.293-.764.293-1.707v-6h-11Z", fill: "currentColor" })] }));
}, xt = o(mt), yt = xt, Ct = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M17 11a1 1 0 0 0 2 0V6c0-.552-.447-1-.997-1H13a1.001 1.001 0 0 0 0 2h2.688l-5.396 5.41c-.39.391-.39 1.024 0 1.415.39.39 1.021.39 1.41 0l5.286-5.3L17 11Z", fill: "currentColor" }), n("path", { d: "M5 7a2 2 0 0 1 2-2h1.992C9.55 5 10 5.451 10 6.008A.992.992 0 0 1 9.008 7H7.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V15a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7Z", fill: "currentColor" })] }));
}, kt = o(Ct), Zt = kt, Mt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.707 9.187a1 1 0 0 0 1.414-1.414l-3.48-3.48a1 1 0 0 0-1.414 0l-3.52 3.52a1 1 0 1 0 1.414 1.414L11 7.348V15a1 1 0 1 0 2 0V7.48l1.707 1.707ZM5 13a1 1 0 0 1 2 0v4.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V13a1 1 0 0 1 2 0v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5Z", fill: "currentColor" })] }));
}, zt = o(Mt), Rt = zt, It = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, d("g", { fill: "currentColor", children: [n("path", { clipRule: "evenodd", d: "M16 4.531h-3c-1.472 0-2.371.005-3.021.092-.301.04-.466.09-.554.126-.072.03-.095.05-.11.066s-.036.038-.066.11a2.313 2.313 0 0 0-.126.554c-.087.65-.092 1.55-.092 3.021v3c0 1.472.005 2.371.092 3.021.04.301.09.466.126.554.03.072.05.095.066.11s.038.036.11.066c.088.036.253.086.554.126.65.087 1.55.092 3.021.092h3c1.472 0 2.371-.005 3.021-.092.301-.04.466-.09.554-.126.072-.03.095-.05.11-.066s.036-.038.066-.11c.036-.088.085-.253.126-.554.087-.65.092-1.55.092-3.021v-3c0-1.472-.005-2.371-.092-3.021a2.313 2.313 0 0 0-.126-.554c-.03-.072-.05-.095-.066-.11s-.038-.036-.11-.066a2.313 2.313 0 0 0-.554-.126c-.65-.087-1.55-.092-3.021-.092zM7.879 3.38C7 4.257 7 5.672 7 8.5v3c0 2.828 0 4.243.879 5.121s2.293.879 5.121.879h3c2.828 0 4.243 0 5.121-.879S22 14.328 22 11.5v-3c0-2.828 0-4.243-.879-5.121S18.828 2.5 16 2.5h-3c-2.828 0-4.243 0-5.121.879z", fillRule: "evenodd" }), n("path", { d: "M5 5.5v10a4 4 0 0 0 4 4h10c0 1-.887 2-2 2H9a6 6 0 0 1-6-6v-8c0-1 1-2 2-2z" })] })] }));
}, St = o(It), Bt = St, Nt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.485 17.237c.21.02.313.274.176.435l-1.784 2.086c-.32.375.025.908.491.747C13.855 19.3 22 15.92 22 10.637 22 6.972 17.523 4 12 4S2 6.972 2 10.637c0 5.363 7.438 6.413 9.485 6.6Z", fill: "currentColor" })] }));
}, At = o(Nt), Ht = At, Vt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.848 15.33-.043-.008c-1.976-.38-4.65-1.468-4.65-4.57C4.154 7.85 7.666 5.5 12 5.5s7.846 2.351 7.846 5.251c0 3.613-4.776 6.101-7.838 7.325a30.004 30.004 0 0 1-1.353.505c-.486.168-.728.252-.861.112s-.035-.384.161-.872l.811-2.015c.051-.127.077-.19.048-.234-.028-.044-.098-.046-.237-.05a11.612 11.612 0 0 1-1.73-.19Zm-.802 1.876a5.28 5.28 0 0 0-.243.728c-.078.337-.24 1.316.542 2.137.77.81 1.741.713 2.097.65.303-.053.63-.168.818-.233l.049-.017c1.409-.488 3.895-1.458 6.067-2.914 2.059-1.38 4.47-3.626 4.47-6.806 0-2.323-1.407-4.185-3.186-5.375C16.87 4.176 14.508 3.5 12 3.5s-4.869.677-6.66 1.876c-1.779 1.19-3.186 3.052-3.186 5.375 0 1.503.46 2.769 1.24 3.775.756.976 1.738 1.61 2.658 2.026.671.303 1.358.511 1.994.654Z", fill: "currentColor" })] }));
}, $t = o(Vt), Lt = $t, Ot = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15.152 2.972.066-.06.009-.008a2.285 2.285 0 0 1 2.446-.391 2.285 2.285 0 0 1 1.358 2.072v12.824a2.285 2.285 0 0 1-1.366 2.075 2.285 2.285 0 0 1-2.45-.406l-.01-.008-.066-.062c-.783-.723-2.54-2.066-4.865-2.322l.962 2.404a1.393 1.393 0 1 1-2.586 1.035l-1.54-3.852c-1.377-.354-2.43-.953-3.152-1.847-1.033-1.28-1.001-2.778-.99-3.329l.002-.101v-.007a1.802 1.802 0 0 0-.002-.133c-.011-.551-.043-2.049.99-3.33C5.102 6.111 7.073 5.434 9.84 5.3c2.55-.123 4.485-1.575 5.312-2.328ZM17 17.385a.248.248 0 0 1-.424.186l-.059-.054a9.948 9.948 0 0 0-.145-.132l-.008-.007a11.761 11.761 0 0 0-1.396-1.062c-1.222-.796-2.947-1.593-5.033-1.694-4.955-.24-4.942-2.3-4.934-3.511a21.58 21.58 0 0 0 0-.269c-.008-1.21-.02-3.273 4.937-3.513 2.084-.1 3.808-.887 5.03-1.67a11.627 11.627 0 0 0 1.393-1.044l.008-.007.15-.134.058-.053a.248.248 0 0 1 .423.187v12.777Z", fill: "currentColor" }), n("path", { d: "M19.843 12.54c0 .276.227.503.492.426.682-.197 1.315-.77 1.315-1.44v-.604c0-.67-.633-1.243-1.314-1.44-.266-.077-.493.15-.493.427v2.63Z", fill: "currentColor" })] }));
}, Ft = o(Ot), Pt = Ft, jt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 6.5a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-11Zm1.75 2a.25.25 0 0 1 .25-.25h15a.25.25 0 0 1 .25.25v9a.25.25 0 0 1-.25.25h-15a.25.25 0 0 1-.25-.25v-9ZM10 10a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h.5a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1H10Zm2.5 1a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11Zm3.5 0a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1V11Zm-3.5 3.5a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1v-.5Zm-2.5-1a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h.5a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H10Zm-4.5 1a1 1 0 0 1 1-1H7a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1v-.5Z", fill: "currentColor" })] }));
}, Et = o(jt), Tt = Et, Gt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.6 0a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.82 6a.25.25 0 0 0 .237-.17l.715-2.146A1 1 0 0 1 7.721 3h8.558a1 1 0 0 1 .949.684l.715 2.145A.25.25 0 0 0 18.18 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h.82Zm.9 2a1 1 0 0 0 .95-.684l.544-1.632A1 1 0 0 1 9.162 5h5.676a1 1 0 0 1 .948.684l.545 1.632a1 1 0 0 0 .948.684H18.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h1.22Z", fill: "currentColor" })] }));
}, Wt = o(Gt), Dt = Wt, Ut = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8Z", fill: "#2E77BC" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m4.636 10.647-.35-.856-.346.856h.696Zm7.69-.341c-.07.043-.152.044-.252.044h-.62v-.477h.629a.52.52 0 0 1 .242.039c.066.031.107.098.107.19 0 .093-.04.169-.105.204Zm4.42.34-.352-.855-.351.856h.704Zm-8.239.927h-.523l-.002-1.682-.74 1.682h-.447L6.053 9.89v1.683H5.016l-.196-.479H3.758l-.198.48h-.554l.913-2.148h.758l.868 2.033V9.426h.832l.668 1.457.613-1.457h.85v2.147Zm2.084 0H8.887V9.426h1.704v.447H9.397v.387h1.165v.44H9.398v.429h1.194v.444Zm2.402-1.569c0 .343-.226.52-.359.572a.592.592 0 0 1 .252.181c.072.107.085.203.085.394v.422h-.515l-.002-.27c0-.13.013-.316-.08-.419-.075-.076-.188-.092-.372-.092h-.547v.781h-.51V9.426h1.173c.26 0 .453.007.617.103.162.096.258.236.258.475Zm.296-.578h.52v2.147h-.52V9.426Zm6.559 2.147h-.723l-.967-1.612v1.612h-1.039l-.198-.479h-1.06l-.192.48h-.597c-.248 0-.562-.056-.74-.238-.18-.183-.272-.43-.272-.82 0-.319.055-.61.275-.84.164-.171.423-.25.774-.25h.494v.46h-.483c-.187 0-.292.028-.393.127-.087.09-.147.261-.147.486 0 .23.046.396.14.505.08.085.222.11.356.11h.23l.718-1.688h.764l.864 2.03v-2.03h.776l.897 1.495V9.426h.523v2.147ZM3 11.995h.872l.196-.477h.44l.196.477h1.715v-.365l.153.366h.89l.153-.371v.37h4.261l-.002-.783h.083c.057.002.074.007.074.103v.68h2.204v-.182c.178.095.455.182.818.182h.928l.198-.477h.44l.194.477H18.6v-.453l.27.453h1.432V9h-1.417v.354L18.687 9h-1.454v.354L17.05 9h-1.964c-.328 0-.617.046-.85.175V9H12.88v.175C12.73 9.042 12.529 9 12.304 9H7.352l-.332.774L6.679 9h-1.56v.354L4.948 9h-1.33L3 10.424v1.57ZM21 13.524h-.93c-.093 0-.154.003-.206.039-.054.034-.075.086-.075.154 0 .081.046.136.112.16a.576.576 0 0 0 .196.024l.277.008c.279.007.465.055.579.173.02.016.033.035.047.053v-.611Zm0 1.416c-.124.182-.365.275-.692.275h-.985v-.46h.98c.098 0 .166-.014.207-.054a.19.19 0 0 0 .06-.14.177.177 0 0 0-.062-.142c-.037-.033-.09-.048-.18-.048-.478-.016-1.076.015-1.076-.665 0-.311.197-.64.732-.64H21v-.427h-.944c-.285 0-.492.07-.638.176v-.175H18.02c-.223 0-.485.055-.609.175v-.175h-2.493v.175c-.199-.144-.534-.175-.688-.175h-1.645v.175c-.157-.153-.506-.175-.719-.175h-1.84l-.421.458-.395-.459h-2.75v2.997H9.16l.434-.465.41.465 1.662.002v-.705h.164c.22.003.48-.006.71-.105v.808h1.372v-.78h.066c.084 0 .093.003.093.088v.692h4.166c.265 0 .541-.068.694-.191v.191h1.322c.275 0 .544-.038.748-.138v-.558Zm-2.035-.858c.1.103.153.234.153.455 0 .462-.287.677-.801.677h-.994v-.46h.99c.096 0 .165-.013.208-.053a.191.191 0 0 0 .06-.14.185.185 0 0 0-.062-.142c-.039-.033-.093-.048-.182-.048-.477-.016-1.074.015-1.074-.665 0-.311.195-.64.73-.64h1.022v.458h-.936c-.093 0-.153.003-.204.039-.056.034-.077.086-.077.154 0 .081.048.136.112.16a.582.582 0 0 0 .198.024l.275.008c.277.007.467.055.582.173Zm-4.602-.133c-.068.04-.153.044-.252.044h-.62v-.482h.629c.09 0 .181.002.243.039.066.035.106.101.106.193s-.04.166-.106.206Zm.308.267a.556.556 0 0 1 .25.18c.072.106.082.204.084.393v.426h-.512v-.27c0-.128.013-.32-.082-.42-.075-.077-.188-.095-.374-.095h-.546v.785h-.512v-2.148h1.178c.258 0 .446.011.613.101a.503.503 0 0 1 .263.477.601.601 0 0 1-.362.571Zm.644-1.15h1.703v.445h-1.195v.39h1.165v.439h-1.165v.427l1.195.002v.446h-1.703v-2.148Zm-3.441.992h-.66v-.547h.666c.184 0 .312.076.312.263 0 .186-.122.284-.318.284Zm-1.167.961-.783-.875.783-.847v1.722Zm-2.023-.252H7.43v-.427h1.12v-.438H7.43v-.391h1.28l.557.626-.583.63Zm4.056-.993c0 .597-.443.72-.889.72h-.636v.72h-.992l-.628-.71-.652.71h-2.02v-2.147h2.05l.628.704.649-.704h1.63c.405 0 .86.113.86.707Z", fill: "#fff" })] }));
}, qt = o(Ut), _t = qt, Xt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 7H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1ZM4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4Z", fill: "currentColor" }), n("path", { d: "M8.384 10.078a.888.888 0 0 1-.206.548c-.13.161-.354.28-.533.28a.281.281 0 0 1-.053-.006.344.344 0 0 1-.007-.07c0-.204.103-.405.216-.533.14-.166.38-.29.576-.297.005.023.007.05.007.078ZM7.861 11.06c.129-.05.283-.112.455-.112.114 0 .516.01.78.393a.247.247 0 0 1-.01.006c-.067.044-.415.27-.415.74 0 .584.51.79.526.795-.003.016-.08.282-.27.559-.165.241-.344.485-.61.485-.13 0-.212-.037-.298-.075a.763.763 0 0 0-.346-.083.833.833 0 0 0-.363.088c-.089.039-.173.075-.289.075-.244 0-.415-.226-.611-.5A2.418 2.418 0 0 1 6 12.128c0-.762.495-1.17.986-1.17.144 0 .275.053.392.1.092.038.174.071.247.071.064 0 .144-.031.236-.068Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.27 13.893v-3.629h1.362c.704 0 1.194.486 1.194 1.192 0 .71-.5 1.197-1.212 1.197h-.78v1.24h-.563Zm1.213-3.154h-.649v1.442h.647c.49 0 .77-.264.77-.722 0-.458-.28-.72-.768-.72ZM13.817 13.939c.347 0 .682-.186.835-.48h.013v.434h.52V12.07c0-.53-.41-.87-1.05-.87-.655 0-1.062.352-1.092.83h.513c.047-.237.244-.388.558-.388.332 0 .53.177.53.47v.204l-.724.043c-.628.036-.983.32-.983.783 0 .475.362.797.88.797Zm.151-.43c-.292 0-.483-.151-.483-.383 0-.226.184-.37.508-.392l.652-.04v.208c0 .345-.297.607-.677.607Z", fill: "currentColor" }), n("path", { d: "M17.009 14.032c-.226.641-.488.848-1.036.848-.046 0-.181-.006-.222-.013v-.44c.04.01.131.01.177.01.251 0 .387-.106.47-.377l.03-.104.018-.06-.956-2.649h.588l.67 2.153h.01l.669-2.152H18l-.991 2.784Z", fill: "currentColor" })] }));
}, Yt = o(Xt), Kt = Yt, Qt = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M1 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8Z", fill: "#fff" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6.5H4A1.5 1.5 0 0 0 2.5 8v8A1.5 1.5 0 0 0 4 17.5h16a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 20 6.5ZM4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4Z", fill: "#E6772F" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.896 12.4c-.168.144-.382.207-.725.207H4.03v-1.716h.142c.343 0 .548.059.725.21a.872.872 0 0 1 0 1.3Zm-.619-1.949H3.5v2.596h.773c.41 0 .707-.094.968-.3.309-.245.492-.614.492-.997 0-.766-.598-1.299-1.456-1.299ZM5.977 10.451h.527v2.596h-.527V10.45ZM7.798 11.446c-.318-.111-.41-.186-.41-.326 0-.163.165-.287.394-.287.158 0 .289.06.428.21l.275-.346a1.212 1.212 0 0 0-.796-.289c-.48 0-.846.32-.846.742 0 .36.17.541.666.714.208.069.313.116.367.148.105.066.158.16.158.268 0 .21-.175.366-.411.366a.628.628 0 0 1-.577-.347l-.341.316c.244.342.536.495.938.495.55 0 .936-.352.936-.853 0-.413-.179-.6-.78-.81ZM8.746 11.75c0 .763.626 1.355 1.432 1.355.227 0 .422-.043.662-.152v-.596c-.212.204-.399.284-.64.284-.532 0-.909-.369-.909-.895 0-.497.39-.89.887-.89.25 0 .442.084.662.291v-.595a1.402 1.402 0 0 0-.652-.16c-.8 0-1.442.604-1.442 1.358ZM15.125 12.194l-.723-1.743h-.577l1.15 2.661h.283l1.172-2.66h-.572l-.733 1.742ZM16.67 13.047h1.5v-.44h-.97v-.7h.934v-.44H17.2v-.576h.97v-.44h-1.5v2.596ZM19.203 11.645h-.153v-.785h.162c.33 0 .507.133.507.386 0 .26-.177.399-.516.399Zm1.061-.428c0-.486-.348-.766-.959-.766h-.786v2.596h.53v-1.044h.07l.73 1.044h.651l-.853-1.094c.399-.078.617-.339.617-.736Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9 11.756c0 .747-.633 1.353-1.414 1.353-.781 0-1.414-.606-1.414-1.353s.633-1.353 1.414-1.353c.78 0 1.413.606 1.413 1.353Z", fill: "#E6772F" })] }));
}, Jt = o(Qt), e4 = Jt, l4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.678 8.407c.03 0 .06.003.09.01l.078.016c.089.02.178.038.265.062.908.243 1.353.957 1.172 1.88-.025.13-.056.26-.095.387-.303.984-1.02 1.536-2.067 1.583-.22.01-.44.01-.659.01h-.31c-.324.004-.415.08-.467.403a186.76 186.76 0 0 0-.328 2.064c-.017.113-.05.155-.17.152a22.945 22.945 0 0 0-.68-.003h-.305c-.256 0-.323-.073-.286-.325.09-.619.184-1.237.28-1.854l.23-1.463c.134-.853.269-1.706.4-2.56a.416.416 0 0 1 .417-.363h2.435Z", fill: "currentColor" }), n("path", { d: "M10.79 15.774c.014.014.034.02.054.02h.962a.08.08 0 0 0 .046-.013.443.443 0 0 0 .182-.325c.054-.378.116-.755.177-1.131l.048-.296c.033-.204.124-.282.33-.288l.153-.002c.077-.001.155-.002.232-.006 1.387-.058 2.354-1.324 2.053-2.687a1.018 1.018 0 0 0-.195-.425c-.043-.052-.126-.03-.142.034-.225.916-.713 1.615-1.625 1.958a3.5 3.5 0 0 1-1.284.203c-.147-.002-.294-.002-.441-.001h-.137a.082.082 0 0 0-.08.065.45.45 0 0 0-.005.025l-.107.684c-.096.617-.193 1.234-.293 1.85-.02.13-.031.246.071.335Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 7H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1ZM4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4Z", fill: "currentColor" })] }));
}, t4 = o(l4), r4 = t4, i4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v8.438a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8Z", fill: "#0066B2" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.631 14.491c0-.14.117-.253.262-.253.144 0 .261.113.261.253s-.117.254-.261.254a.258.258 0 0 1-.262-.254Zm.262.193c.11 0 .199-.087.199-.193a.196.196 0 0 0-.2-.192.196.196 0 0 0-.198.192c0 .106.09.193.199.193Zm-.035-.082h-.054v-.223h.097c.02 0 .04 0 .059.012.018.012.029.033.029.055a.06.06 0 0 1-.04.058l.042.098h-.06l-.034-.088h-.04v.088Zm0-.126h.029c.011 0 .023 0 .033-.004a.03.03 0 0 0 .013-.026.028.028 0 0 0-.013-.022c-.01-.006-.024-.005-.034-.005h-.028v.057ZM18.34 14.76h1.16l-1.012-4.676h-1.016c-.47 0-.585.348-.585.348l-1.886 4.329h1.319l.263-.695h1.608l.148.694Zm-1.392-1.654.664-1.75.374 1.75h-1.038ZM15.1 11.208l.18-1.004S14.725 10 14.144 10c-.628 0-2.118.264-2.118 1.548 0 1.209 1.75 1.224 1.75 1.858 0 .634-1.57.521-2.088.121l-.188 1.05s.565.264 1.428.264 2.165-.43 2.165-1.601c0-1.216-1.765-1.33-1.765-1.858 0-.529 1.232-.46 1.773-.174ZM10.72 14.76H9.455l.79-4.676h1.266l-.791 4.677Z", fill: "#fff" }), n("path", { d: "m7.185 13.3 1.206-3.216h1.361L7.74 14.76H6.422l-1.099-4.064a4.988 4.988 0 0 1 .554.373c.88.685 1.165 1.538 1.165 1.538l.143.692Z", fill: "#F9A533" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m7.042 12.608-.425-2.103s-.052-.421-.6-.421H4.023L4 10.163s.958.191 1.877.907c.88.685 1.165 1.538 1.165 1.538Z", fill: "#F9A533" })] }));
}, a4 = o(i4), n4 = a4, d4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.453 4.128C7.403 4 8.577 4 9.88 4h4.242c1.302 0 2.475 0 3.426.128 1.038.14 2.108.464 2.985 1.34.876.877 1.2 1.947 1.34 2.985.128.95.128 2.124.128 3.426v.242c0 1.302 0 2.476-.128 3.426-.14 1.038-.464 2.108-1.34 2.985-.877.876-1.947 1.2-2.985 1.34-.95.128-2.124.128-3.426.128H9.879c-1.302 0-2.475 0-3.426-.128-1.038-.14-2.108-.464-2.984-1.34-.877-.877-1.202-1.947-1.341-2.985C2 14.597 2 13.423 2 12.12v-.242c0-1.302 0-2.475.128-3.426.14-1.038.464-2.108 1.34-2.984.877-.877 1.947-1.202 2.985-1.341ZM12 8a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Zm-4 4a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm7-1a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z", fill: "currentColor" })] }));
}, o4 = o(d4), c4 = o4, s4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8 12a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1ZM11 9a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0V9ZM16 10a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.12 4H9.88c-1.303 0-2.476 0-3.427.128-1.038.14-2.108.464-2.984 1.34-.877.877-1.202 1.947-1.341 2.985C2 9.403 2 10.577 2 11.88v.242c0 1.302 0 2.475.128 3.426.14 1.038.464 2.108 1.34 2.985.877.876 1.947 1.2 2.985 1.34C7.403 20 8.577 20 9.88 20h4.242c1.302 0 2.475 0 3.426-.128 1.038-.14 2.108-.464 2.985-1.34.876-.877 1.2-1.947 1.34-2.985.128-.95.128-2.124.128-3.426v-.242c0-1.302 0-2.475-.128-3.426-.14-1.038-.464-2.108-1.34-2.984-.877-.877-1.947-1.202-2.985-1.341C16.597 4 15.423 4 14.12 4ZM4.025 12.004c0-2.82 0-4.228.876-5.104.876-.876 2.285-.876 5.104-.876h3.992c2.82 0 4.228 0 5.104.876.876.876.876 2.285.876 5.104v-.008c0 2.82 0 4.228-.876 5.104-.876.876-2.285.876-5.104.876h-3.992c-2.82 0-4.228 0-5.104-.876-.876-.876-.876-2.285-.876-5.104v.008Z", fill: "currentColor" })] }));
}, h4 = o(s4), u4 = h4, v4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 9.094c0-2.873 0-4.31.892-5.202C7.785 3 9.222 3 12.094 3h2.812c2.873 0 4.31 0 5.202.892.892.893.892 2.33.892 5.202v2.812c0 2.873 0 4.31-.892 5.202-.893.892-2.33.892-5.202.892h-2.812c-2.873 0-4.31 0-5.202-.892C6 16.215 6 14.778 6 11.906V9.094Zm7.158 4.498 4.231-4.231a1 1 0 0 0-1.414-1.415l-3.356 3.356c-.1.1-.26.1-.36 0l-1.234-1.234a1 1 0 1 0-1.414 1.414l2.11 2.11c.397.397 1.04.397 1.437 0Z", fill: "currentColor" }), n("path", { d: "M8 20a4 4 0 0 1-4-4V7.254c0-.14-.114-.256-.253-.233C2.838 7.169 2 8.084 2 9v7a6 6 0 0 0 6 6h7c1.019 0 1.848-.838 1.981-1.747.02-.139-.094-.253-.234-.253H8Z", fill: "currentColor" })] }));
}, f4 = o(v4), g4 = f4, p4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.406 4.5h-2.812c-1.493 0-2.412.004-3.077.094-.585.078-.69.191-.709.21l-.001.003-.002.001c-.02.019-.133.124-.211.709-.09.665-.094 1.584-.094 3.077v2.812c0 1.493.004 2.412.094 3.077.078.585.191.69.21.709l.003.001.001.002c.019.02.124.133.709.211.665.09 1.584.094 3.077.094h2.812c1.493 0 2.411-.004 3.077-.094.585-.078.69-.191.709-.21l.001-.003.002-.001c.02-.019.133-.124.211-.709.09-.665.094-1.584.094-3.077V8.594c0-1.493-.004-2.412-.094-3.077-.078-.585-.191-.69-.21-.709l-.003-.001-.001-.002c-.019-.02-.124-.133-.709-.211-.666-.09-1.584-.094-3.077-.094ZM7.392 3.392C6.5 4.285 6.5 5.722 6.5 8.594v2.812c0 2.873 0 4.31.892 5.202.893.892 2.33.892 5.202.892h2.812c2.873 0 4.31 0 5.202-.892.892-.893.892-2.33.892-5.202V8.594c0-2.873 0-4.31-.892-5.202-.893-.892-2.33-.892-5.202-.892h-2.812c-2.873 0-4.31 0-5.202.892Z", fill: "currentColor" }), n("path", { d: "M4.5 6.754V15.5a4 4 0 0 0 4 4h8.747c.14 0 .255.114.234.253-.133.909-.962 1.747-1.981 1.747h-7a6 6 0 0 1-6-6v-7c0-.916.838-1.831 1.747-1.98.139-.022.253.094.253.234ZM13.658 13.092l4.231-4.231a1 1 0 0 0-1.414-1.415l-3.356 3.356c-.1.1-.26.1-.36 0l-1.234-1.234a1 1 0 1 0-1.414 1.414l2.11 2.11c.397.397 1.04.397 1.437 0Z", fill: "currentColor" })] }));
}, w4 = o(p4), b4 = w4, m4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0Zm6.314 7.384c.536.487.576 1.317.088 1.854l-7.245 7.97a2.062 2.062 0 0 1-3.072-.022l-3.173-3.59a1.313 1.313 0 0 1 1.967-1.739l2.758 3.12 6.822-7.505a1.313 1.313 0 0 1 1.855-.088Z", fill: "currentColor" })] }));
}, x4 = o(m4), y4 = x4, C4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.969A6.969 6.969 0 1 0 12 5.03a6.969 6.969 0 0 0 0 13.938ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.071 9.414a1 1 0 0 1 0 1.414l-3.89 3.89a1.5 1.5 0 0 1-2.12 0l-2.01-2.01a1 1 0 1 1 1.413-1.415l1.48 1.48a.25.25 0 0 0 .354 0l3.359-3.359a1 1 0 0 1 1.414 0Z", fill: "currentColor" })] }));
}, k4 = o(C4), Z4 = k4, M4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.712 12.484a1.002 1.002 0 0 1 1.417-.001l2.648 2.654a.25.25 0 0 0 .353 0l6.895-6.894a1 1 0 0 1 1.414 1.414l-7.782 7.781a1 1 0 0 1-1.414 0L6.71 13.9a1.002 1.002 0 0 1 .002-1.416Z", fill: "currentColor" })] }));
}, z4 = o(M4), he = z4, R4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 5.293a1 1 0 0 1 0 1.414l-4.94 4.94a.5.5 0 0 0 0 .707l4.94 4.939a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 5.293a1 1 0 0 1 0 1.414l-4.94 4.94a.5.5 0 0 0 0 .707l4.94 4.939a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z", fill: "currentColor" })] }));
}, I4 = o(R4), S4 = I4, B4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z", fill: "currentColor" })] }));
}, N4 = o(B4), A4 = N4, H4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.293 8.293a1 1 0 0 1 1.414 0l4.94 4.94a.5.5 0 0 0 .707 0l4.939-4.94a1 1 0 1 1 1.414 1.414l-5.646 5.647a1.5 1.5 0 0 1-2.122 0L5.293 9.707a1 1 0 0 1 0-1.414Z", fill: "currentColor" })] }));
}, V4 = o(H4), $4 = V4, L4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 12a6.969 6.969 0 1 0 13.938 0A6.969 6.969 0 0 0 5.03 12ZM3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m10.914 12 2.829-2.828a1 1 0 1 0-1.415-1.415L9.146 10.94a1.5 1.5 0 0 0 0 2.122l3.182 3.182a1 1 0 1 0 1.415-1.415L10.914 12Z", fill: "currentColor" })] }));
}, O4 = o(L4), F4 = O4, P4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.707 5.293a1 1 0 0 1 0 1.414l-5.116 5.116a.25.25 0 0 0 0 .354l5.116 5.116a1 1 0 1 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z", fill: "currentColor" })] }));
}, j4 = o(P4), E4 = j4, T4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.969 12A6.969 6.969 0 1 0 5.03 12a6.969 6.969 0 0 0 13.938 0ZM21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m13.086 12-2.829 2.828a1 1 0 1 0 1.415 1.415l3.182-3.182a1.5 1.5 0 0 0 0-2.122l-3.182-3.182a1 1 0 1 0-1.415 1.415L13.086 12Z", fill: "currentColor" })] }));
}, G4 = o(T4), W4 = G4, D4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z", fill: "currentColor" })] }));
}, U4 = o(D4), q4 = U4, _4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.707 15.707a1 1 0 0 1-1.414 0l-4.94-4.94a.5.5 0 0 0-.707 0l-4.939 4.94a1 1 0 0 1-1.414-1.414l5.646-5.647a1.5 1.5 0 0 1 2.122 0l5.646 5.647a1 1 0 0 1 0 1.414Z", fill: "currentColor" })] }));
}, X4 = o(_4), Y4 = X4, K4 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11.016 12.25a1.018 1.018 0 0 0 .433.603l4.072 2.633a1.017 1.017 0 0 0 1.404-.301 1.016 1.016 0 0 0-.301-1.405l-3.608-2.333V8a1.016 1.016 0 1 0-2.032 0v4c0 .085.011.17.032.25Z", fill: "currentColor" }), n("path", { d: "M18.046 15.91c.416-.644.73-1.355.925-2.109l.002-.009a7.2 7.2 0 1 0-14.115-2.701l1.079-.265c.38-.093.718.26.608.636l-1.149 3.931a.508.508 0 0 1-.854.209l-2.825-2.958a.508.508 0 0 1 .247-.844l1.048-.257a8.928 8.928 0 0 1 .374-2.15 8.998 8.998 0 0 1 12.245-5.628 9 9 0 1 1-9.369 15.169c-.383-.317-.377-.891-.023-1.24.31-.307.784-.338 1.16-.134.052.029.103.062.15.1a7.2 7.2 0 0 0 10.496-1.75Z", fill: "currentColor" })] }));
}, Q4 = o(K4), J4 = Q4, er = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("circle", { cx: 12, cy: 12, r: 7.984, stroke: "currentColor", strokeWidth: 2.031 }), n("path", { d: "M13.203 7.11a1.016 1.016 0 1 0-2.031 0h2.031Zm-1.015 5.077v1.016c.56 0 1.015-.455 1.015-1.015h-1.015Zm-4.57-1.015a1.016 1.016 0 1 0 0 2.031v-2.031Zm3.554-4.063v5.079h2.031V7.109h-2.031Zm1.015 4.063h-4.57v2.031h4.57v-2.031Z", fill: "currentColor" })] }));
}, lr = o(er), tr = lr, rr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m17.66 7.93-4.953-4.953a1 1 0 0 0-1.414 0L6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31A7.98 7.98 0 0 0 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31ZM12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 0 1 6 13.59c0-1.6.62-3.11 1.76-4.24l3.813-3.822a.25.25 0 0 1 .427.177V19.59Z", fill: "currentColor" })] }));
}, ir = o(rr), ar = ir, nr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.879 18.121C3.757 19 5.172 19 8 19h8c2.828 0 4.243 0 5.121-.879C22 17.243 22 15.828 22 13v-2c0-2.828 0-4.243-.879-5.121C20.243 5 18.828 5 16 5H8c-2.828 0-4.243 0-5.121.879C2 6.757 2 8.172 2 11v2c0 2.828 0 4.243.879 5.121ZM4 16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8Z", fill: "currentColor" }), n("path", { d: "M8 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM8 15a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM8 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z", fill: "currentColor" })] }));
}, dr = o(nr), or = dr, cr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 9a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H6a1 1 0 0 1-1-1ZM15 11a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM15 14a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM15 8a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 19c-2.828 0-4.243 0-5.121-.879C2 17.243 2 15.828 2 13v-2c0-2.828 0-4.243.879-5.121C3.757 5 5.172 5 8 5h8c2.828 0 4.243 0 5.121.879C22 6.757 22 8.172 22 11v2c0 2.828 0 4.243-.879 5.121C20.243 19 18.828 19 16 19H8Zm-3-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5Zm8-1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v8Z", fill: "currentColor" })] }));
}, sr = o(cr), hr = sr, ur = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M4.5 13a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4Zm17 3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1h18ZM4 17a1 1 0 0 1-1-1v-6h18v6a1 1 0 0 1-1 1H4Z", fill: "currentColor" })] }));
}, vr = o(ur), fr = vr, gr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M20.506 4.334 3.222 6.348a2 2 0 0 0-1.5 2.987l2.264 3.923a1 1 0 0 0 1.3.4L13.26 9.82a.27.27 0 0 1 .269.465L6.217 15.27a1 1 0 0 0-.303 1.327l2.265 3.923a2 2 0 0 0 3.337.194L21.902 6.75c.795-1.069-.072-2.57-1.396-2.417Z", fill: "currentColor" })] }));
}, pr = o(gr), wr = pr, br = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m12.09 20.401 9.903-13.008c1.17-1.537-.064-3.675-1.98-3.43L3.794 6.035c-1.824.233-2.85 2.23-1.949 3.79l1.965 3.403a2.974 2.974 0 0 0 1.746 1.367 2.974 2.974 0 0 0 .311 2.196l1.965 3.403c.901 1.561 3.143 1.67 4.256.207ZM4.015 8.033 20.233 5.96a.151.151 0 0 1 .14.243L10.47 19.211a.52.52 0 0 1-.862-.041l-1.965-3.404a1.026 1.026 0 0 1 .316-1.351l6.072-4.24a.414.414 0 0 0 .128-.546.414.414 0 0 0-.536-.162l-6.708 3.139a1.026 1.026 0 0 1-1.329-.403L3.621 8.8a.52.52 0 0 1 .395-.767Z", fill: "currentColor" })] }));
}, mr = o(br), xr = mr, yr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.768 11.646a.5.5 0 0 0 0 .708l3.182 3.182a1 1 0 0 1-1.414 1.414l-3.182-3.182a.5.5 0 0 0-.708 0L8.464 16.95a1 1 0 1 1-1.414-1.414l3.182-3.182a.5.5 0 0 0 0-.708L7.05 8.464A1 1 0 0 1 8.464 7.05l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 1 1 1.414 1.414l-3.182 3.182Z", fill: "currentColor" })] }));
}, Cr = o(yr), kr = Cr, Zr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 12H4V4h16v10Zm-9-9h2v2h-2V5Zm0 3h2v2h-2V8ZM8 5h2v2H8V5Zm0 3h2v2H8V8ZM5 8h2v2H5V8Zm0-3h2v2H5V5Zm3 6h8v2H8v-2Zm6-3h2v2h-2V8Zm0-3h2v2h-2V5Zm3 3h2v2h-2V8Zm0-3h2v2h-2V5Zm-5 17 4-4H8l4 4Z", fill: "currentColor" })] }));
}, Mr = o(Zr), zr = Mr, Rr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M18 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z", fill: "currentColor" })] }));
}, Ir = o(Rr), Sr = Ir, Br = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM12 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z", fill: "currentColor" })] }));
}, Nr = o(Br), Ar = Nr, Hr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("g", { clipPath: "url(#a)", children: n("path", { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z", fill: "currentColor" }) }), n("defs", { children: n("clipPath", { id: "a", children: n("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })] }));
}, Vr = o(Hr), $r = Vr, Lr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m9.978 12.622.82.775a1.75 1.75 0 0 0 2.404 0l.82-.775 5.897 6.319c-.133.038-.274.059-.419.059h-15c-.145 0-.286-.02-.419-.06l5.897-6.318Zm-1.09-1.03-5.83-5.506C3.02 6.218 3 6.356 3 6.5v11c0 .122.015.241.042.355l5.846-6.263Zm12.07 6.263-5.846-6.263 5.83-5.506c.038.132.058.27.058.414v11c0 .122-.015.241-.042.355ZM4.138 5.044C4.255 5.015 4.376 5 4.5 5h15c.125 0 .246.015.361.044l-7.69 7.262a.25.25 0 0 1-.343 0l-7.69-7.262Z", fill: "currentColor" })] }));
}, Or = o(Lr), Fr = Or, Pr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 13c0 2.828 0 4.243.879 5.121C4.757 19 6.172 19 9 19h6c2.828 0 4.243 0 5.121-.879C21 17.243 21 15.828 21 13v-2c0-2.828 0-4.243-.879-5.121C19.243 5 17.828 5 15 5H9c-2.828 0-4.243 0-5.121.879C3 6.757 3 8.172 3 11v2Zm3.274-5.941C6.9 7.003 7.742 7 9 7h6c1.259 0 2.1.003 2.726.059l-5.41 4.396a.5.5 0 0 1-.631 0L6.274 7.06Zm-1.24 1.57C5.002 9.212 5 9.965 5 11v2c0 1.47.004 2.373.092 3.025.077.574.187.67.2.681v.001l.002.001c.011.013.107.123.68.2C6.628 16.996 7.53 17 9 17h6c1.47 0 2.373-.004 3.025-.092.574-.077.67-.187.681-.2h.001l.001-.002c.013-.011.123-.107.2-.68.088-.653.092-1.555.092-3.026v-2c0-1.035-.002-1.788-.034-2.371l-5.39 4.379a2.5 2.5 0 0 1-3.152 0l-5.39-4.38Z", fill: "currentColor" })] }));
}, jr = o(Pr), Er = jr, Tr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14.629 17.629 12.94 15.94A7.44 7.44 0 0 1 12 16c-3.75 0-6.101-2.771-6.95-4 .36-.521.99-1.32 1.883-2.067L5.515 8.515a12.528 12.528 0 0 0-2.386 2.768.89.89 0 0 0-.129.472v.49c0 .167.04.33.129.473C3.76 13.737 6.719 18 12 18a9.37 9.37 0 0 0 2.629-.371ZM9.109 6.452A9.358 9.358 0 0 1 12 6c5.282 0 8.239 4.262 8.871 5.283a.89.89 0 0 1 .129.472v.49a.89.89 0 0 1-.129.473 12.539 12.539 0 0 1-2.571 2.925l-1.422-1.422A10.57 10.57 0 0 0 18.95 12c-.849-1.229-3.2-4-6.95-4-.432 0-.845.037-1.24.104L9.11 6.452Z", fill: "currentColor" }), n("path", { d: "M12 15a3 3 0 0 1-3-3l3 3ZM14.982 12.326l-3.308-3.309a3 3 0 0 1 3.308 3.308Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.15 4.435a1 1 0 0 1 1.413 0L19.15 18.021a1 1 0 0 1-1.414 1.414L4.149 5.849a1 1 0 0 1 0-1.414Z", fill: "currentColor" })] }));
}, Gr = o(Tr), Wr = Gr, Dr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14.629 17.629 12.94 15.94A7.44 7.44 0 0 1 12 16c-3.75 0-6.101-2.771-6.95-4 .36-.521.99-1.32 1.883-2.067L5.515 8.515a12.528 12.528 0 0 0-2.386 2.768.89.89 0 0 0-.129.472v.49c0 .167.04.33.129.473C3.76 13.737 6.719 18 12 18a9.37 9.37 0 0 0 2.629-.371ZM9.109 6.452A9.358 9.358 0 0 1 12 6c5.282 0 8.239 4.262 8.871 5.283a.89.89 0 0 1 .129.472v.49a.89.89 0 0 1-.129.473 12.539 12.539 0 0 1-2.571 2.925l-1.422-1.422A10.57 10.57 0 0 0 18.95 12c-.849-1.229-3.2-4-6.95-4-.432 0-.845.037-1.24.104L9.11 6.452Z", fill: "currentColor" }), n("path", { d: "M12 15a3 3 0 0 1-3-3l3 3ZM14.982 12.326l-3.308-3.309a3 3 0 0 1 3.308 3.308Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.15 4.435a1 1 0 0 1 1.413 0L19.15 18.021a1 1 0 0 1-1.414 1.414L4.149 5.849a1 1 0 0 1 0-1.414Z", fill: "currentColor" })] }));
}, Ur = o(Dr), qr = Ur, _r = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.95 12c-.849-1.229-3.2-4-6.95-4s-6.101 2.771-6.95 4c.849 1.229 3.2 4 6.95 4s6.101-2.771 6.95-4ZM3.13 11.283a.89.89 0 0 0-.129.472v.49c0 .167.04.33.129.473C3.76 13.737 6.719 18 12 18c5.282 0 8.239-4.262 8.871-5.283a.89.89 0 0 0 .129-.472v-.49a.89.89 0 0 0-.129-.473C20.24 10.263 17.281 6 12 6c-5.282 0-8.239 4.262-8.871 5.283Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", fill: "currentColor" })] }));
}, Xr = o(_r), Yr = Xr, Kr = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5Z", fill: "currentColor" })] }));
}, Qr = o(Kr), Jr = Qr, e5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm1.818-14c-1.868 0-3.088 1.122-3.088 3.15v1.783H8.66v2.339h2.07v4.581a6.969 6.969 0 1 1 2.553-.003v-4.578h1.902l.368-2.339h-2.27v-1.52c0-.64.317-1.264 1.33-1.264h1.047V7.157c-.61-.097-1.225-.15-1.842-.157Z", fill: "currentColor" })] }));
}, l5 = o(e5), t5 = l5, r5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m14.929 11.795.001.003a4.858 4.858 0 0 1 .43 3.718 4.502 4.502 0 0 1-5.56 3.095 4.502 4.502 0 0 1-3.201-5.1 3.219 3.219 0 0 0 3.769.466c.705-.393 1.273-1.024 1.498-1.9.193-.755.072-1.477-.06-1.996-.459-1.812-.637-2.901-.443-3.762.059-.26.165-.549.38-.862.154.972.451 1.81.863 2.608.343.663.754 1.274 1.124 1.825l.034.051c.394.586.779 1.16 1.165 1.854Zm-1.304-7.886V3.9a12.755 12.755 0 0 1 .06-1.2c.047-.486-.446-.858-.874-.625a12.03 12.03 0 0 0-1.141.708c-3.021 2.154-2.6 4.637-1.803 7.79.204.805.116 1.33-.472 1.657a1.217 1.217 0 0 1-1.656-.472 4.648 4.648 0 0 1-.517-1.465C7.12 9.695 6.333 9.303 6 9.809a9.059 9.059 0 0 0-.67 1.21c-.215.465-.4.961-.549 1.483a6.501 6.501 0 0 0 12.502 3.562 6.859 6.859 0 0 0-.607-5.242c-.434-.78-.864-1.42-1.259-2.007-1.008-1.5-1.783-2.653-1.792-4.906Z", fill: "currentColor" })] }));
}, i5 = o(r5), a5 = i5, n5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M2.879 18.121C3.757 19 5.172 19 8 19h8c2.828 0 4.243 0 5.121-.879C22 17.243 22 15.828 22 13v-2c0-2.828 0-4.243-.879-5.121C20.243 5 18.828 5 16 5h-2.197c-.888 0-1.332 0-1.751-.125l-.026-.008C11.608 4.74 11.24 4.492 10.5 4l-.146-.098c-.593-.395-.89-.593-1.218-.714a2.999 2.999 0 0 0-.353-.107C8.443 3 8.086 3 7.373 3c-2.224 0-3.336 0-4.12.56a3 3 0 0 0-.692.694C2 5.037 2 6.149 2 8.374V13c0 2.828 0 4.243.879 5.121Z", fill: "currentColor" })] }));
}, d5 = o(n5), o5 = d5, c5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 19c-2.828 0-4.243 0-5.121-.879C2 17.243 2 15.828 2 13V8.373c0-2.224 0-3.336.56-4.12a3 3 0 0 1 .694-.692C4.037 3 5.149 3 7.374 3c.712 0 1.068 0 1.41.08.119.03.236.065.352.108.328.121.625.32 1.218.714L10.5 4c.739.492 1.108.739 1.526.867l.026.008c.419.125.863.125 1.75.125H16c2.828 0 4.243 0 5.121.879C22 6.757 22 8.172 22 11v2c0 2.828 0 4.243-.879 5.121C20.243 19 18.828 19 16 19H8Zm-4-6V8.373c0-1.156.003-1.864.059-2.387a2.47 2.47 0 0 1 .084-.468.345.345 0 0 1 .044-.1c.064-.09.142-.168.231-.231.006-.005.03-.021.1-.044a2.47 2.47 0 0 1 .468-.084C5.51 5.003 6.217 5 7.373 5c.804 0 .888.012.95.027a1 1 0 0 1 .117.035c.059.022.135.059.804.505l.147.097.139.093c.597.4 1.202.805 1.908 1.022l.043.013c.708.21 1.436.21 2.155.208H16c1.47 0 2.373.004 3.025.092.574.077.67.187.681.2h.001l.001.002c.013.011.123.107.2.68C19.996 8.628 20 9.53 20 11v2c0 1.47-.004 2.373-.092 3.025-.077.574-.187.67-.2.681v.001l-.002.001c-.011.013-.107.123-.68.2-.653.088-1.555.092-3.026.092H8c-1.47 0-2.373-.004-3.025-.092-.574-.077-.67-.187-.681-.2h-.001l-.001-.002c-.013-.011-.123-.107-.2-.68C4.004 15.372 4 14.47 4 13Z", fill: "currentColor" })] }));
}, s5 = o(c5), h5 = s5, u5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M13.497 6.458c.527 0 .79.084.834.604l.092 1.064a.5.5 0 0 0 .498.457h.465a.5.5 0 0 0 .5-.481l.095-2.584a.5.5 0 0 0-.5-.518H3.52a.5.5 0 0 0-.5.518l.095 2.584a.5.5 0 0 0 .5.481h.465a.5.5 0 0 0 .498-.457l.092-1.063c.044-.521.307-.605.813-.605h3.074v11.334c0 .52-.088.708-.637.791l-.826.124a.5.5 0 0 0-.426.494v.299a.5.5 0 0 0 .5.5h4.666a.5.5 0 0 0 .5-.5v-.299a.5.5 0 0 0-.426-.494l-.826-.124c-.549-.083-.637-.27-.637-.791V6.458h3.053ZM18.425 11.739c1.202-.112 1.931-.168 2.189-.168.257 0 .386.04.386.12 0 .095-.183.195-.55.3-.367.103-1.26.235-2.68.395a28.24 28.24 0 0 1-.282.503c-.234.383-.359.615-.374.695-.89 1.821-1.358 2.98-1.405 3.475a5.289 5.289 0 0 0-.023.551.81.81 0 0 0 .187.551c.219.256.53.272.936.048.406-.224.972-.67 1.698-1.342.726-.67 1.315-1.326 1.767-1.965.063-.08.14-.096.234-.048.235.112-.171.743-1.217 1.893-.999 1.103-1.834 1.782-2.505 2.037-.39.144-.718.216-.983.216-.625 0-1.038-.304-1.241-.91a1.53 1.53 0 0 1-.047-.408c0-.56.25-1.406.75-2.54-.079.175-.383.575-.914 1.198-.14.16-.25.16-.328 0a.305.305 0 0 1-.023-.132c0-.056.031-.124.094-.204.764-.974 1.365-1.797 1.802-2.468 0-.016.172-.351.515-1.007a2.384 2.384 0 0 1-.48.048c-.163 0-.284-.052-.362-.155-.078-.104-.086-.228-.024-.372.11-.256.523-.4 1.241-.431.016-.032.047-.048.094-.048l1.17-2.229c.063-.128.133-.26.211-.395.078-.136.137-.24.175-.312.04-.072.082-.148.13-.228a.921.921 0 0 1 .116-.167l.094-.096c.062-.096.246-.144.55-.144.305 0 .511.088.62.264.047.064.07.171.07.323s-.054.32-.163.503c-.11.184-.226.316-.351.396a.684.684 0 0 0-.258.263l-1.123 2.013.304-.023Z", fill: "currentColor" })] }));
}, v5 = o(u5), f5 = v5, g5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.45 18.49a.5.5 0 0 0 .794.405l7.594-5.49a.5.5 0 0 0 0-.81l-7.594-5.49a.5.5 0 0 0-.793.405v5.139a.498.498 0 0 0-.064-.054l-7.594-5.49A.5.5 0 0 0 4 7.51v10.98a.5.5 0 0 0 .793.405l7.594-5.49a.507.507 0 0 0 .064-.054v5.139Z", fill: "currentColor" })] }));
}, p5 = o(g5), w5 = p5, b5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.286 4.286a1.286 1.286 0 1 0-2.572 0l.004.895a.675.675 0 0 1-.5.64c-.466.135-.91.32-1.327.55a.674.674 0 0 1-.806-.098l-.63-.637a1.286 1.286 0 0 0-1.819 1.818l.637.631a.674.674 0 0 1 .099.806c-.23.417-.416.861-.55 1.327a.675.675 0 0 1-.64.5l-.896-.004a1.286 1.286 0 1 0 0 2.572l.895-.004c.301-.002.557.211.64.5.135.466.32.91.55 1.326a.674.674 0 0 1-.098.807l-.637.63a1.286 1.286 0 0 0 1.818 1.819l.631-.637a.674.674 0 0 1 .806-.099c.417.23.861.416 1.327.55.289.084.502.34.5.64l-.004.896a1.286 1.286 0 1 0 2.572 0l-.004-.895a.675.675 0 0 1 .5-.64 6.39 6.39 0 0 0 1.326-.55.674.674 0 0 1 .807.098l.63.637a1.286 1.286 0 0 0 1.819-1.818l-.637-.631a.674.674 0 0 1-.099-.806c.23-.417.416-.861.55-1.327a.675.675 0 0 1 .64-.5l.896.004a1.286 1.286 0 1 0 0-2.572l-.895.004a.675.675 0 0 1-.64-.5 6.39 6.39 0 0 0-.55-1.327.674.674 0 0 1 .098-.806l.637-.63a1.286 1.286 0 1 0-1.818-1.819l-.631.637a.674.674 0 0 1-.806.099 6.389 6.389 0 0 0-1.327-.55.675.675 0 0 1-.5-.64l.004-.896ZM8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z", fill: "currentColor" })] }));
}, m5 = o(b5), x5 = m5, y5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.765 18.636C8.89 16.748 8.363 14.867 8.21 13H5.07a7.008 7.008 0 0 0 4.694 5.636ZM13.78 13c-.172 1.816-.762 3.698-1.781 5.648-1.019-1.95-1.609-3.832-1.781-5.648h3.562Zm-3.583-2c.141-1.836.729-3.645 1.802-5.43 1.073 1.785 1.66 3.594 1.802 5.43h-3.604Zm5.591 2c-.152 1.867-.68 3.748-1.554 5.636A7.009 7.009 0 0 0 18.93 13h-3.14Zm-1.622-7.658A7.008 7.008 0 0 1 18.929 11h-3.122c-.127-1.94-.674-3.829-1.64-5.658Zm-4.334 0C8.867 7.172 8.32 9.06 8.193 11H5.071a7.008 7.008 0 0 1 4.762-5.658Z", fill: "currentColor" })] }));
}, C5 = o(y5), k5 = C5, Z5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M7.12 1.05a.264.264 0 0 1 .418.214v2.714a.27.27 0 0 1 .033-.029l4.01-2.898a.264.264 0 0 1 .419.213V3a9 9 0 1 1-8.946 9.984c-.061-.554.398-1.006.956-1.005.557.002 1 .457 1.08 1.01A6.98 6.98 0 1 0 12 5.018v2.043c0 .215-.244.34-.419.214l-4.01-2.899a.268.268 0 0 1-.033-.029v2.714c0 .215-.244.34-.419.214L3.11 4.377a.264.264 0 0 1 0-.428l4.01-2.898Z", fill: "currentColor" }), n("path", { d: "M9.31 14.263c0 .506.267.796.742.796.47 0 .737-.285.737-.796V9.695c0-.552-.353-.91-.882-.91-.303 0-.624.105-.977.331l-.737.493c-.267.167-.403.366-.403.588 0 .298.217.516.516.516.15 0 .276-.046.51-.195l.476-.321h.018v4.066ZM13.664 15.136c-1.244 0-2.19-.674-2.19-1.402 0-.353.231-.647.598-.647.217 0 .384.081.556.285.312.384.637.565 1.049.565.597 0 1.022-.402 1.022-1 0-.565-.407-.954-.977-.954-.28 0-.579.109-.85.303-.226.177-.384.231-.565.231-.444 0-.774-.312-.742-.769l.15-2.198c.03-.484.33-.728.895-.728h2.569c.434 0 .678.222.678.602 0 .375-.24.583-.678.583h-2.27l-.1 1.339h.077c.217-.285.705-.47 1.239-.47 1.194 0 1.999.809 1.999 2.02 0 1.353-.968 2.24-2.46 2.24Z", fill: "currentColor" })] }));
}, M5 = o(Z5), z5 = M5, R5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M7.12 1.05a.264.264 0 0 1 .418.214v2.714a.27.27 0 0 1 .033-.029l4.01-2.898a.264.264 0 0 1 .419.213V3a9 9 0 1 1-8.946 9.984c-.061-.554.398-1.006.956-1.005.557.002 1 .457 1.08 1.01A6.98 6.98 0 1 0 12 5.018v2.043c0 .215-.244.34-.419.214l-4.01-2.899a.268.268 0 0 1-.033-.029v2.714c0 .215-.244.34-.419.214L3.11 4.377a.264.264 0 0 1 0-.428l4.01-2.898Z", fill: "currentColor" }), n("path", { d: "M6.98 13.68c0 .773.986 1.456 2.243 1.456 1.425 0 2.433-.774 2.433-1.864 0-.787-.556-1.415-1.298-1.47v-.1c.624-.076 1.117-.668 1.117-1.333 0-.973-.922-1.656-2.243-1.656-1.221 0-2.184.656-2.184 1.403 0 .334.248.57.597.57.235 0 .425-.096.588-.308.275-.367.583-.538.972-.538.507 0 .86.289.86.71 0 .42-.363.728-.851.728h-.353c-.316 0-.542.244-.542.56 0 .33.23.57.542.57h.367c.588 0 .981.326.981.806 0 .483-.389.795-.986.795-.439 0-.796-.19-1.072-.56-.203-.254-.384-.358-.601-.358-.33 0-.57.245-.57.588Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.66 15.136c-1.511 0-2.434-1.19-2.434-3.053v-.33c0-1.841.945-3.04 2.465-3.04 1.524 0 2.433 1.176 2.433 3.04v.33c0 1.836-.954 3.053-2.465 3.053Zm.013-5.229c-.597 0-.945.679-.945 1.85v.321c0 1.176.352 1.864.95 1.864.592 0 .95-.692.95-1.864v-.32c0-1.168-.358-1.85-.955-1.85Z", fill: "currentColor" })] }));
}, I5 = o(R5), S5 = I5, B5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M7.12 1.05a.264.264 0 0 1 .418.214v2.714a.27.27 0 0 1 .033-.029l4.01-2.898a.264.264 0 0 1 .419.213V3a9 9 0 1 1-8.946 9.984c-.061-.554.398-1.006.956-1.005.557.002 1 .457 1.08 1.01A6.98 6.98 0 1 0 12 5.018v2.043c0 .215-.244.34-.419.214l-4.01-2.899a.268.268 0 0 1-.033-.029v2.714c0 .215-.244.34-.419.214L3.11 4.377a.264.264 0 0 1 0-.428l4.01-2.898Z", fill: "currentColor" })] }));
}, N5 = o(B5), A5 = N5, H5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M16.88 1.05a.264.264 0 0 0-.418.214v2.714a.273.273 0 0 0-.033-.029l-4.01-2.898a.264.264 0 0 0-.419.213V3a9 9 0 1 0 8.946 9.984c.061-.554-.398-1.006-.956-1.005-.557.002-1 .457-1.08 1.01a6.982 6.982 0 0 1-12.174 3.596A6.981 6.981 0 0 1 12 5.02v2.043c0 .215.244.34.419.214l4.01-2.899a.271.271 0 0 0 .033-.029v2.714c0 .215.244.34.419.214l4.01-2.899a.264.264 0 0 0 0-.428l-4.01-2.898Z", fill: "currentColor" }), n("path", { d: "M9.31 14.263c0 .506.267.796.742.796.47 0 .737-.285.737-.796V9.695c0-.552-.353-.91-.882-.91-.303 0-.624.105-.977.331l-.737.493c-.267.167-.403.366-.403.588 0 .298.217.516.516.516.15 0 .276-.046.51-.195l.476-.321h.018v4.066ZM13.664 15.136c-1.244 0-2.19-.674-2.19-1.402 0-.353.231-.647.598-.647.217 0 .384.081.556.285.312.384.637.565 1.049.565.597 0 1.022-.402 1.022-1 0-.565-.407-.954-.977-.954-.28 0-.579.109-.85.303-.226.177-.384.231-.565.231-.444 0-.774-.312-.742-.769l.15-2.198c.03-.484.33-.728.895-.728h2.569c.434 0 .678.222.678.602 0 .375-.24.583-.678.583h-2.27l-.1 1.339h.077c.217-.285.705-.47 1.239-.47 1.194 0 1.999.809 1.999 2.02 0 1.353-.968 2.24-2.46 2.24Z", fill: "currentColor" })] }));
}, V5 = o(H5), $5 = V5, L5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M16.88 1.05a.264.264 0 0 0-.418.214v2.714a.272.272 0 0 0-.033-.029l-4.01-2.898a.264.264 0 0 0-.419.213V3a9 9 0 1 0 8.946 9.984c.061-.554-.398-1.006-.956-1.005-.557.002-1 .457-1.08 1.01a6.982 6.982 0 0 1-12.174 3.596A6.981 6.981 0 0 1 12 5.02v2.043c0 .215.244.34.419.214l4.01-2.899a.271.271 0 0 0 .033-.029v2.714c0 .215.244.34.419.214l4.01-2.899a.264.264 0 0 0 0-.428l-4.01-2.898Z", fill: "currentColor" }), n("path", { d: "M6.98 13.68c0 .773.986 1.456 2.243 1.456 1.425 0 2.433-.774 2.433-1.864 0-.787-.556-1.415-1.298-1.47v-.1c.624-.076 1.117-.668 1.117-1.333 0-.973-.922-1.656-2.243-1.656-1.221 0-2.184.656-2.184 1.403 0 .334.248.57.597.57.235 0 .425-.096.588-.308.275-.367.583-.538.972-.538.507 0 .86.289.86.71 0 .42-.363.728-.851.728h-.353c-.316 0-.542.244-.542.56 0 .33.23.57.542.57h.367c.588 0 .981.326.981.806 0 .483-.389.795-.986.795-.439 0-.796-.19-1.072-.56-.203-.254-.384-.358-.601-.358-.33 0-.57.245-.57.588Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.66 15.136c-1.511 0-2.434-1.19-2.434-3.053v-.33c0-1.841.945-3.04 2.465-3.04 1.524 0 2.433 1.176 2.433 3.04v.33c0 1.836-.954 3.053-2.465 3.053Zm.013-5.229c-.597 0-.945.679-.945 1.85v.321c0 1.176.353 1.864.95 1.864.592 0 .95-.692.95-1.864v-.32c0-1.168-.358-1.85-.955-1.85Z", fill: "currentColor" })] }));
}, O5 = o(L5), F5 = O5, P5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M4.365 10.727C4.9 11 5.6 11 7 11c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C11 9.1 11 8.4 11 7c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.093C9.1 3 8.4 3 7 3c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093C3 4.9 3 5.6 3 7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092ZM3.586 20.414C4.172 21 5.114 21 7 21c1.886 0 2.828 0 3.414-.586C11 19.828 11 18.886 11 17c0-1.886 0-2.828-.586-3.414C9.828 13 8.886 13 7 13c-1.886 0-2.828 0-3.414.586C3 14.172 3 15.114 3 17c0 1.886 0 2.828.586 3.414ZM17 11c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.092-1.092C13 9.1 13 8.4 13 7c0-1.4 0-2.1.273-2.635a2.5 2.5 0 0 1 1.092-1.093C14.9 3 15.6 3 17 3c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C21 4.9 21 5.6 21 7c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C19.1 11 18.4 11 17 11ZM14.365 20.727C14.9 21 15.6 21 17 21c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C21 19.1 21 18.4 21 17c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.092C19.1 13 18.4 13 17 13c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 0 0-1.092 1.092C13 14.9 13 15.6 13 17c0 1.4 0 2.1.273 2.635a2.5 2.5 0 0 0 1.092 1.092Z", fill: "currentColor" })] }));
}, j5 = o(P5), E5 = j5, T5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 11c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C3 9.1 3 8.4 3 7c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093C4.9 3 5.6 3 7 3c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C11 4.9 11 5.6 11 7c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C9.1 11 8.4 11 7 11Zm2-4c0 .733-.002 1.163-.027 1.48-.014.16-.03.237-.037.264a.5.5 0 0 1-.192.192 1.732 1.732 0 0 1-.265.037C8.163 8.998 7.733 9 7 9c-.733 0-1.163-.002-1.48-.027a1.732 1.732 0 0 1-.264-.037.5.5 0 0 1-.192-.192 1.733 1.733 0 0 1-.037-.265C5.002 8.163 5 7.733 5 7c0-.733.002-1.163.027-1.48.013-.16.03-.237.037-.264a.5.5 0 0 1 .192-.192c.027-.007.105-.024.265-.037C5.837 5.002 6.267 5 7 5c.733 0 1.163.002 1.48.027.16.013.237.03.264.037a.5.5 0 0 1 .192.192c.007.027.024.105.037.265C8.998 5.837 9 6.267 9 7ZM7 21c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C3 19.1 3 18.4 3 17c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.092C4.9 13 5.6 13 7 13c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092C11 14.9 11 15.6 11 17c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C9.1 21 8.4 21 7 21Zm2-4c0 .733-.002 1.163-.027 1.48a1.73 1.73 0 0 1-.037.264.5.5 0 0 1-.192.192 1.72 1.72 0 0 1-.265.037C8.163 18.998 7.733 19 7 19c-.733 0-1.163-.002-1.48-.027a1.74 1.74 0 0 1-.264-.037.5.5 0 0 1-.192-.192 1.73 1.73 0 0 1-.037-.265C5.002 18.163 5 17.733 5 17c0-.733.002-1.163.027-1.48.013-.16.03-.237.037-.264a.5.5 0 0 1 .192-.192 1.72 1.72 0 0 1 .265-.037C5.837 15.002 6.267 15 7 15c.733 0 1.163.002 1.48.027.16.014.237.03.264.037a.5.5 0 0 1 .192.192c.007.027.024.105.037.265.025.316.027.746.027 1.479ZM14.365 10.727C14.9 11 15.6 11 17 11c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C21 9.1 21 8.4 21 7c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.093C19.1 3 18.4 3 17 3c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.092 1.093C13 4.9 13 5.6 13 7c0 1.4 0 2.1.273 2.635a2.5 2.5 0 0 0 1.092 1.092Zm4.608-2.248C18.998 8.163 19 7.733 19 7c0-.733-.002-1.163-.027-1.48a1.74 1.74 0 0 0-.037-.264.5.5 0 0 0-.192-.192 1.73 1.73 0 0 0-.265-.037C18.163 5.002 17.733 5 17 5c-.733 0-1.163.002-1.48.027a1.73 1.73 0 0 0-.264.037.5.5 0 0 0-.192.192 1.74 1.74 0 0 0-.037.265C15.002 5.837 15 6.267 15 7c0 .733.002 1.163.027 1.48.014.16.03.237.037.264a.5.5 0 0 0 .192.192c.027.007.105.024.265.037.316.025.746.027 1.479.027.733 0 1.163-.002 1.48-.027.16-.014.237-.03.264-.037a.5.5 0 0 0 .192-.192 1.74 1.74 0 0 0 .037-.265ZM17 21c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.092-1.092C13 19.1 13 18.4 13 17c0-1.4 0-2.1.273-2.635a2.5 2.5 0 0 1 1.092-1.092C14.9 13 15.6 13 17 13c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092C21 14.9 21 15.6 21 17c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C19.1 21 18.4 21 17 21Zm2-4c0 .733-.002 1.163-.027 1.48-.014.16-.03.237-.037.264a.5.5 0 0 1-.192.192 1.717 1.717 0 0 1-.265.037c-.316.025-.746.027-1.479.027-.733 0-1.163-.002-1.48-.027a1.738 1.738 0 0 1-.264-.037.5.5 0 0 1-.192-.192 1.738 1.738 0 0 1-.037-.265C15.002 18.163 15 17.733 15 17c0-.733.002-1.163.027-1.48.014-.16.03-.237.037-.264a.5.5 0 0 1 .192-.192c.027-.007.105-.024.265-.037.316-.025.746-.027 1.479-.027.733 0 1.163.002 1.48.027.16.014.237.03.264.037a.5.5 0 0 1 .192.192c.007.027.023.105.037.265.025.316.027.746.027 1.479Z", fill: "currentColor" })] }));
}, G5 = o(T5), W5 = G5, D5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 38 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37 10.583c0 .766-.55 1.422-1.304 1.557l-16.06 2.868c-.42.075-.851.075-1.272 0L2.304 12.14a1.582 1.582 0 1 1 .556-3.115l15.504 2.769c.42.075.851.075 1.272 0L35.14 9.025c.97-.173 1.86.573 1.86 1.558Z", fill: "currentColor" })] }));
}, U5 = o(D5), q5 = U5, _5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 38 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37 12a1.5 1.5 0 0 1-1.5 1.5h-33a1.5 1.5 0 0 1 0-3h33A1.5 1.5 0 0 1 37 12Z", fill: "currentColor" })] }));
}, X5 = o(_5), Y5 = X5, K5 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 38 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 13.417c0-.766.55-1.422 1.304-1.557l16.06-2.868c.42-.075.851-.075 1.272 0l16.06 2.868a1.582 1.582 0 1 1-.556 3.115l-15.504-2.769a3.617 3.617 0 0 0-1.272 0L2.86 14.975A1.582 1.582 0 0 1 1 13.417Z", fill: "currentColor" })] }));
}, Q5 = o(K5), J5 = Q5, e3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.128 11.056c-.161.315-.22.673-.166 1.024l.222 1.459c.058.379-.015.766-.207 1.098l-1.26 2.182a.21.21 0 0 0 .077.288l3.032 1.75c.807.466 1.84.19 2.305-.617l.596-1.033c.143-.248.367-.44.634-.545a6.317 6.317 0 0 0 3.173-2.725l2.318-4.016a.623.623 0 0 0-1.08-.623l-1.245 2.158a.623.623 0 1 1-1.079-.622l2.7-4.676a.623.623 0 1 0-1.08-.623L14.37 10.21a.623.623 0 1 1-1.079-.622l2.284-3.957a.623.623 0 1 0-1.079-.623l-3.53 6.115a.623.623 0 1 1-1.079-.623L10.924 8.7a.623.623 0 0 0-1.079-.623L8.17 10.983a1.73 1.73 0 0 0-.04.073Zm3.566-4.57a2.31 2.31 0 0 0-3.31.749l-1.677 2.904a3.375 3.375 0 0 0-.413 2.195l.222 1.46-1.26 2.181a1.898 1.898 0 0 0 .695 2.593l3.032 1.75a3.374 3.374 0 0 0 4.61-1.235l.522-.905a8.005 8.005 0 0 0 3.88-3.398l2.318-4.015a2.31 2.31 0 0 0-1.006-3.24L19.609 7a2.31 2.31 0 0 0-2.906-3.28 2.312 2.312 0 0 0-3.669.444l-1.34 2.321Z", fill: "currentColor" }), n("path", { d: "M12.649 3.223a1.661 1.661 0 0 0-2.27.608L9.55 5.27c.775-.512 1.854.11 1.854.11l1.246-2.157ZM7.999 6.293a1.661 1.661 0 0 0-2.27.608l-1.83 3.17c-.245.425-.364.91-.314 1.397.056.541.155 1.285.323 1.91l-.685 1.187a1.661 1.661 0 0 0 .608 2.27l1.812-3.14a.228.228 0 0 0 .012-.2 4.555 4.555 0 0 1-.223-2.584c.043-.202.127-.392.23-.572L8 6.293Z", fill: "currentColor" })] }));
}, l3 = o(e3), t3 = l3, r3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.15 8.071c.29 1.63-.158 3.372-1.338 4.992-2.097 2.877-4.151 5.195-6.47 7.122a2.1 2.1 0 0 1-2.684 0c-2.319-1.927-4.373-4.245-6.47-7.122-1.16-1.595-1.628-3.304-1.341-4.916a5.176 5.176 0 0 1 2.518-3.574 5.348 5.348 0 0 1 4.287-.484c.84.265 1.607.733 2.26 1.387.661-.742 1.456-1.28 2.35-1.58 1.537-.518 3.13-.252 4.383.512a5.386 5.386 0 0 1 2.506 3.663Z", fill: "currentColor" })] }));
}, i3 = o(r3), a3 = i3, n3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.003 4.023a5.632 5.632 0 0 0-1.795.443c-.37.16-.843.437-1.13.663-.037.029-.112.088-.168.13A5.41 5.41 0 0 0 3.71 6.653c-.242.41-.408.812-.566 1.372-.03.106-.098.472-.123.66a9.508 9.508 0 0 0 0 1.238c.142 1.144.586 2.216 1.368 3.304a72.285 72.285 0 0 0 .916 1.223c.32.418.74.94 1.133 1.412l.358.43a45.87 45.87 0 0 1 .414.47 22.797 22.797 0 0 0 .603.666 31.8 31.8 0 0 0 2.597 2.497c.28.242.65.431 1.025.526.438.111.984.078 1.413-.087.289-.111.58-.29.795-.486.06-.056.182-.16.269-.234.164-.137.67-.608 1.103-1.025a35.23 35.23 0 0 0 2.518-2.724c.156-.18.58-.706.9-1.112a56.18 56.18 0 0 0 1.14-1.509c.024-.03.111-.155.195-.277.564-.829.93-1.654 1.117-2.526.078-.359.104-.596.114-1.017a4.932 4.932 0 0 0-.252-1.784c-.433-1.334-1.461-2.491-2.768-3.115a5.968 5.968 0 0 0-1.407-.46 5.12 5.12 0 0 0-.619-.073 5.252 5.252 0 0 0-2.335.37 5.406 5.406 0 0 0-1.477.913.671.671 0 0 1-.14.107.32.32 0 0 1-.095-.068 5.583 5.583 0 0 0-1.186-.801 5.707 5.707 0 0 0-1.549-.48A8.705 8.705 0 0 0 8.376 4a9.885 9.885 0 0 0-.373.023Zm.968 1.991c1.043.182 1.886.818 2.478 1.867.059.105.126.211.149.236.097.105.312.165.49.137a.586.586 0 0 0 .31-.138c.023-.024.074-.103.114-.175.32-.579.672-.992 1.164-1.364.087-.065.312-.2.451-.27.276-.138.618-.248.943-.302.24-.04.833-.04 1.065 0 .567.1 1.03.287 1.5.609.222.15.418.326.593.529.537.622.791 1.273.817 2.087.008.272.004.337-.046.668-.02.136-.111.505-.157.636-.129.37-.332.797-.524 1.103-.276.44-.987 1.389-1.746 2.332-.398.496-.393.49-.58.71a52.018 52.018 0 0 1-.806.927c-.068.075-.178.2-.244.275-.066.076-.13.141-.141.146a.648.648 0 0 0-.104.108c-.253.306-1.258 1.3-1.794 1.775-.144.127-.298.264-.342.305a2.689 2.689 0 0 1-.4.31.584.584 0 0 1-.169.022c-.152 0-.258-.052-.432-.21a34.43 34.43 0 0 0-.378-.336c-.635-.556-1.526-1.45-2.325-2.332a17.597 17.597 0 0 1-.473-.538c-.27-.31-.928-1.105-1.113-1.343l-.278-.358a37.577 37.577 0 0 1-1.225-1.65 5.054 5.054 0 0 1-.77-1.867c-.039-.214-.043-.273-.043-.602 0-.328.005-.388.043-.59a3.217 3.217 0 0 1 .764-1.57A3.582 3.582 0 0 1 8.04 5.983c.23-.023.716-.006.931.031Z", fill: "currentColor" })] }));
}, d3 = o(n3), o3 = d3, c3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.949 12.834a1 1 0 0 0 0 1.414l2.828 2.829a1 1 0 0 0 1.415 0l8.628-8.629a1 1 0 0 0 0-1.414l-2.828-2.828a1 1 0 0 0-1.415 0L7.95 12.834Zm2.348 4.897-2.97-2.97-3.18 3.18a.5.5 0 0 0 .002.707l1.411 1.407a.5.5 0 0 0 .352.146l1.703.004a.5.5 0 0 0 .354-.147l2.328-2.327Z", fill: "currentColor" })] }));
}, s3 = o(c3), h3 = s3, u3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m3.161 16.367 3-3a2.015 2.015 0 0 1 .525-1.939l6.717-6.717a4.516 4.516 0 0 1 6.386 6.386l-7.07 7.07a1.516 1.516 0 0 1-1.716.302l-1.876 1.876c-.381.381-.898.595-1.437.595H5.703a2.031 2.031 0 0 1-1.436-.595L3.16 19.24a2.031 2.031 0 0 1 0-2.873Zm4.254-1.381-2.817 2.817 1.105 1.106H7.69l1.824-1.824-2.1-2.1Zm4.243 1.37 6.695-6.695a2.484 2.484 0 1 0-3.514-3.514l-6.695 6.695 3.514 3.514Z", fill: "currentColor" })] }));
}, v3 = o(u3), f3 = v3, g3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8.5 20h8v-3c0-1.1-.392-2.042-1.175-2.825C14.542 13.392 13.6 13 12.5 13s-2.042.392-2.825 1.175C8.892 14.958 8.5 15.9 8.5 17v3Zm4-9c1.1 0 2.042-.392 2.825-1.175C16.108 9.042 16.5 8.1 16.5 7V4h-8v3c0 1.1.392 2.042 1.175 2.825C10.458 10.608 11.4 11 12.5 11Zm-7 11a.967.967 0 0 1-.713-.288A.968.968 0 0 1 4.5 21c0-.283.096-.52.287-.712A.967.967 0 0 1 5.5 20h1v-3c0-1.017.237-1.97.713-2.863A5.572 5.572 0 0 1 9.2 12a5.572 5.572 0 0 1-1.987-2.137A5.998 5.998 0 0 1 6.5 7V4h-1a.968.968 0 0 1-.713-.288A.968.968 0 0 1 4.5 3c0-.283.096-.52.287-.712A.968.968 0 0 1 5.5 2h14c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 19.5 4h-1v3c0 1.017-.238 1.97-.712 2.863A5.572 5.572 0 0 1 15.8 12a5.572 5.572 0 0 1 1.988 2.137c.474.892.712 1.846.712 2.863v3h1c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 19.5 22h-14Z", fill: "currentColor" })] }));
}, p3 = o(g3), w3 = p3, b3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8.5 20h8v-3c0-1.1-.392-2.042-1.175-2.825C14.542 13.392 13.6 13 12.5 13s-2.042.392-2.825 1.175C8.892 14.958 8.5 15.9 8.5 17v3Zm-3 2a.967.967 0 0 1-.713-.288A.968.968 0 0 1 4.5 21c0-.283.096-.52.287-.712A.967.967 0 0 1 5.5 20h1v-3c0-1.017.237-1.97.713-2.863A5.572 5.572 0 0 1 9.2 12a5.572 5.572 0 0 1-1.987-2.137A5.998 5.998 0 0 1 6.5 7V4h-1a.968.968 0 0 1-.713-.288A.968.968 0 0 1 4.5 3c0-.283.096-.52.287-.712A.968.968 0 0 1 5.5 2h14c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 19.5 4h-1v3c0 1.017-.238 1.97-.712 2.863A5.572 5.572 0 0 1 15.8 12a5.572 5.572 0 0 1 1.988 2.137c.474.892.712 1.846.712 2.863v3h1c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 19.5 22h-14Z", fill: "currentColor" })] }));
}, m3 = o(b3), x3 = m3, y3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M2 12.784v.657c0 4.035 0 6.052 1.25 7.306C4.5 22 6.513 22 10.537 22h2.926c4.024 0 6.036 0 7.287-1.253C22 19.493 22 17.476 22 13.44v-.658c0-2.234 0-3.35-.496-4.299-.496-.948-1.413-1.583-3.246-2.853l-2.56-1.773C13.912 2.619 13.018 2 12.004 2c-1.014 0-1.908.619-3.696 1.857L5.744 5.631C3.91 6.901 2.993 7.536 2.496 8.484 2 9.433 2 10.55 2 12.784Z", fill: "currentColor" })] }));
}, C3 = o(y3), k3 = C3, Z3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.699 3.908C13.91 2.67 13.017 2.051 12.003 2.05c-1.014 0-1.908.62-3.696 1.857L5.744 5.682C3.91 6.952 2.993 7.586 2.496 8.535 2 9.483 2 10.6 2 12.835v.656c0 4.035 0 6.053 1.25 7.306 1.25 1.253 3.263 1.253 7.287 1.253h2.926c4.024 0 6.036 0 7.287-1.253C22 19.544 22 17.527 22 13.491v-.658c0-2.234 0-3.35-.496-4.299-.496-.948-1.413-1.583-3.246-2.852l-2.56-1.774ZM4.134 12.835v.656c0 2.078.005 3.422.138 4.411.124.928.325 1.22.487 1.382.163.163.453.364 1.379.49.987.132 2.327.137 4.4.137h2.925c2.072 0 3.412-.005 4.4-.138.925-.125 1.215-.326 1.378-.489.162-.163.363-.454.487-1.382.133-.99.138-2.333.138-4.41v-.659c0-1.155-.003-1.879-.053-2.436-.047-.513-.126-.728-.2-.869-.073-.14-.205-.327-.6-.658-.427-.358-1.02-.771-1.968-1.428l-2.56-1.773c-.933-.647-1.491-1.03-1.936-1.27-.389-.21-.513-.209-.544-.209H12c-.03 0-.155 0-.544.209-.445.24-1.003.623-1.937 1.27L6.956 7.441c-.948.657-1.541 1.07-1.97 1.429-.394.33-.526.517-.6.658-.073.14-.152.356-.199.87-.05.556-.053 1.28-.053 2.436Z", fill: "currentColor" })] }));
}, M3 = o(Z3), z3 = M3, R3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9.346 14.272c.15.228.499.228 1.194.228h5.628c.81 0 1.215 0 1.36-.262.145-.261-.07-.605-.5-1.292l-.667-1.068c-.386-.618-.58-.928-.861-.928s-.475.31-.861.928l-.453.724-1.252-2.924c-.4-.931-.6-1.397-.934-1.397-.335 0-.534.466-.934 1.397l-1.46 3.406c-.273.64-.41.96-.26 1.188ZM18 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.879 3.379C6 4.257 6 5.672 6 8.5v3c0 2.828 0 4.243.879 5.121.878.879 2.293.879 5.121.879h3c2.828 0 4.243 0 5.121-.879C21 15.743 21 14.328 21 11.5v-3c0-2.828 0-4.243-.879-5.121C19.243 2.5 17.828 2.5 15 2.5h-3c-2.828 0-4.243 0-5.121.879ZM18.02 4.623c-.65-.087-1.55-.092-3.021-.092h-3c-1.472 0-2.371.005-3.021.092-.301.04-.466.09-.554.126a.292.292 0 0 0-.11.066.292.292 0 0 0-.066.11 2.313 2.313 0 0 0-.126.554c-.087.65-.092 1.55-.092 3.021v3c0 1.472.005 2.371.092 3.021.04.301.09.466.126.554.03.072.05.095.066.11a.292.292 0 0 0 .11.066c.088.036.253.085.554.126.65.087 1.55.092 3.021.092h3c1.472 0 2.371-.005 3.021-.092.301-.04.466-.09.554-.126a.292.292 0 0 0 .11-.066.292.292 0 0 0 .066-.11c.036-.088.085-.253.126-.554.087-.65.092-1.55.092-3.021v-3c0-1.472-.005-2.371-.092-3.021a2.313 2.313 0 0 0-.126-.554.292.292 0 0 0-.066-.11.292.292 0 0 0-.11-.066 2.313 2.313 0 0 0-.554-.126Z", fill: "currentColor" }), n("path", { d: "M2 8.5c0-1 1-2 2-2v9a4 4 0 0 0 4 4h9c0 1-.887 2-2 2H8a6 6 0 0 1-6-6v-7Z", fill: "currentColor" })] }));
}, I3 = o(R3), S3 = I3, B3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.109 3H8.89c-1.63 0-3.475-.073-4.72 1.172C2.928 5.416 3 7.262 3 8.892v6.217c0 1.63-.073 3.475 1.172 4.72C5.416 21.072 7.262 21 8.892 21h6.217c1.63 0 3.475.073 4.72-1.172 1.244-1.244 1.171-3.09 1.171-4.72V8.892c0-1.63.073-3.475-1.172-4.72C18.584 2.928 16.738 3 15.108 3ZM5 9c0-1.886 0-2.828.586-3.414C6.172 5 7.114 5 9 5h6c1.886 0 2.828 0 3.414.586C19 6.172 19 7.114 19 9v6c0 1.886 0 2.828-.586 3.414C17.828 19 16.886 19 15 19H9c-1.886 0-2.828 0-3.414-.586C5 17.828 5 16.886 5 15V9Z", fill: "currentColor" }), n("path", { d: "M7.075 16.743c.182.257.601.257 1.44.257h6.79c.977 0 1.466 0 1.64-.294.175-.295-.084-.682-.602-1.455l-.805-1.202c-.466-.697-.7-1.045-1.039-1.045-.34 0-.573.348-1.039 1.045l-.546.814-1.511-3.29C10.92 10.523 10.68 10 10.277 10c-.404 0-.645.524-1.127 1.572l-1.76 3.834c-.331.72-.497 1.08-.315 1.337ZM17 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", fill: "currentColor" })] }));
}, N3 = o(B3), A3 = N3, H3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.16 11.988a1.389 1.389 0 0 1-.242-.057c-.298-.09-.5-.335-.505-.614v-3.503c-.018-.34.222-.65.587-.759.389-.132.83-.02 1.08.272a.639.639 0 0 1 .16.432v1.74c0 .564-.013 1.128 0 1.693a.765.765 0 0 1-.325.624.998.998 0 0 1-.755.172Zm.14-6.025a.982.982 0 1 1 .009 0h-.008Z", fill: "currentColor" })] }));
}, V3 = o(H3), $3 = V3, L3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.047 19.047a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 2a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), n("path", { d: "M11 12.188a1.016 1.016 0 0 1 2.031 0v3.046a1.016 1.016 0 0 1-2.031 0v-3.046ZM13.031 9.14a1.016 1.016 0 1 1-2.03 0 1.016 1.016 0 0 1 2.03 0Z", fill: "currentColor" })] }));
}, O3 = o(L3), F3 = O3, P3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9 11.995a3 3 0 1 1 5.999.001A3 3 0 0 1 9 11.995Zm-1.621 0A4.62 4.62 0 0 0 12 16.614a4.62 4.62 0 1 0 0-9.238 4.62 4.62 0 0 0-4.621 4.619Zm8.346-4.802a1.079 1.079 0 0 0 2.14.211 1.078 1.078 0 0 0-1.06-1.29 1.08 1.08 0 0 0-1.08 1.079Zm-7.36 12.124c-.878-.04-1.355-.186-1.672-.31a2.798 2.798 0 0 1-1.035-.673 2.775 2.775 0 0 1-.674-1.034c-.123-.316-.27-.793-.31-1.67-.043-.948-.052-1.233-.052-3.635 0-2.402.01-2.686.053-3.635.04-.877.187-1.353.31-1.67.163-.42.358-.72.673-1.035.314-.315.614-.51 1.035-.673.317-.123.794-.27 1.671-.31C9.313 4.63 9.598 4.62 12 4.62c2.403 0 2.688.01 3.638.053.877.04 1.353.187 1.671.31.42.162.72.357 1.035.672.316.315.51.615.673 1.035.124.316.27.793.31 1.67.044.949.052 1.233.052 3.635 0 2.402-.008 2.686-.052 3.635-.04.877-.187 1.354-.31 1.67-.163.42-.358.72-.673 1.034-.315.315-.615.51-1.035.673-.317.124-.794.27-1.671.31-.95.043-1.234.052-3.638.052-2.403 0-2.687-.009-3.636-.052ZM8.29 3.054c-.958.044-1.613.196-2.185.418A4.415 4.415 0 0 0 4.511 4.51c-.501.5-.809 1.001-1.038 1.593-.223.572-.375 1.226-.418 2.184C3.01 9.246 3 9.552 3 11.995c0 2.443.01 2.75.055 3.708.043.958.195 1.612.418 2.184.23.591.537 1.093 1.038 1.593.5.5 1.002.807 1.594 1.038.573.222 1.227.374 2.185.417.96.044 1.266.055 3.71.055 2.445 0 2.751-.01 3.711-.055.958-.043 1.612-.195 2.185-.417a4.424 4.424 0 0 0 1.594-1.038c.501-.5.808-1.002 1.038-1.593.223-.572.375-1.226.418-2.184.044-.96.054-1.265.054-3.708 0-2.443-.01-2.75-.054-3.708-.043-.958-.195-1.612-.418-2.184A4.422 4.422 0 0 0 19.49 4.51c-.5-.5-1.002-.808-1.594-1.038-.573-.222-1.227-.375-2.184-.418-.96-.043-1.267-.054-3.71-.054-2.445 0-2.752.01-3.712.054Z", fill: "currentColor" })] }));
}, j3 = o(P3), E3 = j3, T3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M20 7v10H4V7h16Zm0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-9 3h2v2h-2V8Zm0 3h2v2h-2v-2ZM8 8h2v2H8V8Zm0 3h2v2H8v-2Zm-3 0h2v2H5v-2Zm0-3h2v2H5V8Zm3 6h8v2H8v-2Zm6-3h2v2h-2v-2Zm0-3h2v2h-2V8Zm3 3h2v2h-2v-2Zm0-3h2v2h-2V8Z", fill: "currentColor" })] }));
}, G3 = o(T3), W3 = G3, D3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14.055 20.623c.611 0 .938-.313 1.167-1.118l.323-.994a.2.2 0 0 1 .19-.138h2.895a.2.2 0 0 1 .19.14l.317.992c.23.784.584 1.118 1.194 1.118.66 0 1.09-.39 1.09-.993 0-.243-.062-.52-.187-.91l-2.09-6.144c-.381-1.132-.91-1.576-1.909-1.576-1 0-1.541.451-1.916 1.576l-2.097 6.144c-.16.466-.222.73-.222.958 0 .556.43.945 1.055.945Zm2.276-3.91a.2.2 0 0 1-.192-.257l.983-3.278a.074.074 0 0 1 .143 0l.97 3.28a.2.2 0 0 1-.192.256h-1.712ZM16 6a1 1 0 1 1 0 2h-.85a.257.257 0 0 0-.25.207c-.409 1.997-1.698 3.803-2.98 5.354a.247.247 0 0 0 .039.355c.328.248.684.494 1.071.736a1 1 0 0 1-1.06 1.696c-.5-.312-.955-.632-1.372-.954a.254.254 0 0 0-.338.025 39.85 39.85 0 0 1-3.628 3.356 1.01 1.01 0 0 1-1.413-.15 1 1 0 0 1 .156-1.406c1.2-.964 2.332-2.03 3.399-3.14a.251.251 0 0 0 0-.346c-.926-.99-1.787-2.12-2.222-3.415a1 1 0 0 1 1.895-.64c.336.931.97 1.784 1.637 2.522.1.112.277.107.372-.009.934-1.133 1.93-2.453 2.36-3.885A.24.24 0 0 0 12.582 8H4a1 1 0 0 1 0-2h4.75A.25.25 0 0 0 9 5.75V5a1 1 0 0 1 2 0v.75c0 .138.112.25.25.25H16Z", fill: "currentColor" })] }));
}, U3 = o(D3), q3 = U3, _3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.892 14.553c.568.637 1.4 1.57 1.608 2.447v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3c.21-.877 1.042-1.812 1.61-2.45.137-.154.26-.291.354-.406a6.784 6.784 0 0 0 1.49-3.508 6.734 6.734 0 0 0-.644-3.747 6.907 6.907 0 0 0-2.582-2.836A7.107 7.107 0 0 0 12.001 3c-1.319 0-2.61.365-3.727 1.052A6.907 6.907 0 0 0 5.69 6.887a6.735 6.735 0 0 0-.646 3.747c.15 1.284.666 2.5 1.49 3.508.095.116.218.255.357.41Zm3.554 1.984.054.228V17h3v-.235l.055-.229c.236-.994.845-1.849 1.274-2.392.236-.298.473-.57.665-.786l.144-.162c.128-.144.213-.239.278-.319a4.785 4.785 0 0 0 1.052-2.473 4.734 4.734 0 0 0-.454-2.635 4.906 4.906 0 0 0-1.835-2.013A5.108 5.108 0 0 0 12 5c-.95 0-1.88.263-2.678.755a4.907 4.907 0 0 0-1.837 2.013 4.735 4.735 0 0 0-.454 2.635c.104.9.467 1.758 1.051 2.473.066.08.151.176.281.322l.14.158c.193.218.43.488.666.787.43.543 1.039 1.399 1.276 2.394ZM10.5 20v-1h3v1h-3Z", fill: "currentColor" })] }));
}, X3 = o(_3), Y3 = X3, K3 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 8a1.5 1.5 0 0 0 0-3h-11a1.5 1.5 0 1 0 0 3h11Zm1.5 4.5a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1 0-3h11a1.5 1.5 0 0 1 1.5 1.5Zm0 6a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1 0-3h11a1.5 1.5 0 0 1 1.5 1.5Z", fill: "currentColor" })] }));
}, Q3 = o(K3), J3 = Q3, ei = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 7a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2h12Zm1 5a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1Zm0 6a1 1 0 0 1-1 1H6a1 1 0 1 1 0-2h12a1 1 0 0 1 1 1Z", fill: "currentColor" })] }));
}, li = o(ei), ti = li, ri = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Zm0-6a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2H5Zm0 12a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Z", fill: "currentColor" })] }));
}, ii = o(ri), ai = ii, ni = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Zm0-8a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2H5Zm0 16a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Z", fill: "currentColor" })] }));
}, di = o(ni), oi = di, ci = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Zm0-4a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2H5Zm0 8a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2H5Z", fill: "currentColor" })] }));
}, si = o(ci), hi = si, ui = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 13a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2H6Z", fill: "currentColor" })] }));
}, vi = o(ui), fi = vi, gi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("g", { clipPath: "url(#a)", children: n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 11.5C4 8.073 7.403 5 12 5c4.597 0 8 3.073 8 6.5 0 1.685-.914 3.313-2.551 4.817-1.37 1.258-3.181 2.364-5.164 3.262a2.801 2.801 0 0 0-.458-1.201c-.363-.515-.92-.867-1.655-.996C6.435 16.73 4 14.4 4 11.5ZM12 3C6.656 3 2 6.643 2 11.5c0 4.24 3.549 7.106 7.828 7.852.367.064.459.286.493.635.047.466-.055.964.153 1.4.249.522.863.755 1.397.541 2.571-1.028 5.063-2.423 6.93-4.138C20.664 16.08 22 13.957 22 11.5 22 6.643 17.344 3 12 3Zm.268 6.36A1 1 0 0 0 10.5 10v3a1 1 0 0 0 2 0v-.238l.732.878A1 1 0 0 0 15 13v-3a1 1 0 0 0-2 0v.238l-.732-.878ZM7 10a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2v-2Zm2-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm9 2h-.134a.995.995 0 0 1 0 1H18a1 1 0 0 1 0 2h-1.5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1H18a1 1 0 1 1 0 2Z", fill: "currentColor" }) }), n("defs", { children: n("clipPath", { id: "a", children: n("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })] }));
}, pi = o(gi), wi = pi, bi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M2 12a5 5 0 0 1 5-5h3a1 1 0 1 1 0 2H7a3 3 0 1 0 0 6h3a1 1 0 1 1 0 2H7a5 5 0 0 1-5-5ZM22 12a5 5 0 0 1-5 5h-3a1 1 0 1 1 0-2h3a3 3 0 1 0 0-6h-3a1 1 0 1 1 0-2h3a5 5 0 0 1 5 5Z", fill: "currentColor" }), n("path", { d: "M9 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z", fill: "currentColor" })] }));
}, mi = o(bi), xi = mi, yi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M17 13.13v3.697h-2.143v-3.45c0-.866-.31-1.457-1.086-1.457-.592 0-.945.398-1.1.784-.056.138-.071.33-.071.522v3.601h-2.144s.029-5.842 0-6.447H12.6v.913l-.014.021h.014v-.021c.285-.44.793-1.065 1.932-1.065 1.41 0 2.468.922 2.468 2.902ZM8.213 7.271C7.48 7.271 7 7.753 7 8.385c0 .62.466 1.115 1.185 1.115h.014c.748 0 1.213-.496 1.213-1.115-.014-.632-.465-1.114-1.199-1.114Zm-1.086 9.556h2.144V10.38H7.127v6.447Z", fill: "currentColor" }), n("path", { d: "M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Z", fill: "currentColor" })] }));
}, Ci = o(yi), ki = Ci, Zi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM8 7a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM8 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 16a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H9ZM6.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM5 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "currentColor" })] }));
}, Mi = o(Zi), zi = Mi, Ri = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M7 6a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM7 10a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM7 14a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM7 18a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor" })] }));
}, Ii = o(Ri), Si = Ii, Bi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.156 2.01c-.385.034-.69.126-1.262.382-.128.058-11.95 5.97-12.147 6.074-.58.31-.94.582-1.202.907-.296.369-.455.75-.525 1.263a2.602 2.602 0 0 0 .724 2.118l.179.155c.27.237.634.412 1.063.513.395.093.443.095 2.524.106l1.947.01.011 1.902c.007 1.236.018 1.968.032 2.091.061.559.196.976.434 1.34.104.159.346.418.533.57a2.581 2.581 0 0 0 2.025.523c.532-.094.943-.31 1.337-.7.228-.227.38-.433.584-.786.127-.223 6.069-12.09 6.222-12.43.203-.449.295-.742.343-1.09.035-.251.027-.577-.019-.82-.136-.718-.607-1.381-1.256-1.772a2.55 2.55 0 0 0-1.547-.356Zm.365 2.142a.667.667 0 0 1 .174.106c.18.155.214.337.119.63-.062.189-6.101 12.284-6.29 12.598-.14.232-.208.307-.314.354a.359.359 0 0 1-.314-.008c-.173-.076-.236-.184-.268-.454-.008-.07-.015-1.19-.016-2.49 0-2.386-.006-2.622-.067-2.843a.976.976 0 0 0-.42-.522 1.172 1.172 0 0 0-.235-.088l-.153-.04-2.596-.01c-2.399-.01-2.604-.013-2.704-.043a.644.644 0 0 1-.153-.064c-.106-.077-.182-.298-.147-.428.042-.155.098-.207.435-.406.164-.097 11.678-5.866 12.107-6.067.32-.15.38-.174.522-.214.172-.05.208-.05.32-.01Z", fill: "currentColor" })] }));
}, Ni = o(Bi), Ai = Ni, Hi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 8a3 3 0 1 1 6 0v1H9V8ZM7 9H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-1V8A5 5 0 0 0 7 8v1Z", fill: "currentColor" })] }));
}, Vi = o(Hi), $i = Vi, Li = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M13.5 13.5a1.5 1.5 0 0 1-.75 1.3v.45a.75.75 0 0 1-1.5 0v-.45a1.5 1.5 0 1 1 2.25-1.3Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 8a4 4 0 1 1 8 0v1c.711 0 1.23.162 1.826.62a3 3 0 0 1 .554.554c.62.808.62 1.98.62 4.326 0 2.346 0 3.518-.62 4.326a3 3 0 0 1-.554.554c-.808.62-.98.62-3.326.62h-5c-2.346 0-2.518 0-3.326-.62a3 3 0 0 1-.554-.554C5 18.018 5 16.846 5 14.5c0-2.346 0-3.518.62-4.326a3 3 0 0 1 .554-.554C6.9 9.062 7.5 9 8 9V8Zm4-2a2 2 0 0 1 2 2v1h-4V8a2 2 0 0 1 2-2Zm-2.5 5c-.994 0-1.01.002-1.28.036-.06.008-.134.018-.236.029a2.45 2.45 0 0 0-.488.093c-.073.024-.097.043-.105.049-.069.053-.131.115-.184.184-.006.008-.024.032-.05.105a2.448 2.448 0 0 0-.092.488C7.003 12.534 7 13.281 7 14.5c0 1.22.003 1.966.065 2.516.029.255.064.403.093.488a.336.336 0 0 0 .049.105c.053.069.115.131.184.184.008.006.032.024.105.05.085.028.233.063.488.092.102.012.176.02.237.029.27.034.285.036 1.279.036h5c.994 0 1.01-.002 1.28-.036l.236-.029c.255-.029.403-.064.488-.093.073-.024.097-.043.105-.048.069-.054.131-.116.184-.185.006-.008.024-.032.05-.105.028-.085.063-.233.092-.488.062-.55.065-1.297.065-2.516 0-1.22-.003-1.966-.065-2.516a2.451 2.451 0 0 0-.093-.488c-.024-.073-.043-.097-.048-.105a1.004 1.004 0 0 0-.185-.184c-.008-.006-.032-.025-.105-.05a2.451 2.451 0 0 0-.488-.092c-.102-.011-.176-.021-.237-.029-.27-.034-.285-.036-1.279-.036h-5Z", fill: "currentColor" })] }));
}, Oi = o(Li), Fi = Oi, Pi = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.79 18.155a7.5 7.5 0 1 1 6.316-3.455l2.964 2.965a1.5 1.5 0 1 1-2.12 2.12l-2.934-2.933a7.465 7.465 0 0 1-4.227 1.303Zm0-3.046a4.453 4.453 0 1 1 0-8.907 4.453 4.453 0 0 1 0 8.907Z", fill: "currentColor" })] }));
}, ji = o(Pi), Ei = ji, Ti = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 19a7.5 7.5 0 1 1 5.963-2.95l3.336 3.335a1 1 0 0 1-1.414 1.414l-3.336-3.336A7.467 7.467 0 0 1 10.5 19Zm0-2.031a5.469 5.469 0 1 1 0-10.938 5.469 5.469 0 0 1 0 10.938Z", fill: "currentColor" })] }));
}, Gi = o(Ti), Wi = Gi, Di = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.984 9.3A7.311 7.311 0 0 1 12.3 1.984 7.311 7.311 0 0 1 19.616 9.3c0 2.154-1.107 4.568-2.306 6.588-1.224 2.06-2.653 3.886-3.499 4.908a1.954 1.954 0 0 1-3.022 0c-.846-1.022-2.275-2.848-3.499-4.908-1.199-2.02-2.306-4.434-2.306-6.588ZM12.3 4.016A5.28 5.28 0 0 0 7.016 9.3c0 1.57.85 3.577 2.02 5.55 1.124 1.891 2.446 3.593 3.264 4.586.818-.993 2.14-2.695 3.263-4.585 1.172-1.974 2.021-3.982 2.021-5.551A5.28 5.28 0 0 0 12.3 4.016Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 10.05a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001Z", fill: "currentColor" })] }));
}, Ui = o(Di), qi = Ui, _i = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6.72a1 1 0 0 1 .684-.948l4.684-1.561a2 2 0 0 1 1.265 0l4.735 1.578a2 2 0 0 0 1.264 0l4.052-1.35A1 1 0 0 1 21 5.387V17.28a1 1 0 0 1-.684.949l-4.683 1.561a2 2 0 0 1-1.265 0l-4.735-1.578a2 2 0 0 0-1.265 0l-4.052 1.35A1 1 0 0 1 3 18.613V6.72Zm2.328 10.397A.25.25 0 0 1 5 16.879V7.622a.25.25 0 0 1 .171-.237l2.5-.834A.25.25 0 0 1 8 6.788v9.266a.25.25 0 0 1-.172.238l-2.5.825ZM10 16.054a.25.25 0 0 0 .171.238c.555.182 2.337.77 3.5 1.157a.25.25 0 0 0 .329-.237V7.946a.249.249 0 0 0-.171-.238c-.555-.183-2.337-.77-3.5-1.157a.25.25 0 0 0-.329.237v9.266Zm6.33 1.395a.25.25 0 0 1-.33-.237V7.946a.25.25 0 0 1 .172-.238l2.5-.825a.25.25 0 0 1 .328.238v9.257a.25.25 0 0 1-.17.237l-2.5.834Z", fill: "currentColor" })] }));
}, Xi = o(_i), Yi = Xi, Ki = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12.5 17Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 6.881c0-1.757 0-2.635.357-3.3a3 3 0 0 1 1.225-1.224C7.246 2 8.124 2 9.882 2h5.237c1.757 0 2.635 0 3.3.357a3 3 0 0 1 1.224 1.225c.357.664.357 1.542.357 3.3 0 .414 0 .622-.07.8-.055.141-.14.268-.25.37-.14.132-.333.21-.719.364L15.573 9.77a6.5 6.5 0 1 1-6.146 0L6.039 8.416c-.386-.155-.579-.232-.718-.363a1.016 1.016 0 0 1-.251-.37C5 7.504 5 7.296 5 6.88Zm2.992-2.844C8.409 4.002 8.968 4 9.882 4h5.237c.913 0 1.472.002 1.89.037.194.017.31.038.382.055a.596.596 0 0 1 .065.02l.004.001a1 1 0 0 1 .428.43.593.593 0 0 1 .02.066c.017.071.038.188.055.383.032.38.036.878.037 1.654l-5.5 2.2-5.5-2.2c0-.776.005-1.274.037-1.654.017-.195.038-.312.055-.383a.595.595 0 0 1 .02-.065l.001-.004.006-.013a1 1 0 0 1 .408-.408l.017-.007a.595.595 0 0 1 .065-.02c.071-.017.188-.038.383-.055ZM12.5 19.97a4.469 4.469 0 1 0 0-8.938 4.469 4.469 0 0 0 0 8.938Z", fill: "currentColor" })] }));
}, Qi = o(Ki), Ji = Qi, ea = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8 9h8m-8 4h6m4-9a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, la = o(ea), ta = la, ra = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.5A3.5 3.5 0 0 0 8.5 7v4a3.5 3.5 0 1 0 7 0V7A3.5 3.5 0 0 0 12 3.5Zm0 9a1.5 1.5 0 0 0 1.5-1.5V7a1.5 1.5 0 0 0-3 0v4a1.5 1.5 0 0 0 1.5 1.5Z", fill: "currentColor" }), n("path", { d: "M5 11a7.001 7.001 0 0 0 6 6.93V20h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-2.07A7.001 7.001 0 0 0 19 11v-1a1 1 0 1 0-2 0v1a5 5 0 0 1-10 0v-1a1 1 0 0 0-2 0v1Z", fill: "currentColor" })] }));
}, ia = o(ra), aa = ia, na = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.969A6.969 6.969 0 1 0 12 5.03a6.969 6.969 0 0 0 0 13.938ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), n("path", { d: "M8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z", fill: "currentColor" })] }));
}, da = o(na), oa = da, ca = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.924 11.075c.548 0 .991-.455.991-1.018 0 .563.445 1.018.992 1.018-.547 0-.992.457-.992 1.018 0-.562-.443-1.018-.991-1.018Zm-3.77-4.827a2.5 2.5 0 0 0 2.5-2.5 2.5 2.5 0 0 0 2.5 2.5 2.5 2.5 0 0 0-2.5 2.5 2.5 2.5 0 0 0-2.5-2.5Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.24 6.633A8.494 8.494 0 0 0 4 11.075c0 4.645 3.66 8.363 8.125 8.363a7.934 7.934 0 0 0 4.83-1.638c-.6.116-1.22.177-1.854.177-5.509 0-9.927-4.57-9.927-10.157 0-.402.022-.798.067-1.187Zm2.874-3.244c.06.306-.009.584-.112.796a8.316 8.316 0 0 0-.828 3.635c0 4.531 3.57 8.157 7.926 8.157a7.71 7.71 0 0 0 3.928-1.071c.373-.22 1.023-.337 1.516.147.51.5.38 1.169.149 1.544-1.787 2.9-4.949 4.84-8.568 4.84C6.507 21.438 2 16.777 2 11.075c0-3.423 1.624-6.464 4.133-8.35.327-.247.909-.444 1.455-.104.276.173.464.45.526.768Z", fill: "currentColor" })] }));
}, sa = o(ca), ha = sa, ua = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.005 22a3.004 3.004 0 0 1-3.004-3v-6.91L4 6c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 4h1V3c0-.283.096-.52.287-.712A.968.968 0 0 1 8 2c.283 0 .52.096.713.288.191.191.287.429.287.712v1h7V3c0-.283.096-.52.288-.712A.968.968 0 0 1 17 2c.283 0 .52.096.712.288.192.191.288.429.288.712v1h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v13c0 1.657-1.341 3-2.998 3H7.005ZM10 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm-3 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-.5 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-.5 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-3-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z", fill: "currentColor" })] }));
}, va = o(ua), fa = va, ga = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9.5 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM6.5 13.5A.5.5 0 0 1 7 13h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-1ZM6.5 16.5A.5.5 0 0 1 7 16h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-1ZM10 13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM9.5 16.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM13 13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM12.5 16.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM16 13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM13 10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM15.5 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v1.076c-.975.096-1.631.313-2.121.803C3.5 5.757 3.5 7.172 3.5 10v6c0 2.828 0 4.243.879 5.121C5.257 22 6.672 22 9.5 22h5c2.828 0 4.243 0 5.121-.879.879-.878.879-2.293.879-5.121v-6c0-2.828 0-4.243-.879-5.121-.49-.49-1.146-.707-2.121-.803V3a1 1 0 1 0-2 0v1.002C15.188 4 14.855 4 14.5 4h-5c-.355 0-.688 0-1 .002V3a1 1 0 0 0-1-1Zm10.908 6.975c.088.652.092 1.554.092 3.025v4c0 1.47-.004 2.373-.092 3.025-.077.574-.187.67-.2.681v.001l-.002.001c-.011.013-.107.123-.68.2-.653.088-1.555.092-3.026.092h-5c-1.47 0-2.373-.004-3.025-.092-.574-.077-.67-.187-.681-.2h-.001l-.001-.002c-.013-.011-.123-.107-.2-.68C5.504 18.372 5.5 17.47 5.5 16v-4c0-1.47.004-2.373.092-3.025.077-.574.187-.67.2-.681v-.001l.002-.001c.011-.013.107-.123.68-.2C7.128 8.004 8.03 8 9.5 8h5c1.47 0 2.373.004 3.025.092.574.077.67.187.681.2h.001l.001.002c.013.011.123.107.2.68Z", fill: "currentColor" })] }));
}, pa = o(ga), wa = pa, ba = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.06 2.94a1.5 1.5 0 0 1 0 2.12l-6.333 6.334a1 1 0 0 0-.04 1.371l6.434 7.238a1.5 1.5 0 1 1-2.242 1.994L7.505 13.7a2.5 2.5 0 0 1 .101-3.428l7.333-7.334a1.5 1.5 0 0 1 2.122 0Z", fill: "currentColor" })] }));
}, ma = o(ba), xa = ma, ya = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 4.531h-3c-1.472 0-2.371.005-3.021.092-.301.04-.466.09-.554.126a.292.292 0 0 0-.11.066.292.292 0 0 0-.066.11 2.313 2.313 0 0 0-.126.554c-.087.65-.092 1.55-.092 3.021v3c0 1.472.005 2.371.092 3.021.04.301.09.466.126.554.03.072.05.095.066.11a.292.292 0 0 0 .11.066c.088.036.253.085.554.126.65.087 1.55.092 3.021.092h3c1.472 0 2.371-.005 3.021-.092.301-.04.466-.09.554-.126a.292.292 0 0 0 .11-.066.292.292 0 0 0 .066-.11c.036-.088.085-.253.126-.554.087-.65.092-1.55.092-3.021v-3c0-1.472-.005-2.371-.092-3.021a2.313 2.313 0 0 0-.126-.554.292.292 0 0 0-.066-.11.292.292 0 0 0-.11-.066 2.313 2.313 0 0 0-.554-.126c-.65-.087-1.55-.092-3.021-.092ZM7.879 3.38C7 4.257 7 5.672 7 8.5v3c0 2.828 0 4.243.879 5.121.878.879 2.293.879 5.121.879h3c2.828 0 4.243 0 5.121-.879C22 15.743 22 14.328 22 11.5v-3c0-2.828 0-4.243-.879-5.121C20.243 2.5 18.828 2.5 16 2.5h-3c-2.828 0-4.243 0-5.121.879Z", fill: "currentColor" }), n("path", { d: "M5 5.5v10a4 4 0 0 0 4 4h10c0 1-.887 2-2 2H9a6 6 0 0 1-6-6v-8c0-1 1-2 2-2Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.172 7.625c0-.56.455-1.016 1.015-1.016h5.079a1.016 1.016 0 0 1 0 2.032h-5.078c-.561 0-1.016-.455-1.016-1.016ZM11.172 11.688c0-.561.455-1.016 1.015-1.016h4.063a1.016 1.016 0 0 1 0 2.031h-4.063c-.56 0-1.015-.455-1.015-1.015Z", fill: "currentColor" })] }));
}, Ca = o(ya), ka = Ca, Za = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9.2 13.3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-.7-2.6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 7.55a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm2 3.95a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 16c3.5 1.5 7-.5 7-4a9 9 0 1 0-9 9c1.872 0 1.396-1.752.995-3.227C12.624 16.407 12.317 15.28 14 16Zm-2.762 2.959A7.001 7.001 0 1 1 19 12c0 1.025-.484 1.741-1.18 2.139-.72.41-1.805.548-3.032.023-.489-.21-1.254-.487-2.064-.35a2.382 2.382 0 0 0-1.393.762 2.48 2.48 0 0 0-.583 1.229c-.107.608.005 1.204.075 1.532.115.547.284 1.08.415 1.624Z", fill: "currentColor" })] }));
}, Ma = o(Za), za = Ma, Ra = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.082 20.304 15.081-6.314c1.783-.746 1.783-3.215 0-3.96L6.083 3.714C4.386 3.005 2.5 4.221 2.5 6.023v3.93c0 .79.313 1.516.829 2.057a2.975 2.975 0 0 0-.829 2.057v3.93c0 1.802 1.887 3.017 3.582 2.307ZM5.275 5.556l15.08 6.314a.151.151 0 0 1 0 .28l-15.08 6.314a.52.52 0 0 1-.725-.468v-3.93c0-.526.412-.966.949-1.012l7.379-.636a.414.414 0 0 0 .383-.408.414.414 0 0 0-.383-.409l-7.379-.636a1.026 1.026 0 0 1-.95-1.013V6.023a.52.52 0 0 1 .726-.467Z", fill: "currentColor" })] }));
}, Ia = o(Ra), Sa = Ia, Ba = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 4A2.5 2.5 0 0 0 14 6.5v11a2.5 2.5 0 0 0 5 0v-11A2.5 2.5 0 0 0 16.5 4Zm-9 0A2.5 2.5 0 0 0 5 6.5v11a2.5 2.5 0 0 0 5 0v-11A2.5 2.5 0 0 0 7.5 4Z", fill: "currentColor" })] }));
}, Na = o(Ba), Aa = Na, Ha = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.334 15.666a1 1 0 0 0 1 1h1.364a1 1 0 0 0 .707-.293l7.898-7.899-2.777-2.777-7.899 7.899a1 1 0 0 0-.293.707v1.363Zm13.117-9.34a.738.738 0 0 0 0-1.044L14.718 3.55a.738.738 0 0 0-1.044 0l-1.356 1.356 2.778 2.777 1.355-1.355Z", fill: "currentColor" })] }));
}, Va = o(Ha), $a = Va, La = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m20.056 4.853-1.061-1.06a3 3 0 0 0-4.243 0l-9.676 9.676a3 3 0 0 0-.833 1.6l-.451 2.554a2.1 2.1 0 0 0 2.433 2.433l2.554-.45a3 3 0 0 0 1.6-.834l9.677-9.676a3 3 0 0 0 0-4.243ZM6.49 14.883a1 1 0 0 0-.278.533l-.45 2.554a.1.1 0 0 0 .115.116l2.555-.45a1 1 0 0 0 .533-.278l6.457-6.458-2.474-2.475-6.458 6.458Zm7.872-7.872 2.475 2.475 1.804-1.805a1 1 0 0 0 0-1.414l-1.06-1.06a1 1 0 0 0-1.414 0L14.362 7.01Z", fill: "currentColor" })] }));
}, Oa = o(La), Fa = Oa, Pa = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.476 5.016c-.687.044-1.44.352-1.994.815-.984.82-1.518 2.002-1.519 3.359 0 1.093.28 2.249.772 3.184.143.271.327.578.441.734.328.448.028.572-.375.77-.487.238-1.087.458-1.865.683-.623.18-.738.232-1.056.471-.444.334-.759.86-.85 1.421-.04.252-.04 1.083.001 1.283.11.53.486.956 1.013 1.144 0 0 .127.044.21.067.084.021 1.139 0 1.139 0l1.177.005.01-.608c.007-.53.014-.631.051-.795a3.85 3.85 0 0 0 .047-.227c.004-.039-.01-.04-.982-.05-.543-.005-.99-.012-.992-.014a3.981 3.981 0 0 1-.004-.276c0-.41.124-.62.524-.736.978-.28 1.798-.581 2.376-.87 1.08-.54 1.497-1.088 1.454-1.913-.025-.479-.168-.855-.536-1.404-.517-.772-.762-1.525-.858-2.635-.094-1.092.535-2.186 1.566-2.593a2.145 2.145 0 0 1 1.58.032c.164.069.186.079.318-.044a5.36 5.36 0 0 1 1.116-.787c.119-.061.216-.118.216-.128 0-.255-1.107-.658-1.293-.718-.518-.166-1-.215-1.687-.17Zm1.627 3.165c-.612.933-.797 2.024-.67 3.12.137 1.18.524 2.235 1.15 3.133.11.16.202.357.202.438 0 .119-.7.474-1.47.747-1.247.442-2.622.647-2.864 2.25-.044.285-.03 1.11.02 1.299a1.58 1.58 0 0 0 1.008 1.08l.158.055 5.714.005c5.657.005 5.716.005 5.872-.035.436-.108.807-.406.999-.8.124-.255.157-.417.17-.848.022-.7-.06-1.133-.293-1.55-.36-.643-.95-.952-1.625-1.145-.823-.235-2.924-.456-2.177-1.59.569-.863.881-1.7 1.054-2.821.175-1.141.028-2.33-.619-3.306-.753-1.138-1.902-1.805-3.174-1.843a3.996 3.996 0 0 0-3.455 1.811Zm3.582-.106c1.32.171 2.134 1.497 2.035 2.758-.085 1.095-.361 1.884-.965 2.755-.434.627-.618 1.54-.183 2.208.418.64 1.48 1.19 3.369 1.746.238.07.466.15.506.175.226.148.235.4.23.641l-.006.267-5.231.005c-2.877.003-5.252 0-5.277-.006l-.047-.01.008-.281c.009-.312.033-.396.154-.534.088-.1.156-.13.504-.23a15.39 15.39 0 0 0 2.065-.74c.485-.22 1.063-.527 1.37-.99.512-.772.207-1.705-.266-2.415-.518-.778-.775-1.551-.852-2.565-.111-1.462.986-2.992 2.586-2.784Z", fill: "currentColor" }), n("path", { d: "M18.75 3H17a1 1 0 1 0 0 2h1.75a.25.25 0 0 1 .25.25V7a1 1 0 1 0 2 0V5.25a.25.25 0 0 1 .25-.25H23a1 1 0 1 0 0-2h-1.75a.25.25 0 0 1-.25-.25V1a1 1 0 1 0-2 0v1.75a.25.25 0 0 1-.25.25Z", fill: "currentColor" })] }));
}, ja = o(Pa), Ea = ja, Ta = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.815 5.98c.377.652.587 1.421.562 2.246a8.078 8.078 0 0 1-.181 1.491 7.14 7.14 0 0 1-.914 2.263 7.032 7.032 0 0 1-.306.447 2.548 2.548 0 0 0-.296.753c-.539-.892-.947-2.047-1-3.463l-.001-.06c-.05-1.625.852-3.029 2.136-3.676Zm-1.454-1.469C9.69 5.605 8.615 7.564 8.68 9.717c.046 1.563.442 2.904 1.013 4.006.147.282.036.637-.263.747a17.835 17.835 0 0 1-1.466.469l-.107.03-.039.01-.026.007-.026.008-.068.021A3.664 3.664 0 0 0 5.2 18.49V19H2.833A.833.833 0 0 1 2 18.167v-.74a1.733 1.733 0 0 1 1.228-1.657c.425-.115 3.55-.964 4.022-1.9.23-.456.003-1.04-.225-1.443a6.76 6.76 0 0 1-.306-.447v-.001c-.595-.952-1.049-2.205-1.095-3.753-.07-2.33 1.732-4.22 3.871-4.226h.01c.667.002 1.301.187 1.856.511ZM7.2 19h8.967c.46 0 .833-.373.833-.833v-.74c0-.765-.494-1.414-1.18-1.644l-.048-.013c-.34-.093-2.41-.654-3.465-1.355.043.226.035.456-.067.66-.453.9-3.453 1.713-3.861 1.824l-.045.012A1.664 1.664 0 0 0 7.2 18.49V19Z", fill: "currentColor" }), n("path", { d: "M20.8 20a.8.8 0 0 0 .8-.8v-.71c0-.735-.475-1.358-1.134-1.578-.052-.018-3.423-.88-3.906-1.837-.22-.438-.003-.999.217-1.385.1-.136.199-.28.293-.43.572-.913 1.007-2.117 1.052-3.603.067-2.236-1.663-4.052-3.717-4.057h-.01c-2.053.005-3.784 1.821-3.716 4.057.044 1.486.48 2.688 1.05 3.603h.001c.094.15.193.294.293.43.22.386.437.947.217 1.385-.482.957-3.854 1.819-3.906 1.837A1.664 1.664 0 0 0 7.2 18.489v.711a.8.8 0 0 0 .8.8h12.8Z", fill: "currentColor" })] }));
}, Ga = o(Ta), Wa = Ga, Da = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.745 3.019c-.821.053-1.722.421-2.385.975-1.176.981-1.815 2.394-1.816 4.017-.001 1.308.334 2.69.923 3.808.17.324.391.691.528.878.392.536.032.684-.45.92-.581.285-1.3.548-2.23.818-.745.215-.882.277-1.263.563a2.698 2.698 0 0 0-1.016 1.7c-.049.3-.048 1.295.001 1.534a1.845 1.845 0 0 0 1.212 1.367s.152.054.251.08c.1.027 1.361 0 1.361 0l1.409.007.01-.727c.01-.635.018-.755.063-.95.028-.124.053-.246.056-.272.005-.047-.013-.048-1.175-.06a68.142 68.142 0 0 1-1.186-.018 4.763 4.763 0 0 1-.005-.33c.001-.489.148-.741.627-.879 1.17-.336 2.15-.695 2.842-1.041 1.292-.647 1.79-1.301 1.738-2.288-.03-.573-.2-1.022-.641-1.68-.618-.922-.911-1.823-1.026-3.15-.112-1.306.64-2.614 1.874-3.1.593-.235 1.304-.21 1.889.037.196.082.222.094.38-.052a6.409 6.409 0 0 1 1.334-.942c.143-.073.26-.141.26-.153 0-.304-1.325-.787-1.548-.859-.619-.198-1.195-.257-2.017-.203Zm1.946 3.786c-.732 1.115-.954 2.42-.801 3.732.163 1.41.626 2.672 1.374 3.746.134.191.243.427.243.524 0 .141-.837.566-1.76.893-1.49.528-3.134.773-3.424 2.69-.052.34-.036 1.329.025 1.554a1.89 1.89 0 0 0 1.204 1.291l.19.066 6.833.006c6.766.007 6.836.006 7.023-.04.521-.13.965-.486 1.195-.957.148-.306.187-.5.203-1.015.026-.838-.072-1.355-.351-1.854-.43-.769-1.136-1.138-1.943-1.37-.984-.28-3.497-.545-2.603-1.902.68-1.03 1.053-2.032 1.26-3.373.21-1.364.033-2.785-.74-3.954-.9-1.36-2.275-2.158-3.796-2.204a4.78 4.78 0 0 0-4.132 2.167Zm4.284-.128c1.579.205 2.552 1.791 2.434 3.299-.103 1.31-.433 2.253-1.155 3.295-.519.75-.74 1.843-.218 2.641.499.764 1.77 1.422 4.028 2.088.286.084.558.178.606.21.27.176.281.478.275.766l-.008.319-6.255.006c-3.441.004-6.281 0-6.312-.007l-.056-.013.01-.336c.01-.373.04-.474.185-.639.104-.119.186-.156.601-.273a18.397 18.397 0 0 0 2.47-.886c.581-.264 1.272-.63 1.639-1.184.613-.923.248-2.04-.318-2.889-.62-.93-.927-1.855-1.019-3.067-.133-1.749 1.179-3.578 3.093-3.33Z", fill: "currentColor" })] }));
}, Ua = o(Da), qa = Ua, _a = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M18.6 19.4a.8.8 0 0 0 .8-.8v-.71c0-.735-.475-1.358-1.134-1.579-.051-.017-3.423-.878-3.906-1.836-.22-.438-.003-.999.217-1.386.1-.135.199-.278.293-.428.572-.915 1.008-2.118 1.052-3.604.067-2.236-1.663-4.052-3.717-4.057h-.01c-2.053.005-3.784 1.821-3.716 4.057.044 1.486.48 2.688 1.05 3.603h.001c.094.15.193.294.293.43.22.386.437.947.217 1.385-.482.958-3.854 1.819-3.906 1.836A1.664 1.664 0 0 0 5 17.89v.711a.8.8 0 0 0 .8.8h12.8Z", fill: "currentColor" })] }));
}, Xa = o(_a), Ya = Xa, Ka = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m12.258 4.004.18.018a4.487 4.487 0 0 1 2.51 1.109c.116.096.362.349.517.53a5 5 0 0 1 1.101 2.572c.03.222.031.977 0 1.25-.13 1.16-.36 1.98-.81 2.882-.149.301-.436.78-.576.961-.075.098-.18.341-.18.418 0 .128.624.46 1.455.774a12.15 12.15 0 0 0 .514.183c.204.07.6.192.918.28l.277.08a2.606 2.606 0 0 1 1.8 2.162c.047.38.048 1.013.002 1.275-.073.412-.23.715-.513.986-.287.276-.568.421-.95.49l-.14.026-6.353-.002c-5.637-.002-6.369-.004-6.49-.02a1.734 1.734 0 0 1-1.079-.574 1.765 1.765 0 0 1-.418-.846c-.027-.143-.032-1.124-.007-1.343.111-.966.834-1.848 1.753-2.136.064-.02.26-.078.436-.129a21.393 21.393 0 0 0 1.251-.405 11.899 11.899 0 0 0 .604-.24c.303-.126.77-.381.88-.482.06-.055.06-.063.015-.186-.056-.157-.064-.17-.287-.506-.659-.996-1.055-2.074-1.217-3.315-.082-.63-.08-1.413.006-1.873a4.964 4.964 0 0 1 .698-1.783c.493-.78 1.297-1.477 2.073-1.793l.103-.044c.234-.11.723-.239 1.107-.29a6.47 6.47 0 0 1 .82-.029Zm-.502 1.968c-1.446.152-2.54 1.55-2.41 3.082.043.527.069.714.145 1.064.087.407.224.82.39 1.184.157.34.322.62.588.99.019.027.066.11.106.183.396.738.483 1.439.253 2.027-.12.307-.289.522-.66.846-.22.19-.833.541-1.286.733a11.6 11.6 0 0 0-.17.073c-.026.012-.091.04-.144.06a21.822 21.822 0 0 1-1.462.514l-.32.094-.278.081c-.22.064-.245.077-.353.184-.164.162-.187.234-.197.625A2.08 2.08 0 0 0 5.96 18c.012.017 12.016.028 12.043.011.02-.011.022-.515.003-.613a.584.584 0 0 0-.17-.303c-.102-.101-.162-.132-.377-.193-.929-.262-1.912-.606-2.485-.87-.435-.202-.957-.502-1.099-.632a1.61 1.61 0 0 0-.102-.084 2.538 2.538 0 0 1-.392-.398l-.066-.1c-.28-.422-.358-.977-.22-1.566a3.32 3.32 0 0 1 .47-1.033A5.727 5.727 0 0 0 14.6 9.387c.007-.09.018-.21.024-.267.053-.455-.028-.997-.22-1.48a3.781 3.781 0 0 0-.243-.449c-.165-.25-.255-.35-.585-.649-.268-.243-.78-.48-1.168-.543a1.997 1.997 0 0 0-.653-.027Zm6.267 12.063c.005.004.009 0 .009-.008 0-.01-.004-.013-.009-.008a.011.011 0 0 0 0 .016Z", fill: "currentColor" })] }));
}, Qa = o(Ka), Ja = Qa, e8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.773 10.245c-1.506-3.042-.56-4.988.696-5.874.374-.265.87-.11 1.137.261l1.64 2.278a1 1 0 0 1-.128 1.314l-1.048.983a.987.987 0 0 0-.298.543.96.96 0 0 0 .173.746c.557.755 1.507 1.984 2.48 2.994.07.075.143.148.214.22 1.05 1.049 2.408 2.035 3.214 2.587a.95.95 0 0 0 .824.122c.159-.05.307-.14.428-.27l.876-.938a1 1 0 0 1 1.3-.14l2.25 1.557c.448.31.57.934.166 1.3-1.018.92-2.784 1.589-5.348.535a10.75 10.75 0 0 1-1.467-.747c-1.048-.633-2.205-1.534-3.473-2.776a29.811 29.811 0 0 1-.219-.216c-1.152-1.153-2.023-2.212-2.663-3.18-.3-.453-.55-.886-.754-1.299Zm3.456-6.782 1.64 2.278a3 3 0 0 1-.383 3.942l-.38.356c.56.72 1.265 1.574 1.948 2.256.663.664 1.495 1.321 2.2 1.835l.265-.284a3 3 0 0 1 3.9-.42l2.25 1.558c1.2.83 1.99 2.962.369 4.427-1.218 1.1-3.084 1.888-5.477 1.48-2.308-.394-4.893-1.86-7.785-4.753-2.986-2.986-4.464-5.656-4.732-8.02-.281-2.484.812-4.35 2.27-5.381 1.515-1.07 3.196-.273 3.915.726Z", fill: "currentColor" })] }));
}, l8 = o(e8), t8 = l8, r8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.092 7.364a1 1 0 0 1-1.414 0l-.707-.707-3.162 3.161c-.457.457-.662 1.106-.636 1.752.036.889-.01 2.24-.445 3.572-.223.685-.667 1.25-1.138 1.69-.902.842-2.265.564-3.138-.309l-2.088-2.088-5.657 5.657a1 1 0 0 1-1.414-1.414L5.95 13.02l-2.088-2.088c-.873-.873-1.151-2.236-.309-3.138.44-.471 1.005-.915 1.69-1.138.812-.265 2.668-.333 3.757-.35a2.068 2.068 0 0 0 1.433-.597l3.295-3.296-.707-.707A1 1 0 0 1 14.435.293l5.657 5.657a1 1 0 0 1 0 1.414Z", fill: "currentColor" })] }));
}, i8 = o(r8), a8 = i8, n8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.092 9.364a1 1 0 0 1-1.414 0l-.707-.707-3.162 3.161c-.457.457-.662 1.106-.636 1.752.036.889-.01 2.24-.445 3.572-.223.685-.667 1.25-1.138 1.69-.902.842-2.265.564-3.138-.309l-2.088-2.088-5.657 5.657a1 1 0 0 1-1.414-1.414L8.95 15.02l-2.088-2.088c-.873-.873-1.151-2.236-.309-3.138.44-.471 1.005-.915 1.69-1.138.812-.265 2.668-.333 3.756-.35a2.068 2.068 0 0 0 1.434-.597l3.295-3.296-.707-.707a1 1 0 0 1 1.414-1.414l5.657 5.657a1 1 0 0 1 0 1.414Zm-4.95-3.536-4.06 3.936a2.163 2.163 0 0 1-1.625.586c-1.31-.069-3.61-.058-4.408.774a.568.568 0 0 0 .057.165.93.93 0 0 0 .17.23l5.59 5.59c.074.073.154.13.23.17a.567.567 0 0 0 .165.057c.824-.79.805-3.11.717-4.446a2.16 2.16 0 0 1 .606-1.675l3.972-3.972-1.414-1.415Z", fill: "currentColor" })] }));
}, d8 = o(n8), o8 = d8, c8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M13.37 2.094A10.003 10.003 0 0 0 8.002 21.17a7.757 7.757 0 0 1 .163-2.293c.185-.839 1.296-5.463 1.296-5.463a3.739 3.739 0 0 1-.324-1.577c0-1.485.857-2.593 1.923-2.593a1.334 1.334 0 0 1 1.342 1.508c0 .9-.578 2.262-.88 3.54a1.544 1.544 0 0 0 1.575 1.923c1.898 0 3.17-2.43 3.17-5.3 0-2.2-1.457-3.849-4.143-3.849a4.746 4.746 0 0 0-4.93 4.794 2.96 2.96 0 0 0 .648 1.97.48.48 0 0 1 .162.554c-.046.184-.162.623-.208.784a.354.354 0 0 1-.51.254c-1.384-.554-2.036-2.077-2.036-3.816 0-2.847 2.384-6.255 7.154-6.255 3.796 0 6.32 2.777 6.32 5.747 0 3.91-2.177 6.848-5.394 6.848a2.86 2.86 0 0 1-2.454-1.246s-.578 2.316-.692 2.754a8.026 8.026 0 0 1-1.019 2.131c.923.28 1.882.42 2.846.416a9.987 9.987 0 0 0 9.996-10.003 10.002 10.002 0 0 0-8.635-9.903h-.002Z", fill: "currentColor" })] }));
}, s8 = o(c8), h8 = s8, u8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8.492 19.191c.023-.336.071-.671.143-1.001.063-.295.254-1.13.534-2.34l.007-.03.387-1.668c.079-.34.14-.604.181-.692a3.46 3.46 0 0 1-.284-1.423c0-1.337.756-2.373 1.736-2.373.36-.006.704.15.942.426s.348.643.302.996c0 .453-.085.798-.454 2.035a28.2 28.2 0 0 0-.165.571c-.051.188-.095.358-.132.522-.096.386-.008.797.237 1.105a1.2 1.2 0 0 0 1.006.457c1.492 0 2.6-1.985 2.6-4.548 0-1.97-1.29-3.274-3.432-3.274A3.878 3.878 0 0 0 9.201 9.1a4.13 4.13 0 0 0-1.195 2.961c-.025.59.156 1.172.512 1.644.181.14.25.383.175.59-.041.168-.14.552-.177.68a.41.41 0 0 1-.392.34.388.388 0 0 1-.178-.041c-1.16-.479-1.796-1.778-1.796-3.44 0-2.985 2.491-5.584 6.192-5.584 3.135 0 5.481 2.329 5.481 5.14 0 3.532-1.932 6.104-4.69 6.104a2.508 2.508 0 0 1-2.046-.959l-.043.177-.207.852-.002.008c-.146.6-.248 1.017-.288 1.173-.106.355-.24.703-.4 1.04a8 8 0 1 0-1.655-.594ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z", fill: "currentColor" })] }));
}, v8 = o(u8), f8 = v8, g8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.983 13.621-3.062-2.43a1 1 0 0 0-1.325.072l-.636.63a1 1 0 0 0-.074 1.34l4.36 5.381a1 1 0 0 0 1.52.04L20.065 7.22a1 1 0 0 0-.04-1.38l-.383-.379a1 1 0 0 0-1.365-.039l-9.293 8.198Z", fill: "currentColor" })] }));
}, p8 = o(g8), w8 = p8, b8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "m9.555 5.036 9.197 6.132a1 1 0 0 1 0 1.664l-9.197 6.131A1 1 0 0 1 8 18.131V5.87a1 1 0 0 1 1.555-.833Z", fill: "currentColor" })] }));
}, m8 = o(b8), x8 = m8, y8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8.75 1.25a.5.5 0 0 1 .5-.5h3a.75.75 0 0 0 0-1.5h-3a.5.5 0 0 1-.5-.5v-3a.75.75 0 0 0-1.5 0v3a.5.5 0 0 1-.5.5h-3a.75.75 0 0 0 0 1.5h3a.5.5 0 0 1 .5.5v3a.75.75 0 0 0 1.5 0v-3Z", fill: "currentColor" })] }));
}, C8 = o(y8), k8 = C8, Z8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.969A6.969 6.969 0 1 0 12 5.03a6.969 6.969 0 0 0 0 13.938ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), n("path", { d: "M13 8a1 1 0 1 0-2 0v3H8a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3V8Z", fill: "currentColor" })] }));
}, M8 = o(Z8), z8 = M8, R8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 13a.5.5 0 0 0-.5.5V18a1 1 0 1 1-2 0v-4.5a.5.5 0 0 0-.5-.5H6a1 1 0 1 1 0-2h4.5a.5.5 0 0 0 .5-.5V6a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 .5.5H18a1 1 0 1 1 0 2h-4.5Z", fill: "currentColor" })] }));
}, I8 = o(R8), S8 = I8, B8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11.625 13.584c-.524 0-.785-.327-.785-.756 0-.637.315-1.047 1.053-1.607l.04-.03c.502-.382.853-.649.853-1.13 0-.542-.506-.857-1.072-.857-.464 0-.82.173-1.1.536-.203.208-.364.321-.637.321-.453 0-.685-.315-.685-.678 0-.37.209-.744.536-1.03.44-.38 1.143-.625 2.07-.625 1.655 0 2.816.815 2.816 2.22 0 1.024-.613 1.517-1.333 2.017-.488.357-.72.566-.905.988-.202.357-.357.63-.85.63ZM11.613 16.119c-.571 0-1.041-.369-1.041-.94 0-.572.47-.94 1.041-.94.572 0 1.036.368 1.036.94 0 .571-.464.94-1.036.94Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.047 12.047a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-2.031 0a6.969 6.969 0 1 1-13.938 0 6.969 6.969 0 0 1 13.938 0Z", fill: "currentColor" })] }));
}, N8 = o(B8), A8 = N8, H8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 7h-2c-1.47 0-2.373.004-3.025.092-.574.077-.67.187-.681.2a.025.025 0 0 1-.002.002c-.013.011-.123.107-.2.68C7.004 8.628 7 9.53 7 11v1c0 1.47.004 2.373.092 3.025.077.574.187.67.2.681v.001l.002.001c.011.013.107.123.68.2C8.628 15.996 9.53 16 11 16h2c1.47 0 2.373-.004 3.025-.092.574-.077.67-.187.681-.2h.001l.001-.002c.013-.011.123-.107.2-.68.088-.653.092-1.555.092-3.026v-1c0-1.47-.004-2.373-.092-3.025-.077-.574-.187-.67-.2-.681v-.001l-.002-.001c-.011-.013-.107-.123-.68-.2C15.372 7.004 14.47 7 13 7ZM5.879 5.879C5 6.757 5 8.172 5 11v1c0 2.828 0 4.243.879 5.121C6.757 18 8.172 18 11 18h2c2.828 0 4.243 0 5.121-.879C19 16.243 19 14.828 19 12v-1c0-2.828 0-4.243-.879-5.121C17.243 5 15.828 5 13 5h-2c-2.828 0-4.243 0-5.121.879Z", fill: "currentColor" }), n("path", { d: "M20 7.222c0-.123.1-.222.222-.222C21.204 7 22 7.796 22 8.778v5.444c0 .982-.796 1.778-1.778 1.778a.222.222 0 0 1-.222-.222V7.222ZM2 8.778C2 7.796 2.796 7 3.778 7 3.9 7 4 7.1 4 7.222v8.556c0 .122-.1.222-.222.222A1.778 1.778 0 0 1 2 14.222V8.778Z", fill: "currentColor" })] }));
}, V8 = o(H8), $8 = V8, L8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 9c0-2.828 0-4.243.879-5.121C5.757 3 7.172 3 10 3h4c2.828 0 4.243 0 5.121.879C20 4.757 20 6.172 20 9v6c0 2.828 0 4.243-.879 5.121C18.243 21 16.828 21 14 21h-4c-2.828 0-4.243 0-5.121-.879C4 19.243 4 17.828 4 15V9Zm2-3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6Zm1 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H7Z", fill: "currentColor" })] }));
}, O8 = o(L8), F8 = O8, P8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.212C2 5.99 2.99 5 4.212 5H7v-.788C7 2.99 7.99 2 9.212 2h10.576C21.01 2 22 2.99 22 4.212v15.576C22 21.01 21.01 22 19.788 22H9.212A2.212 2.212 0 0 1 7 19.788V19H4.212A2.212 2.212 0 0 1 2 16.788V7.212Zm7-3C9 4.095 9.095 4 9.212 4h10.576c.117 0 .212.095.212.212v15.576a.212.212 0 0 1-.212.212H9.212A.212.212 0 0 1 9 19.788V19h4.788C15.01 19 16 18.01 16 16.788V7.212C16 5.99 15.01 5 13.788 5H9v-.788Zm-5 3C4 7.095 4.095 7 4.212 7H7v10H4.212A.212.212 0 0 1 4 16.788V7.212Zm10 9.576a.212.212 0 0 1-.212.212H9V7h4.788c.117 0 .212.095.212.212v9.576Z", fill: "currentColor" })] }));
}, j8 = o(P8), E8 = j8, T8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10H1.448a.6.6 0 0 1-.424-1.024L2.93 17.07A9.969 9.969 0 0 1 0 10Zm13.656-4.002a1.667 1.667 0 0 1-1.622-1.282v.001a1.973 1.973 0 0 0-1.693 1.951v.006c1.48.056 2.833.473 3.905 1.136a2.335 2.335 0 1 1 2.423 3.96c-.073 2.714-3.03 4.897-6.664 4.897s-6.588-2.18-6.665-4.891a2.334 2.334 0 1 1 2.418-3.963c1.062-.658 2.4-1.075 3.866-1.137v-.009a2.692 2.692 0 0 1 2.4-2.672 1.667 1.667 0 1 1 1.632 2.003ZM6.92 9.646c-.654 0-1.217.65-1.256 1.497-.039.847.534 1.191 1.188 1.191.655 0 1.143-.307 1.182-1.154.04-.847-.46-1.534-1.114-1.534Zm7.426 1.497c-.038-.847-.6-1.497-1.255-1.497-.655 0-1.154.687-1.115 1.534.039.847.528 1.154 1.182 1.154.654 0 1.227-.344 1.188-1.191Zm-1.88 2.213a.185.185 0 0 0-.153-.254 23.105 23.105 0 0 0-2.308-.112c-.812 0-1.59.04-2.308.112a.185.185 0 0 0-.153.254 2.667 2.667 0 0 0 4.922 0Z", fill: "currentColor" })] }));
}, G8 = o(T8), W8 = G8, D8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.123 15.9c-.334.17-.736.181-1.06-.008l-5.267-3.065c-.325-.19-.463-.562-.463-.938 0-.376.138-.75.463-.939l5.193-3.027c.325-.19.73-.178 1.065-.005.38.196.892.415 1.28.415A2.663 2.663 0 0 0 20 5.667 2.663 2.663 0 0 0 17.333 3a2.663 2.663 0 0 0-2.666 2.667c0 .376-.138.749-.463.938L9.011 9.632c-.326.19-.73.178-1.065.005-.38-.196-.892-.415-1.28-.415A2.663 2.663 0 0 0 4 11.89a2.663 2.663 0 0 0 2.667 2.667c.387 0 .898-.22 1.279-.415.335-.173.74-.185 1.066.005l5.294 3.093c.302.177.432.523.432.872a2.599 2.599 0 0 0 2.595 2.596 2.599 2.599 0 0 0 2.596-2.596 2.599 2.599 0 0 0-2.596-2.595c-.365 0-.846.2-1.21.384Z", fill: "currentColor" })] }));
}, U8 = o(D8), q8 = U8, _8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 6.414V9h-1c-2.26 0-4.995.786-7.17 2.409-1.233.919-2.28 2.099-2.966 3.558 1.105-1.177 2.21-2.039 3.387-2.65C10.313 11.244 12.481 11 15 11h1v2.585L19.586 10 16 6.414Zm-2-1.81c0-1.114 1.346-1.672 2.134-.884l5.22 5.22a1.5 1.5 0 0 1 0 2.12l-5.22 5.22c-.783.784-2.134.237-2.134-.883v-2.38c-1.914.065-3.424.345-4.826 1.074-1.643.854-3.253 2.384-5.16 5.194-.58.853-2.042.52-2.01-.646.113-3.985 2.064-6.92 4.63-8.834C8.862 8.144 11.569 7.238 14 7.041V4.604Z", fill: "currentColor" })] }));
}, X8 = o(_8), Y8 = X8, K8 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.57 7.365A3 3 0 0 1 15.085 6H16V4.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V8h-.915a1 1 0 0 0-.838.455L11.943 12l2.304 3.545a1 1 0 0 0 .838.455H16v-1.117a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V18h-.915a3 3 0 0 1-2.515-1.365l-1.82-2.8-1.82 2.8A3 3 0 0 1 6.415 18H4a1 1 0 1 1 0-2h2.415a1 1 0 0 0 .838-.455L9.557 12 7.253 8.455A1 1 0 0 0 6.415 8H4a1 1 0 1 1 0-2h2.415A3 3 0 0 1 8.93 7.365l1.82 2.8 1.82-2.8Z", fill: "currentColor" })] }));
}, Q8 = o(K8), J8 = Q8, e6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M16 2.01 8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99Zm0 16.49a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v13Z", fill: "currentColor" })] }));
}, l6 = o(e6), t6 = l6, r6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5.636 16.575c.597 0 .916-.306 1.14-1.093l.36-1.105h3.113l.353 1.105c.224.767.57 1.093 1.167 1.093.644 0 1.065-.38 1.065-.97 0-.238-.061-.51-.183-.89l-2.042-6.003c-.373-1.106-.89-1.54-1.866-1.54-.977 0-1.506.44-1.872 1.54l-2.05 6.004c-.155.454-.216.712-.216.936 0 .543.42.923 1.03.923Zm1.96-3.82 1.052-3.507h.109l1.038 3.507H7.597ZM13.055 15.374c0 .665.502 1.126 1.228 1.126h5.095a.859.859 0 0 0 .888-.889c0-.522-.373-.895-.888-.895h-3.704v-.109l3.493-4.579c.706-.889.896-1.241.896-1.676 0-.685-.461-1.112-1.194-1.112H14.14c-.529 0-.895.36-.895.895 0 .53.36.889.895.889h3.365v.109l-3.568 4.606c-.712.882-.882 1.2-.882 1.635Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.291 4.396a.25.25 0 0 1-.175.429h-2.503a.25.25 0 0 1-.175-.429l1.252-1.225a.25.25 0 0 1 .35 0l1.251 1.225ZM10.438 19.627a.25.25 0 0 1 .175-.429h2.456a.25.25 0 0 1 .175.429l-1.228 1.202a.25.25 0 0 1-.35 0l-1.228-1.202Z", fill: "currentColor" })] }));
}, i6 = o(r6), a6 = i6, n6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.45 3.397c.112-.53.867-.53.979 0l.55 2.611a6.5 6.5 0 0 0 4.515 4.89l2.027.6c.477.142.477.818 0 .96l-2.027.6a6.5 6.5 0 0 0-4.514 4.89l-.551 2.612c-.112.529-.867.529-.979 0l-.55-2.611a6.5 6.5 0 0 0-4.515-4.89l-2.027-.601c-.477-.142-.477-.818 0-.96l2.027-.6a6.5 6.5 0 0 0 4.514-4.89l.551-2.611Z", fill: "currentColor" })] }));
}, d6 = o(n6), o6 = d6, c6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.45 3.397c.112-.53.867-.53.979 0l.55 2.611a6.5 6.5 0 0 0 4.515 4.89l2.027.6c.477.142.477.818 0 .96l-2.027.6a6.5 6.5 0 0 0-4.514 4.89l-.551 2.612c-.112.529-.867.529-.979 0l-.55-2.611a6.5 6.5 0 0 0-4.515-4.89l-2.027-.601c-.477-.142-.477-.818 0-.96l2.027-.6a6.5 6.5 0 0 0 4.514-4.89l.551-2.611ZM11.85 9a.103.103 0 0 1 .178 0 8.506 8.506 0 0 0 2.833 2.89.103.103 0 0 1 0 .175 8.506 8.506 0 0 0-2.833 2.89.103.103 0 0 1-.177 0 8.507 8.507 0 0 0-2.833-2.89.103.103 0 0 1 0-.175A8.507 8.507 0 0 0 11.85 9Z", fill: "currentColor" })] }));
}, s6 = o(c6), h6 = s6, u6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.016 6.969a3.047 3.047 0 0 0-3.047 3.047v3.968a3.047 3.047 0 0 0 3.047 3.047h1.12l2.12 2.204c1.426 1.483 3.931.473 3.931-1.584V6.673c0-1.991-2.368-3.03-3.833-1.681L6.207 6.969H5.016Zm5.14 10.682c0 .229-.278.34-.437.176L7.3 15.311A1.016 1.016 0 0 0 6.569 15H5.016C4.455 15 4 14.545 4 13.984v-3.968C4 9.455 4.455 9 5.016 9h1.588c.255 0 .5-.096.688-.268L9.73 6.486a.254.254 0 0 1 .426.187V17.65Z", fill: "currentColor" }), n("path", { d: "M17.26 17.484c.275.48.893.65 1.33.31a7.11 7.11 0 0 0 .02-11.197c-.435-.342-1.053-.174-1.33.305-.278.479-.106 1.085.31 1.45a5.104 5.104 0 0 1-.015 7.683c-.417.364-.59.97-.315 1.45Z", fill: "currentColor" }), n("path", { d: "M14.135 15.121c.165.518.728.814 1.191.53a4.064 4.064 0 0 0 .03-6.91c-.462-.287-1.028.004-1.197.52-.168.518.141 1.063.526 1.448a2.094 2.094 0 0 1-.013 2.97c-.387.381-.702.924-.537 1.442Z", fill: "currentColor" })] }));
}, v6 = o(u6), f6 = v6, g6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M6.988 10.03c-.02.312-.02.636-.02.921v2.098c0 .406 0 .89.056 1.305.068.502.248 1.196.837 1.785.59.589 1.283.77 1.785.837.416.056.9.056 1.305.055h.184l1.684 1.75.037.04c.144.15.379.394.61.575.179.141 1.102.854 2.29.375a2.23 2.23 0 0 0 .609-.364l-1.538-1.538c-.13-.065-.295-.237-.544-.496l-1.22-1.268-.92-.92a.853.853 0 0 0-.178-.104c-.19-.081-.403-.081-.83-.081h-.104c-.957 0-1.436 0-1.734-.297C9 14.405 9 13.926 9 12.969v-.927L6.988 10.03Zm8.168 2.511v-5.29c0-.496 0-.744-.152-.81-.152-.067-.334.1-.7.437l-1.72 1.585c-.289.265-.433.398-.611.468a1.12 1.12 0 0 1-.363.064l-1.97-1.97.006-.001c.416-.056.9-.056 1.305-.055h.256l1.722-1.585.037-.035c.14-.13.381-.353.619-.515.212-.146 1.122-.742 2.235-.254 1.113.488 1.291 1.562 1.328 1.816.04.285.04.613.04.805v7.372l-2.032-2.032Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.15 4.435a1 1 0 0 1 1.413 0L20.15 19.021a1 1 0 1 1-1.414 1.414L4.149 5.849a1 1 0 0 1 0-1.414Z", fill: "currentColor" })] }));
}, p6 = o(g6), w6 = p6, b6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.485 6.528C7.941 5.554 9.894 4.984 12 4.984s4.06.57 5.515 1.544c1.448.97 2.5 2.42 2.5 4.157 0 1.373-.6 2.55-1.419 3.51-.814.954-1.886 1.746-2.957 2.385-2.143 1.278-4.468 2.053-5.278 2.304-1.025.317-1.75-.725-1.417-1.55l.594-1.478a9.981 9.981 0 0 1-1.868-.435c-.843-.29-1.761-.758-2.476-1.527-.737-.792-1.21-1.854-1.21-3.209 0-1.737 1.052-3.187 2.501-4.157Zm4.494 7.401 1.538-.033-.972 2.416c.913-.362 2.013-.856 3.053-1.477.968-.577 1.836-1.236 2.453-1.96.613-.717.933-1.443.933-2.19 0-.85-.515-1.743-1.6-2.469-1.077-.721-2.624-1.2-4.384-1.2-1.76 0-3.307.479-4.385 1.2-1.084.726-1.6 1.619-1.6 2.47 0 .839.278 1.407.666 1.825.41.44.992.763 1.65.99a8.299 8.299 0 0 0 1.833.385 8.909 8.909 0 0 0 .771.043h.044Z", fill: "currentColor" }), n("path", { d: "M10 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM13 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM16 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor" })] }));
}, m6 = o(b6), x6 = m6, y6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 4a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7.001 7.001 0 0 0-7-7 1 1 0 0 1-1-1Z", fill: "currentColor", children: n("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", from: "0 12 12", to: "360 12 12", dur: i.dur, repeatCount: "indefinite" }) })] }));
}, C6 = o(y6), k6 = C6, Z6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.673 8.99c.719.034 1.078.05 1.246.169a.7.7 0 0 1 .258.797c-.067.194-.348.418-.91.867l-3.432 2.733c-.5.399-.751.598-.844.884-.093.286-.008.594.163 1.212l1.164 4.223c.191.694.287 1.041.226 1.237a.7.7 0 0 1-.678.493c-.204-.003-.505-.201-1.106-.598l-3.66-2.412c-.533-.351-.8-.527-1.1-.527-.3 0-.567.175-1.1.527l-3.66 2.412c-.601.397-.902.595-1.107.598a.7.7 0 0 1-.678-.493c-.06-.196.035-.543.227-1.237l1.164-4.223c.17-.618.256-.926.163-1.212-.093-.286-.344-.485-.844-.884l-3.431-2.733c-.563-.449-.845-.673-.91-.867a.7.7 0 0 1 .257-.797c.167-.119.527-.135 1.246-.17l4.388-.205c.638-.03.957-.044 1.199-.22.242-.177.355-.476.58-1.074l1.543-4.104c.253-.674.38-1.011.544-1.134a.7.7 0 0 1 .838 0c.164.123.29.46.544 1.134l1.544 4.104c.224.598.337.897.579 1.073.242.177.561.192 1.2.221l4.387.206Z", fill: "currentColor" })] }));
}, M6 = o(Z6), z6 = M6, R6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.876 10.72c-.637-.03-.956-.044-1.199-.22-.242-.177-.354-.476-.58-1.073l-.91-2.422c-.079-.21-.118-.314-.187-.314-.07 0-.109.104-.187.314l-.911 2.422c-.225.598-.337.896-.58 1.073-.242.176-.56.19-1.199.22l-2.593.122c-.223.01-.334.016-.356.082-.02.066.066.135.241.274l2.029 1.616c.5.4.75.599.844.884.093.286.008.595-.163 1.212l-.687 2.492c-.06.216-.089.324-.033.364.056.041.15-.02.336-.143L10.9 16.2c.534-.352.801-.528 1.1-.528.3 0 .568.176 1.102.528l2.158 1.423c.186.123.28.184.336.143.056-.04.026-.148-.033-.364l-.688-2.492c-.17-.617-.255-.926-.162-1.212.093-.285.343-.485.844-.884l2.029-1.616c.174-.139.262-.209.24-.274-.02-.066-.132-.072-.356-.082l-2.593-.121Zm5.797-1.73c.719.034 1.078.05 1.246.169a.7.7 0 0 1 .258.797c-.067.194-.348.418-.91.867l-3.432 2.733c-.5.399-.751.598-.844.884-.093.286-.008.594.163 1.212l1.164 4.223c.191.694.287 1.041.226 1.237a.7.7 0 0 1-.678.493c-.204-.003-.505-.201-1.106-.598l-3.66-2.412c-.533-.351-.8-.527-1.1-.527-.3 0-.567.175-1.1.527l-3.66 2.412c-.601.397-.902.595-1.107.598a.7.7 0 0 1-.678-.493c-.06-.196.035-.543.227-1.237l1.164-4.223c.17-.618.256-.926.163-1.212-.093-.286-.344-.485-.844-.884l-3.431-2.733c-.563-.449-.845-.673-.91-.867a.7.7 0 0 1 .257-.797c.167-.119.527-.135 1.246-.17l4.388-.205c.638-.03.957-.044 1.199-.22.242-.177.355-.476.58-1.074l1.543-4.104c.253-.674.38-1.011.544-1.134a.7.7 0 0 1 .838 0c.164.123.29.46.544 1.134l1.544 4.104c.224.598.337.897.579 1.073.242.177.561.192 1.2.221l4.387.206Z", fill: "currentColor" })] }));
}, I6 = o(R6), S6 = I6, B6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.67 18 12 15.631 9.33 18l.14-3.618L6 13.717l2.846-2.143-1.658-3.197 3.408.946L12 6l1.404 3.323 3.408-.946-1.658 3.197L18 13.717l-3.47.665.14 3.618Zm1.925-1.977 1.712-.328c1.932-.37 2.899-.555 3.048-1.199.15-.643-.636-1.235-2.208-2.419l-1.44-1.083.847-1.633c.92-1.774 1.38-2.66.96-3.177-.42-.517-1.382-.25-3.306.285l-1.646.457-.69-1.636c-.8-1.89-1.199-2.835-1.872-2.835-.674 0-1.073.945-1.871 2.835l-.691 1.636-1.646-.457c-1.924-.534-2.887-.802-3.306-.285-.42.517.04 1.403.96 3.177l.846 1.633-1.439 1.083c-1.572 1.184-2.358 1.776-2.208 2.42.15.643 1.116.828 3.048 1.198l1.712.328-.07 1.826c-.08 2.034-.12 3.05.487 3.337.606.287 1.368-.388 2.89-1.738L12 18.305l1.288 1.143c1.522 1.35 2.284 2.025 2.89 1.738.607-.287.567-1.303.488-3.337l-.071-1.826Z", fill: "currentColor" })] }));
}, N6 = o(B6), A6 = N6, H6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12.188 3.047c.56 0 1.015.455 1.015 1.015v1.016a1.016 1.016 0 1 1-2.031 0V4.062c0-.56.455-1.015 1.015-1.015ZM12.188 7.002a5.078 5.078 0 1 0 0 10.156 5.078 5.078 0 0 0 0-10.156ZM17.933 7.879l.718-.719a1.016 1.016 0 0 0-1.436-1.436l-.719.718a1.016 1.016 0 0 0 1.437 1.437ZM12.188 18.281c.56 0 1.015.455 1.015 1.016v1.015a1.016 1.016 0 0 1-2.031 0v-1.015c0-.561.455-1.016 1.015-1.016ZM7.16 18.65l.719-.717a1.016 1.016 0 1 0-1.437-1.436l-.718.718A1.016 1.016 0 0 0 7.16 18.65ZM3.047 12.188c0-.561.455-1.016 1.015-1.016h1.016a1.016 1.016 0 1 1 0 2.031H4.062c-.56 0-1.015-.455-1.015-1.015ZM7.16 5.724A1.016 1.016 0 1 0 5.724 7.16l.718.719A1.016 1.016 0 1 0 7.88 6.442l-.719-.718ZM18.281 12.188c0-.561.455-1.016 1.016-1.016h1.015a1.016 1.016 0 0 1 0 2.031h-1.015c-.561 0-1.016-.455-1.016-1.015ZM17.933 16.497a1.015 1.015 0 1 0-1.437 1.436l.719.718a1.016 1.016 0 0 0 1.436-1.436l-.718-.718Z", fill: "currentColor" })] }));
}, V6 = o(H6), $6 = V6, L6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.188 9.033a3.047 3.047 0 1 0 0 6.094 3.047 3.047 0 0 0 0-6.094ZM7.109 12.08a5.078 5.078 0 1 1 10.157 0 5.078 5.078 0 0 1-10.157 0ZM12.188 3.047c.56 0 1.015.455 1.015 1.015v1.016a1.016 1.016 0 1 1-2.031 0V4.062c0-.56.455-1.015 1.015-1.015ZM18.65 5.724c.398.397.398 1.04 0 1.436l-.717.719a1.016 1.016 0 1 1-1.437-1.437l.719-.718a1.016 1.016 0 0 1 1.436 0ZM12.188 18.281c.56 0 1.015.455 1.015 1.016v1.015a1.016 1.016 0 0 1-2.031 0v-1.015c0-.561.455-1.016 1.015-1.016ZM7.879 16.497c.396.396.396 1.04 0 1.436l-.719.718a1.016 1.016 0 0 1-1.436-1.436l.718-.718a1.015 1.015 0 0 1 1.437 0ZM3.047 12.188c0-.561.455-1.016 1.015-1.016h1.016a1.016 1.016 0 1 1 0 2.031H4.062c-.56 0-1.015-.455-1.015-1.015ZM5.724 5.724a1.016 1.016 0 0 1 1.436 0l.719.718A1.016 1.016 0 1 1 6.442 7.88l-.718-.719a1.016 1.016 0 0 1 0-1.436ZM18.281 12.188c0-.561.455-1.016 1.016-1.016h1.015a1.016 1.016 0 0 1 0 2.031h-1.015c-.561 0-1.016-.455-1.016-1.015ZM16.496 16.497a1.015 1.015 0 0 1 1.437 0l.718.718a1.016 1.016 0 0 1-1.436 1.436l-.719-.718a1.016 1.016 0 0 1 0-1.436Z", fill: "currentColor" })] }));
}, O6 = o(L6), F6 = O6, P6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 11a3.001 3.001 0 0 0 2.83-2H19a1 1 0 1 0 0-2h-2.17a3.001 3.001 0 0 0-5.66 0H5a1 1 0 0 0 0 2h6.17A3.001 3.001 0 0 0 14 11Zm1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7.17 15a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-6.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h2.17ZM9 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z", fill: "currentColor" })] }));
}, j6 = o(P6), E6 = j6, T6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.192 19H8.828c-.862 0-1.697 0-2.386-.092-.775-.104-1.655-.358-2.386-1.089-.731-.73-.985-1.611-1.089-2.386-.092-.688-.092-1.524-.092-2.386V10.953c0-.862 0-1.698.092-2.386.104-.775.358-1.655 1.089-2.386.73-.731 1.611-.985 2.386-1.089C7.131 5 7.966 5 8.828 5h5.536c.644-.003 1.455-.007 2.212.307.758.313 1.329.89 1.782 1.347l.121.122.938.937.077.078c.61.61 1.2 1.2 1.622 1.752.474.621.918 1.423.918 2.457 0 1.034-.444 1.836-.918 2.457-.421.552-1.012 1.143-1.622 1.752l-.077.078-.938.937-.121.122c-.453.457-1.024 1.034-1.782 1.347-.757.314-1.568.31-2.212.307h-.172Zm1.619-11.845C15.438 7 15.023 7 14.192 7H8.938c-1.916 0-2.873 0-3.468.595-.595.595-.595 1.552-.595 3.468v1.874c0 1.916 0 2.873.595 3.468C6.065 17 7.022 17 8.938 17h5.254c.83 0 1.246 0 1.619-.155.373-.154.667-.448 1.254-1.035l.937-.937c1.355-1.354 2.032-2.032 2.032-2.873 0-.841-.677-1.518-2.032-2.873l-.937-.937c-.587-.587-.88-.88-1.254-1.035Z", fill: "currentColor" }), n("path", { d: "M17 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z", fill: "currentColor" })] }));
}, G6 = o(T6), W6 = G6, D6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 13a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2h5ZM16 18a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2h9ZM3 7a1 1 0 0 0 1 1h16a1 1 0 1 0 0-2H4a1 1 0 0 0-1 1Z", fill: "currentColor" })] }));
}, U6 = o(D6), q6 = U6, _6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 18a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h4ZM3 7a1 1 0 0 0 1 1h16a1 1 0 1 0 0-2H4a1 1 0 0 0-1 1Zm11 6a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h10Z", fill: "currentColor" })] }));
}, X6 = o(_6), Y6 = X6, K6 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 18a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2h-4Zm5-11a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1Zm-11 6a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2H10Z", fill: "currentColor" })] }));
}, Q6 = o(K6), J6 = Q6, e7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M13 17a1 1 0 0 0 0-2H8a1 1 0 1 0 0 2h5ZM16 13a1 1 0 0 0 0-2H8a1 1 0 1 0 0 2h8ZM16 9a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h8Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.109 3H8.89c-1.63 0-3.475-.073-4.72 1.172C2.928 5.416 3 7.262 3 8.892v6.217c0 1.63-.073 3.475 1.172 4.72C5.416 21.072 7.262 21 8.892 21h6.217c1.63 0 3.475.073 4.72-1.172 1.244-1.244 1.171-3.09 1.171-4.72V8.892c0-1.63.073-3.475-1.172-4.72C18.584 2.928 16.738 3 15.108 3ZM5 9c0-1.886 0-2.828.586-3.414C6.172 5 7.114 5 9 5h6c1.886 0 2.828 0 3.414.586C19 6.172 19 7.114 19 9v6c0 1.886 0 2.828-.586 3.414C17.828 19 16.886 19 15 19H9c-1.886 0-2.828 0-3.414-.586C5 17.828 5 16.886 5 15V9Z", fill: "currentColor" })] }));
}, l7 = o(e7), t7 = l7, r7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2h-4ZM21 7a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1ZM7 13a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2H7Z", fill: "currentColor" })] }));
}, i7 = o(r7), a7 = i7, n7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 18a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h4ZM18 13a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h14ZM3 7a1 1 0 0 0 1 1h11a1 1 0 1 0 0-2H4a1 1 0 0 0-1 1Z", fill: "currentColor" })] }));
}, d7 = o(n7), o7 = d7, c7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M16.058 6.507A3.803 3.803 0 0 1 15.116 4h-2.747v11.022a2.304 2.304 0 0 1-2.302 2.222 2.318 2.318 0 0 1-2.311-2.31c0-1.53 1.475-2.676 2.995-2.205V9.92C7.684 9.511 5 11.893 5 14.933 5 17.893 7.453 20 10.058 20a5.063 5.063 0 0 0 5.058-5.067v-5.59a6.534 6.534 0 0 0 3.822 1.226V7.822s-1.671.08-2.88-1.315Z", fill: "currentColor" })] }));
}, s7 = o(c7), h7 = s7, u7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M11 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4ZM15 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 3a3 3 0 0 1 3 3h3a1 1 0 1 1 0 2v8.079c0 .4 0 .875-.054 1.285-.067.494-.245 1.177-.825 1.757-.58.58-1.263.758-1.757.825-.41.055-.886.054-1.285.054H8.92c-.4 0-.875 0-1.285-.054-.494-.067-1.177-.245-1.757-.825-.58-.58-.758-1.263-.825-1.757C5 16.954 5 16.478 5 16.079V8a1 1 0 0 1 0-2h3a3 3 0 0 1 3-3h2Zm-2 2a1 1 0 0 0-1 1h4a1 1 0 0 0-1-1h-2Zm5.707 12.707C17 17.414 17 16.943 17 16V8H7v8c0 .943 0 1.414.293 1.707C7.586 18 8.057 18 9 18h6c.943 0 1.414 0 1.707-.293Z", fill: "currentColor" })] }));
}, v7 = o(u7), f7 = v7, g7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.207 10a.5.5 0 0 0-.354.854l3.793 3.792a.5.5 0 0 0 .707 0l3.793-3.792a.5.5 0 0 0-.353-.854H8.207Z", fill: "currentColor" })] }));
}, p7 = o(g7), w7 = p7, b7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M14.441 14.953s-.307.34-.89.34c-.584 0-.845-.34-.845-.845V11.59h1.887V9.857h-1.887V7h-1.421C11.062 8.282 10.187 9.35 9 9.874v1.716h1.386v3.291c0 .457.446 2.119 2.72 2.119 1.335 0 1.888-.83 1.888-.83l-.553-1.217Z", fill: "currentColor" }), n("path", { d: "M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Z", fill: "currentColor" })] }));
}, m7 = o(b7), x7 = m7, y7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M22.162 5.656a8.385 8.385 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.73 1.86 3.48a4.168 4.168 0 0 1-1.894-.522v.052a4.185 4.185 0 0 0 3.355 4.1 4.208 4.208 0 0 1-1.89.073A4.185 4.185 0 0 0 7.97 16.65a8.393 8.393 0 0 1-6.19 1.732 11.83 11.83 0 0 0 6.409 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.497 8.497 0 0 0 2.087-2.165v-.001Z", fill: "currentColor" })] }));
}, C7 = o(y7), k7 = C7, Z7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M8.51 20h-.08a10.87 10.87 0 0 1-4.65-1.09A1.38 1.38 0 0 1 3 17.47a1.41 1.41 0 0 1 1.16-1.18 6.63 6.63 0 0 0 2.54-.89 9.49 9.49 0 0 1-3.51-9.07 1.41 1.41 0 0 1 1-1.15 1.35 1.35 0 0 1 1.43.41 7.09 7.09 0 0 0 4.88 2.75 4.5 4.5 0 0 1 1.41-3.1 4.47 4.47 0 0 1 6.37.19.7.7 0 0 0 .78.1A1.39 1.39 0 0 1 21 7.13a6.661 6.661 0 0 1-1.28 2.6A10.79 10.79 0 0 1 8.51 20Zm0-2h.08a8.79 8.79 0 0 0 9.09-8.59 1.32 1.32 0 0 1 .37-.85 5.19 5.19 0 0 0 .62-1 2.56 2.56 0 0 1-1.91-.85A2.45 2.45 0 0 0 15 6a2.5 2.5 0 0 0-1.79.69 2.53 2.53 0 0 0-.72 2.42l.26 1.14-1.17.08a8.3 8.3 0 0 1-6.54-2.4 7.12 7.12 0 0 0 3.73 6.46l.95.54-.63.9a5.62 5.62 0 0 1-2.68 1.92A8.337 8.337 0 0 0 8.5 18h.01Z", fill: "currentColor" })] }));
}, M7 = o(Z7), z7 = M7, R7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M4 7.508V15a4 4 0 0 0 4 4h9.494c.28 0 .511.232.433.501C17.695 20.309 16.925 21 16 21H8a6 6 0 0 1-6-6V9c0-.832.692-1.664 1.5-1.92.268-.085.5.147.5.428Z", fill: "currentColor" }), n("path", { d: "M7.016 9c0-1.443.002-2.423.1-3.156.095-.705.262-1.028.48-1.247.22-.22.543-.386 1.248-.48.733-.1 1.713-.101 3.156-.101h4c1.443 0 2.423.002 3.157.1.704.095 1.027.262 1.246.48.22.22.386.543.48 1.248.1.733.101 1.713.101 3.156v2c0 1.443-.002 2.423-.1 3.156-.095.705-.262 1.028-.48 1.247-.22.22-.543.386-1.247.48-.734.1-1.714.101-3.157.101h-4c-1.443 0-2.423-.002-3.156-.1-.705-.095-1.028-.262-1.247-.48-.22-.22-.386-.543-.48-1.248-.1-.733-.101-1.713-.101-3.156V9Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 2.031, strokeLinecap: "round", strokeLinejoin: "round" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.333 12.044c0 .266.371.425.648.277l3.832-2.044c.248-.132.248-.422 0-.554l-3.832-2.044c-.277-.148-.648.011-.648.277v4.088Z", fill: "#fff" })] }));
}, I7 = o(R7), S7 = I7, B7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, d("g", { fill: "currentColor", children: [n("path", { d: "M12.981 12.321c-.277.148-.648-.01-.648-.277V7.956c0-.266.371-.425.648-.277l3.832 2.044c.248.132.248.422 0 .554z" }), n("path", { clipRule: "evenodd", d: "M6.879 3.879C6 4.757 6 6.172 6 9v2c0 2.828 0 4.243.879 5.121S9.172 17 12 17h4c2.828 0 4.243 0 5.121-.879S22 13.828 22 11V9c0-2.828 0-4.243-.879-5.121S18.828 3 16 3h-4c-2.828 0-4.243 0-5.121.879zm12.146 1.213C18.373 5.004 17.471 5 16 5h-4c-1.47 0-2.373.004-3.025.092-.574.077-.67.187-.681.2h-.001l-.001.002c-.013.011-.123.107-.2.68C8.004 6.628 8 7.53 8 9v2c0 1.47.004 2.373.092 3.025.077.574.187.67.2.681v.001l.002.001c.011.013.107.123.68.2.653.088 1.555.092 3.026.092h4c1.47 0 2.373-.004 3.025-.092.574-.077.67-.187.681-.2h.001l.001-.002c.013-.011.123-.107.2-.68.088-.653.092-1.555.092-3.026V9c0-1.47-.004-2.373-.092-3.025-.077-.574-.187-.67-.2-.681v-.001l-.002-.001c-.011-.013-.107-.123-.68-.2z", fillRule: "evenodd" }), n("path", { d: "M3.5 7.08c.268-.085.5.147.5.428V15a4 4 0 0 0 4 4h9.494c.28 0 .511.232.433.5-.233.809-1.002 1.5-1.927 1.5H8a6 6 0 0 1-6-6V9c0-.832.692-1.664 1.5-1.92z" })] })] }));
}, N7 = o(B7), A7 = N7, H7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.319 11.775C3.319 6.936 7.285 3 12.159 3 17.035 3 21 6.936 21 11.775c0 4.837-3.966 8.773-8.84 8.773a8.9 8.9 0 0 1-4.185-1.043l-4.67 1.484a.233.233 0 0 1-.293-.298l1.519-4.48a8.71 8.71 0 0 1-1.212-4.436Zm4.987 5.797a7.004 7.004 0 0 0 3.854 1.148c3.86 0 7.002-3.115 7.002-6.945S16.02 4.828 12.16 4.828c-3.862 0-7.003 3.116-7.003 6.947 0 1.472.46 2.88 1.333 4.072a.234.234 0 0 1 .033.213l-.755 2.228 2.34-.744a.236.236 0 0 1 .198.028Zm7.97-4.25.043.021c.172.083.308.148.386.277.116.19.07.716-.103 1.196-.22.61-1.184 1.11-1.623 1.148l-.065.007c-.101.01-.216.02-.36.02-.342 0-.944-.058-2.215-.565-1.32-.528-2.622-1.658-3.666-3.184a1.68 1.68 0 0 1-.009-.012l-.029-.042c-.272-.359-.908-1.304-.908-2.305 0-1.113.533-1.745.847-1.943.297-.187.968-.276 1.092-.281l.088-.004h.013c.26 0 .447.158.589.497l.114.273c.18.436.506 1.22.53 1.266a.612.612 0 0 1 .018.576l-.03.06a1.412 1.412 0 0 1-.213.338c-.035.04-.07.083-.106.126-.075.09-.152.183-.224.254a.423.423 0 0 0-.077.091c.001.003.003.02.022.052.147.247 1.215 1.718 2.623 2.33.062.026.265.11.276.11.014 0 .035-.022.051-.04.123-.139.52-.603.65-.798.117-.173.266-.261.443-.261.108 0 .21.033.306.067.21.076 1.3.61 1.536.726Z", fill: "currentColor" })] }));
}, V7 = o(H7), $7 = V7, L7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.33 14.768a.785.785 0 0 0 0-1.11 4.711 4.711 0 0 0-1.33-.934V14a2 2 0 0 1-.067.514c.1.079.196.164.287.255a.785.785 0 0 0 1.11 0Zm-5.263-.254a3.17 3.17 0 0 0-.287.255.785.785 0 1 1-1.11-1.11c.389-.39.84-.705 1.33-.935V14c0 .178.023.35.067.514ZM14 11.034a6.268 6.268 0 0 1 2.44 1.514.785.785 0 0 0 1.11-1.11A7.831 7.831 0 0 0 14 9.397v1.637Zm-4-1.637v1.637a6.268 6.268 0 0 0-2.44 1.514.785.785 0 0 1-1.11-1.11A7.831 7.831 0 0 1 10 9.398Zm3.512-1.706A1.995 1.995 0 0 0 12 7c-.604 0-1.145.268-1.512.69A9.383 9.383 0 0 0 5.34 10.33a.785.785 0 0 1-1.11-1.11A10.954 10.954 0 0 1 12 6c2.953 0 5.723 1.172 7.77 3.219a.785.785 0 0 1-1.11 1.11 9.382 9.382 0 0 0-5.148-2.638ZM11 9a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V9Zm1 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z", fill: "currentColor" })] }));
}, O7 = o(L7), F7 = O7, P7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.33 14.768a.785.785 0 0 0 0-1.11A4.696 4.696 0 0 0 12 12.28a4.696 4.696 0 0 0-3.33 1.38.785.785 0 0 0 1.11 1.11 3.127 3.127 0 0 1 2.22-.92c.845 0 1.634.334 2.22.92a.785.785 0 0 0 1.11 0Zm2.22-2.22a.785.785 0 0 0 0-1.11A7.825 7.825 0 0 0 12 9.14c-2.109 0-4.088.837-5.55 2.298a.785.785 0 1 0 1.11 1.11A6.256 6.256 0 0 1 12 10.71c1.689 0 3.27.669 4.44 1.84a.785.785 0 0 0 1.11 0Zm2.22-2.22a.785.785 0 0 0 0-1.11A10.954 10.954 0 0 0 12 6a10.954 10.954 0 0 0-7.77 3.219.785.785 0 1 0 1.11 1.11A9.385 9.385 0 0 1 12 7.569a9.385 9.385 0 0 1 6.66 2.76.785.785 0 0 0 1.11 0ZM12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" })] }));
}, j7 = o(P7), E7 = j7, T7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.969A6.969 6.969 0 1 0 12 5.03a6.969 6.969 0 0 0 0 13.938ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), n("path", { d: "M13.414 12.354a.5.5 0 0 1 0-.708l1.768-1.767a.75.75 0 1 0-1.06-1.061l-1.768 1.768a.5.5 0 0 1-.708 0L9.88 8.818a.75.75 0 0 0-1.061 1.06l1.768 1.768a.5.5 0 0 1 0 .708L8.818 14.12a.75.75 0 0 0 1.06 1.061l1.768-1.768a.5.5 0 0 1 .708 0l1.767 1.768a.75.75 0 0 0 1.061-1.06l-1.768-1.768Z", fill: "currentColor" })] }));
}, G7 = o(T7), ue = G7, W7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15.123.413-5.6 6.51 6.208 9.037a.25.25 0 0 1-.206.392h-4.158a.25.25 0 0 1-.206-.109l-4.288-6.24-5.387 6.262a.25.25 0 0 1-.19.087H.546a.25.25 0 0 1-.19-.413L6.246 9.09.27.391A.25.25 0 0 1 .475 0h4.158c.082 0 .16.04.206.108l4.056 5.904L13.992.087a.25.25 0 0 1 .19-.087h.752a.25.25 0 0 1 .19.413Zm-13.011.65a.1.1 0 0 0-.082.157l9.84 14.075a.1.1 0 0 0 .082.042h1.924a.1.1 0 0 0 .082-.157L4.118 1.105a.1.1 0 0 0-.082-.042H2.112Z", fill: "currentColor" })] }));
}, D7 = o(W7), U7 = D7, q7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.768 11.646a.5.5 0 0 0 0 .708l3.182 3.182a1 1 0 0 1-1.414 1.414l-3.182-3.182a.5.5 0 0 0-.708 0L8.464 16.95a1 1 0 1 1-1.414-1.414l3.182-3.182a.5.5 0 0 0 0-.708L7.05 8.464A1 1 0 1 1 8.464 7.05l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 1 1 1.414 1.414l-3.182 3.182Z", fill: "currentColor" })] }));
}, _7 = o(q7), X7 = _7, Y7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 166 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, d("g", { clipPath: "url(#a)", fill: "currentColor", children: [n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M70.1.644c-.42 0-.771.127-1.044.38a1.281 1.281 0 0 0-.413.98c0 .396.14.721.413.969.273.245.624.368 1.045.368.42 0 .773-.123 1.044-.368.274-.248.413-.573.413-.97 0-.396-.14-.725-.413-.979-.27-.253-.624-.38-1.044-.38Zm22.864 5.282A2.669 2.669 0 0 0 91.87 4.67c-.48-.28-1.089-.422-1.81-.422-.461 0-.91.085-1.34.235-.507.175-1.288.554-1.813 1.661l-.223-1.65h-2.112v10.242h2.433V8.755c0-.558.173-1.073.502-1.485a2.362 2.362 0 0 1 1.833-.886c.524 0 .917.154 1.172.457.255.305.385.833.385 1.565v6.33h2.433V7.941c-.002-.792-.126-1.47-.367-2.016ZM57.082 4.29c-1.027.133-1.916.925-2.365 1.946l-.241-1.755h-2.128v10.241h2.469V9.32c0-.668.239-1.477.666-1.946.478-.526 1.134-.75 1.806-.745.435.004.943.13.943.13l.331-2.338h-.002c-.042-.019-.574-.248-1.48-.13ZM27.449 10.51V4.508h2.45v10.241h-2.097l-.233-1.69-.075.12v.001c-.134.22-.349.573-.583.817a3.14 3.14 0 0 1-1.15.758 3.71 3.71 0 0 1-1.35.245c-.703 0-1.297-.147-1.77-.434-.474-.288-.831-.714-1.064-1.265-.232-.544-.35-1.224-.35-2.015V4.508h2.45v6.33c0 .725.121 1.245.36 1.55.238.301.613.455 1.115.455.301 0 .59-.056.855-.17a2.382 2.382 0 0 0 1.442-2.163Zm-9.442-4.83a4.625 4.625 0 0 0-1.555-1.054 4.816 4.816 0 0 0-3.683 0 4.747 4.747 0 0 0-1.555 1.054 5.003 5.003 0 0 0-1.075 1.69c-.263.663-.397 1.427-.397 2.268 0 .842.134 1.606.397 2.27a5.003 5.003 0 0 0 1.075 1.689c.45.456.973.807 1.555 1.044a4.953 4.953 0 0 0 3.683 0 4.459 4.459 0 0 0 1.556-1.044 5.26 5.26 0 0 0 1.074-1.69c.27-.663.407-1.427.407-2.269 0-.843-.137-1.607-.407-2.269a5.26 5.26 0 0 0-1.075-1.689Zm-1.688 6.377c-.415.596-.991.897-1.713.897-.722 0-1.296-.3-1.703-.897-.413-.6-.62-1.414-.62-2.419 0-1.016.21-1.838.62-2.438.409-.594.98-.898 1.703-.898.722 0 1.298.302 1.713.898.418.602.63 1.422.63 2.438 0 1.003-.212 1.817-.63 2.42Zm52.553-7.561h2.477v10.241h-2.477V4.496Zm10.927.118c.589.243 1.111.598 1.556 1.054a5.264 5.264 0 0 1 1.074 1.69c.27.661.407 1.425.407 2.268 0 .842-.138 1.606-.407 2.27a5.265 5.265 0 0 1-1.074 1.689c-.445.458-.967.81-1.556 1.044a4.953 4.953 0 0 1-3.683 0 4.628 4.628 0 0 1-1.555-1.044 5.007 5.007 0 0 1-1.075-1.69c-.263-.663-.397-1.427-.397-2.269 0-.841.134-1.605.397-2.269a5.006 5.006 0 0 1 1.075-1.689c.45-.456.973-.811 1.555-1.054a4.816 4.816 0 0 1 3.683 0Zm-1.848 8.329c.722 0 1.298-.302 1.713-.898.418-.602.632-1.415.63-2.419 0-1.016-.212-1.836-.63-2.438-.415-.596-.991-.897-1.713-.897-.722 0-1.294.303-1.703.897-.41.6-.62 1.422-.62 2.438 0 1.006.207 1.819.62 2.42.407.595.981.897 1.703.897ZM10.624 1.387H7.958L5.4 7.724 2.843 1.387H.18l3.962 9.059v4.295H6.66v-4.295l3.964-9.059Zm28.681.01h2.642L37.782 14.75h-2.883L30.733 1.397h2.64L36.34 11.87l2.965-10.473Zm9.222 10.31c-.087.167-.183.318-.285.454a2.208 2.208 0 0 1-2.823.614 2.476 2.476 0 0 1-.678-.536c-.447-.5-.662-1.159-.754-1.903h6.518c.152-.945.144-1.83-.051-2.707a6.21 6.21 0 0 0-.25-.838c-.442-1.15-1.242-1.998-2.558-2.363a4.566 4.566 0 0 0-4.225.945 4.801 4.801 0 0 0-1.003 1.205c-1.063 1.802-1.14 4.305-.042 6.113a4.802 4.802 0 0 0 4.979 2.218c.925-.174 1.799-.605 2.427-1.316.349-.395.602-.86.791-1.35-.755-.196-1.383-.361-2.046-.537Zm-3.336-5.193.023-.014a.623.623 0 0 1 .04-.024c.763-.439 1.569-.459 2.336-.002.116.068.222.162.32.273.406.465.631 1.25.54 1.92h-4.473c.058-.49.18-.937.401-1.32.19-.33.453-.612.813-.833Zm20.83.65c.334-.092.668-.184.993-.263-.297-.716-.726-1.376-1.352-1.843-.78-.588-1.793-.827-2.76-.791-.815.03-1.637.26-2.31.73-1.654 1.148-1.835 3.946.338 4.915.761.34 1.578.524 2.388.707l.32.072c.656.15 1.272.6 1.139 1.35-.098.545-.58.897-1.097 1.003-1.167.236-2.034-.21-2.632-1.332l-.803.215c-.39.104-.791.212-1.231.328.4.989 1.065 1.796 2.04 2.259a5 5 0 0 0 2.191.46c1.089-.016 2.212-.377 2.99-1.162.464-.47.763-1.099.857-1.75.137-.978-.216-1.893-.954-2.54-.683-.597-1.618-.8-2.501-.993-.171-.037-.34-.074-.505-.113l-.123-.028c-.366-.085-.802-.185-1.062-.44a.974.974 0 0 1-.275-.81c.074-.532.61-.88 1.103-.983.82-.174 1.627.24 2.028.96.055.097.169.324.169.324.34-.082.694-.179 1.048-.276Z" }), n("path", { d: "M108.953 11.357c-.057.517-.186 1-.387 1.45-.201.44-.474.823-.819 1.149a3.616 3.616 0 0 1-1.263.76c-.488.182-1.057.273-1.708.273-.709 0-1.345-.12-1.91-.359a3.825 3.825 0 0 1-1.436-1.048c-.392-.46-.698-1.019-.918-1.68-.211-.67-.316-1.43-.316-2.282 0-.862.115-1.627.344-2.297.23-.67.551-1.235.962-1.694.412-.46.895-.81 1.45-1.048a4.629 4.629 0 0 1 1.824-.36c.631 0 1.177.082 1.636.245.46.162.847.392 1.163.689.326.297.584.65.775 1.062.201.412.355.866.46 1.364l-1.292.216a4.729 4.729 0 0 0-.345-1.005 2.376 2.376 0 0 0-.531-.776 1.999 1.999 0 0 0-.775-.473c-.297-.115-.661-.173-1.091-.173-.508 0-.962.106-1.364.316a2.87 2.87 0 0 0-1.005.861c-.268.364-.474.81-.618 1.336a6.454 6.454 0 0 0-.215 1.722c0 .632.072 1.211.215 1.738a4.2 4.2 0 0 0 .618 1.335c.277.373.612.66 1.005.861a3.04 3.04 0 0 0 1.378.302c.469 0 .866-.058 1.192-.173.335-.124.607-.296.818-.516.22-.22.392-.484.517-.79.124-.306.215-.641.273-1.005h1.363ZM114.825 14.99c-.699 0-1.34-.116-1.924-.345a4.272 4.272 0 0 1-1.493-1.034c-.411-.46-.732-1.024-.962-1.694-.23-.67-.344-1.436-.344-2.297 0-.862.114-1.627.344-2.297.239-.67.565-1.235.976-1.694.422-.46.919-.81 1.493-1.048a4.991 4.991 0 0 1 1.91-.36c.699 0 1.335.12 1.909.36a3.88 3.88 0 0 1 1.493 1.033c.412.45.733 1.01.962 1.68.23.66.345 1.421.345 2.283 0 .861-.115 1.632-.345 2.311-.22.67-.536 1.235-.947 1.694-.412.46-.909.81-1.493 1.048-.575.24-1.216.36-1.924.36Zm0-1.15c.545 0 1.024-.1 1.436-.3.421-.202.77-.484 1.048-.848.277-.373.488-.818.631-1.335.144-.526.216-1.11.216-1.752 0-.631-.072-1.206-.216-1.722a3.838 3.838 0 0 0-.646-1.35 2.805 2.805 0 0 0-1.033-.861c-.412-.201-.891-.302-1.436-.302-.555 0-1.043.1-1.464.302a2.939 2.939 0 0 0-1.049.861 4 4 0 0 0-.631 1.35 6.865 6.865 0 0 0-.201 1.722 7.1 7.1 0 0 0 .201 1.752c.143.517.354.962.631 1.335.278.364.623.646 1.034.847.421.201.914.302 1.479.302ZM121.151 4.48h1.306l5.212 8.14V4.48h1.278v10.251h-1.264l-5.254-8.097v8.097h-1.278V4.481ZM130.931 4.48h1.306l5.212 8.14V4.48h1.277v10.251h-1.263l-5.255-8.097v8.097h-1.277V4.481ZM140.71 4.48h6.633v1.163h-5.312V8.86h5.025v1.178h-5.025v3.531h5.585l-.216 1.163h-6.69V4.481ZM157.346 11.357a4.86 4.86 0 0 1-.388 1.45c-.201.44-.474.823-.818 1.149a3.63 3.63 0 0 1-1.264.76c-.488.182-1.057.273-1.708.273-.708 0-1.345-.12-1.91-.359a3.821 3.821 0 0 1-1.435-1.048c-.393-.46-.699-1.019-.919-1.68-.211-.67-.316-1.43-.316-2.282 0-.862.115-1.627.344-2.297.23-.67.551-1.235.962-1.694.412-.46.895-.81 1.45-1.048a4.629 4.629 0 0 1 1.824-.36c.631 0 1.177.082 1.636.245.46.162.847.392 1.163.689.326.297.584.65.776 1.062.201.412.354.866.459 1.364l-1.292.216a4.729 4.729 0 0 0-.345-1.005 2.376 2.376 0 0 0-.531-.776 1.991 1.991 0 0 0-.775-.473c-.297-.115-.661-.173-1.091-.173-.507 0-.962.106-1.364.316a2.878 2.878 0 0 0-1.005.861c-.268.364-.474.81-.618 1.336a6.454 6.454 0 0 0-.215 1.722c0 .632.072 1.211.215 1.738a4.2 4.2 0 0 0 .618 1.335c.277.373.613.66 1.005.861a3.04 3.04 0 0 0 1.378.302c.469 0 .866-.058 1.192-.173.335-.124.607-.296.818-.516.22-.22.392-.484.517-.79.124-.306.215-.641.273-1.005h1.364ZM161.11 5.658h-3.388V4.48h8.111v1.178h-3.388v9.073h-1.335V5.658Z" })] }), n("defs", { children: n("clipPath", { id: "a", children: n("path", { fill: "#fff", transform: "translate(0 .644)", d: "M0 0h166v14.357H0z" }) }) })] }));
}, K7 = o(Y7), Q7 = K7, J7 = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 117 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M87.075.122c-.524 0-.96.159-1.301.474-.34.315-.514.725-.514 1.22 0 .493.174.898.514 1.206.34.306.777.46 1.301.46.524 0 .964-.154 1.301-.46.34-.308.514-.713.514-1.207 0-.494-.173-.904-.514-1.219-.337-.315-.777-.474-1.3-.474ZM115.547 6.7c-.303-.686-.762-1.21-1.36-1.562-.599-.35-1.356-.527-2.255-.527-.574 0-1.132.107-1.669.293-.631.219-1.604.69-2.257 2.069l-.278-2.054h-2.63v12.754h3.03v-7.45c0-.695.216-1.336.625-1.85a2.942 2.942 0 0 1 2.282-1.102c.653 0 1.143.191 1.461.568.317.38.479 1.038.479 1.95v7.881h3.029V9.21c-.002-.986-.156-1.83-.457-2.51ZM70.863 4.663c-1.28.167-2.387 1.153-2.946 2.424l-.3-2.185h-2.65v12.754h3.075v-6.73c0-.832.298-1.84.829-2.424.596-.655 1.413-.933 2.25-.928.541.005 1.174.161 1.174.161l.412-2.91-.003-.002c-.052-.022-.715-.308-1.841-.16ZM33.96 12.408V4.934h3.052v12.754H34.4l-.291-2.106-.093.152c-.167.274-.434.713-.727 1.018a3.91 3.91 0 0 1-1.432.943 4.622 4.622 0 0 1-1.681.306c-.874 0-1.614-.184-2.203-.542-.591-.357-1.035-.889-1.326-1.574-.288-.678-.434-1.525-.434-2.51v-8.44h3.049v7.883c0 .902.151 1.55.45 1.93.295.375.762.566 1.387.566.375 0 .735-.07 1.066-.211a2.966 2.966 0 0 0 1.795-2.694ZM22.202 6.394a5.76 5.76 0 0 0-1.937-1.313 5.998 5.998 0 0 0-4.586 0 5.912 5.912 0 0 0-1.937 1.313c-.561.569-1.01 1.277-1.339 2.104-.327.826-.494 1.777-.494 2.825 0 1.048.167 2 .494 2.826.328.827.778 1.535 1.339 2.104a5.765 5.765 0 0 0 1.937 1.3 6.169 6.169 0 0 0 4.586 0 5.553 5.553 0 0 0 1.937-1.3c.551-.57 1-1.277 1.338-2.104.336-.827.507-1.778.507-2.826 0-1.05-.171-2.001-.506-2.825-.338-.827-.788-1.535-1.339-2.104ZM20.1 14.335c-.517.743-1.234 1.118-2.133 1.118-.9 0-1.614-.375-2.12-1.117-.515-.748-.773-1.761-.773-3.013 0-1.266.26-2.29.772-3.037.51-.74 1.222-1.117 2.12-1.117.9 0 1.617.375 2.134 1.117.521.75.785 1.77.785 3.037 0 1.25-.264 2.262-.785 3.012ZM85.546 4.92h3.084v12.754h-3.084V4.919Zm13.607.147a5.753 5.753 0 0 1 1.937 1.313c.552.569 1.001 1.277 1.339 2.104.335.824.506 1.775.506 2.825 0 1.048-.171 2-.506 2.826-.338.827-.787 1.535-1.339 2.104a5.546 5.546 0 0 1-1.937 1.3 6.169 6.169 0 0 1-4.586 0 5.766 5.766 0 0 1-1.937-1.3c-.561-.57-1.01-1.277-1.338-2.104-.328-.827-.495-1.778-.495-2.825 0-1.048.167-2 .495-2.826.327-.827.777-1.535 1.338-2.104a5.913 5.913 0 0 1 1.937-1.313 5.946 5.946 0 0 1 2.287-.455c.792 0 1.564.152 2.3.455Zm-2.302 10.372c.9 0 1.617-.375 2.133-1.117.522-.75.788-1.764.785-3.012 0-1.267-.263-2.288-.785-3.037-.516-.743-1.234-1.118-2.132-1.118-.9 0-1.612.378-2.121 1.118-.512.747-.772 1.77-.772 3.037 0 1.251.258 2.264.772 3.012.506.742 1.222 1.117 2.12 1.117ZM13.008 1.048h-3.32L6.503 8.94 3.318 1.048H0l4.934 11.281v5.349H8.07v-5.349l4.937-11.281Zm35.718.012h3.29l-5.187 16.628h-3.59L38.05 1.06h3.288l3.694 13.042L48.725 1.06ZM60.21 13.898c-.11.209-.229.398-.355.567-.805 1.09-2.315 1.418-3.517.764a3.078 3.078 0 0 1-.844-.668c-.556-.623-.824-1.442-.939-2.368h8.118c.189-1.178.179-2.28-.065-3.373a7.75 7.75 0 0 0-.31-1.043c-.551-1.432-1.547-2.488-3.186-2.942a5.686 5.686 0 0 0-5.262 1.177 5.981 5.981 0 0 0-1.249 1.5c-1.323 2.244-1.42 5.36-.052 7.613a5.98 5.98 0 0 0 6.2 2.761c1.153-.216 2.24-.752 3.023-1.639.434-.491.75-1.07.985-1.68-.94-.244-1.723-.45-2.547-.669Zm-4.142-6.473.016-.01a.803.803 0 0 1 .048-.03c.951-.546 1.955-.571 2.91-.002.145.084.276.2.398.34.506.578.787 1.557.673 2.391h-5.57c.072-.61.224-1.167.5-1.644a2.87 2.87 0 0 1 1.012-1.038l.013-.007Zm25.926.816c.416-.114.833-.228 1.237-.327-.37-.892-.904-1.713-1.683-2.294-.971-.733-2.233-1.031-3.437-.986-1.016.037-2.039.325-2.878.909-2.059 1.43-2.285 4.914.422 6.12.948.424 1.965.654 2.974.881l.398.09c.817.187 1.585.748 1.418 1.682-.121.677-.722 1.117-1.366 1.249-1.452.293-2.532-.261-3.277-1.66l-1 .268c-.486.13-.986.264-1.533.408.499 1.232 1.326 2.238 2.54 2.814.842.4 1.798.586 2.73.573 1.355-.02 2.753-.469 3.721-1.447a3.917 3.917 0 0 0 1.068-2.18c.171-1.217-.268-2.357-1.187-3.162-.85-.744-2.015-.998-3.116-1.237-.213-.046-.423-.092-.629-.14-.049-.013-.1-.024-.152-.036-.457-.105-1-.23-1.323-.548a1.213 1.213 0 0 1-.342-1.009c.092-.663.76-1.095 1.373-1.224 1.02-.216 2.026.298 2.525 1.195.07.121.212.404.212.404.424-.102.864-.222 1.305-.343Z", fill: "currentColor" })] }));
}, en = o(J7), ln = en, tn = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022ZM10 15.5l6-3.5-6-3.5v7Z", fill: "currentColor" })] }));
}, rn = o(tn), an = rn, nn = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = u(e, ["title", "titleId"]);
  return d("svg", h(s({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M12 4c.855 0 1.732.022 2.582.058l1.004.048.961.057.9.061.822.064a3.802 3.802 0 0 1 3.494 3.423l.04.425.075.91c.07.943.122 1.971.122 2.954 0 .983-.052 2.011-.122 2.954l-.075.91c-.013.146-.026.287-.04.425a3.802 3.802 0 0 1-3.495 3.423l-.82.063-.9.062-.962.057-1.004.048A61.58 61.58 0 0 1 12 20a61.58 61.58 0 0 1-2.582-.058l-1.004-.048-.961-.057-.9-.062-.822-.063a3.802 3.802 0 0 1-3.494-3.423l-.04-.425-.075-.91A40.662 40.662 0 0 1 2 12c0-.983.052-2.011.122-2.954l.075-.91c.013-.146.026-.287.04-.425A3.802 3.802 0 0 1 5.73 4.288l.821-.064.9-.061.962-.057 1.004-.048A61.68 61.68 0 0 1 12 4Zm0 2c-.825 0-1.674.022-2.5.056l-.978.047-.939.055-.882.06-.808.063a1.802 1.802 0 0 0-1.666 1.623C4.11 9.113 4 10.618 4 12c0 1.382.11 2.887.227 4.096.085.872.777 1.55 1.666 1.623l.808.062.882.06.939.056.978.047c.826.034 1.675.056 2.5.056s1.674-.022 2.5-.056l.978-.047.939-.055.882-.06.808-.063a1.801 1.801 0 0 0 1.666-1.623C19.89 14.887 20 13.382 20 12c0-1.382-.11-2.887-.227-4.096a1.802 1.802 0 0 0-1.666-1.623l-.808-.062-.882-.06-.939-.056-.978-.047A60.71 60.71 0 0 0 12 6Zm-2 3.575a.6.6 0 0 1 .819-.559l.081.04 4.2 2.424a.602.602 0 0 1 .085.98l-.085.06-4.2 2.425a.6.6 0 0 1-.894-.43l-.006-.09v-4.85Z", fill: "currentColor" })] }));
}, dn = o(nn), on = dn;
const cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AaStroked: nl,
  Alert: gl,
  ArrowDownLineStroked: bl,
  ArrowDownStroked: yl,
  ArrowLeftStroked: Zl,
  ArrowRightStroked: Rl,
  ArrowTwoCircle: Bl,
  ArrowUpStroked: Hl,
  ArrowsDiagonalInStroked: Ll,
  ArrowsDiagonalOutStroked: Pl,
  ArrowsUpDown: Tl,
  BackwardStroked: Dl,
  BankStroked: cl,
  BellStroked: _l,
  BibleFilled: Kl,
  BibleSmallStroked: et,
  BibleStroked: rt,
  BoltStroked: nt,
  BookmarkFilled: ct,
  BookmarkStroked: ut,
  BorderedArrowsUpDown: gt,
  BorderedArrowsUpDownStroked: bt,
  BoxArchiveStroked: yt,
  BoxArrowDiagonalRight: Zt,
  BoxArrowUpStroked: Rt,
  BoxStackStroked: Bt,
  BubbleSpeechFilled: Ht,
  BubbleSpeechStroked: Lt,
  BullhornStroked: Pt,
  Calendar: Tt,
  CameraStroked: Dt,
  CardAmexStroked: _t,
  CardAppleStroked: Kt,
  CardDiscoverStroked: e4,
  CardPaypalStroked: r4,
  CardVisaStroked: n4,
  Chart: c4,
  ChartStroked: u4,
  CheckmarkBoxStackFilled: g4,
  CheckmarkBoxStackStroked: b4,
  CheckmarkCircle: Z4,
  CheckmarkCircleStroked: y4,
  CheckmarkStroked: he,
  Chevron2LeftStroked: S4,
  Chevron2RightStroked: A4,
  ChevronDownStroked: $4,
  ChevronLeftCircleStroked: F4,
  ChevronLeftStroked: E4,
  ChevronRightCircleStroked: W4,
  ChevronRightStroked: q4,
  ChevronUpStroked: Y4,
  ClockBackStroked: J4,
  ClockStroked: tr,
  ColorInvertStroked: ar,
  Columns1Stroked: or,
  Columns2Stroked: hr,
  CreditCardStroked: fr,
  DiagonalPaperAirplane: wr,
  DiagonalPaperAirplaneStroked: xr,
  Dismiss: kr,
  DismissKeyboard: zr,
  Dots3HorizontalStroked: Sr,
  Dots3VerticalStroked: Ar,
  DragIndicator: $r,
  Envelope: Fr,
  EnvelopeStroked: Er,
  EyeSlashStroked: qr,
  EyeSlashStroked1: Wr,
  EyeStroked: Yr,
  FacebookFilled: Jr,
  FacebookStroked: t5,
  FlameStroked: a5,
  Folder: o5,
  FolderStroked: h5,
  FontStroked: f5,
  ForwardStroked: w5,
  GearStroked: x5,
  GlobeStroked: k5,
  Gobackward15Stroked: z5,
  Gobackward30Stroked: S5,
  GobackwardStroked: A5,
  Goforward15Stroked: $5,
  Goforward30Stroked: F5,
  Grid4: E5,
  Grid4Stroked: W5,
  HandleDown: q5,
  HandleStraight: Y5,
  HandleUp: J5,
  HandsPrayingStroked: t3,
  HeartFilled: a3,
  HeartStroked: o3,
  HighlighterFilled: h3,
  HighlighterStroked: f3,
  HourglassEmpty: w3,
  HourglassTop: x3,
  HouseFilled: k3,
  HouseStroked: z3,
  ImageBoxStackStroked: S3,
  ImageSingle: A3,
  InfoCircle: $3,
  InfoCircleStroked: F3,
  InstagramStroked: E3,
  Keyboard: W3,
  LanguageIcon: q3,
  LightbulbStroked: Y3,
  Line: wi,
  Line3HorizontalBoldFilled: J3,
  Line3HorizontalStroked: ti,
  LineHorizontal3Mid: ai,
  LineHoriztonal3Loose: oi,
  LineHoriztonal3Tight: hi,
  LineHoriztonalStroked: fi,
  Link: xi,
  Linkedin: ki,
  ListBullet3Stroked: zi,
  ListBullet4Stroked: Si,
  LocationStroked: Ai,
  Lock: $i,
  LockStroked: Fi,
  MagnifyingGlassBoldFilled: Ei,
  MagnifyingGlassStroked: Wi,
  MapPinStroked: qi,
  MapStroked: Yi,
  MasterCardStroked: ul,
  MedalStroked: Ji,
  Messages: ta,
  MicStroked: aa,
  MinusCircleStroked: oa,
  MoonStroked: ha,
  NarrowCalendar: fa,
  NarrowCalendarStroked: wa,
  NavbarBackStroked: xa,
  NoteBoxStackStroked: ka,
  PaintPaletteStroked: za,
  PaperAirplaneStroked: Sa,
  PauseStroked: Aa,
  PencilFilled: $a,
  PencilStroked: Fa,
  PeopleAddStroked: Ea,
  PeopleFilled: Wa,
  PeopleStroked: qa,
  PersonFilled: Ya,
  PersonStroked: Ja,
  PhoneStroked: t8,
  Pin: a8,
  PinStroked: o8,
  PinterestFilled: h8,
  PinterestStroked: f8,
  Plans: w8,
  PlayFilled: x8,
  PlusCircle: k8,
  PlusCircleStroked: z8,
  PlusStroked: S8,
  QuestionCircleStroked: A8,
  RectangleCarouselStroked: $8,
  RectangleStackStroked: F8,
  RectanglesOverlappingStroked: E8,
  RedditStroked: W8,
  ShareMaterialStroked: q8,
  ShareWebStroked: Y8,
  ShuffleStroked: J8,
  SmartphoneView: t6,
  SortAlphaStroked: a6,
  Sparkle: o6,
  SparkleStroked: h6,
  SpeakerOnStroked: f6,
  SpeakerSlashStroked: w6,
  SpeechBubbleDotsStroked: x6,
  Spinner: k6,
  Star5PointFilled: z6,
  Star5PointStroked: S6,
  Star7PointStroked: A6,
  SunFilled: $6,
  SunStroked: F6,
  SwitchSlider2Stroked: E6,
  TagStroked: W6,
  TextAlignCenterStroked: q6,
  TextAlignLeftStroked: Y6,
  TextAlignRightStroked: J6,
  TextDoc: t7,
  TextFilterDecreaseStroked: a7,
  TextStroked: o7,
  Tiktok: h7,
  TrashCan: f7,
  TriangleDownStroked: w7,
  Tumblr: x7,
  TwitterFilled: k7,
  TwitterStroked: z7,
  VideoBoxStackFilled: S7,
  VideoBoxStackStroked: A7,
  Whatsapp: $7,
  WifiExclamationStroked: F7,
  WifiStroked: E7,
  XCircleStroked: ue,
  XStroked: X7,
  XTwitterStroked: U7,
  YouVersionConnectLogo: Q7,
  YouVersionLogo: ln,
  Youtube: an,
  YoutubeStroked: on
}, Symbol.toStringTag, { value: "Module" }));
var sn = Object.defineProperty, hn = Object.defineProperties, un = Object.getOwnPropertyDescriptors, P1 = Object.getOwnPropertySymbols, ve = Object.prototype.hasOwnProperty, fe = Object.prototype.propertyIsEnumerable, I0 = (l, r, e) => r in l ? sn(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, vn = (l, r) => {
  for (var e in r || (r = {}))
    ve.call(r, e) && I0(l, e, r[e]);
  if (P1)
    for (var e of P1(r))
      fe.call(r, e) && I0(l, e, r[e]);
  return l;
}, fn = (l, r) => hn(l, un(r)), gn = (l, r) => {
  var e = {};
  for (var t in l)
    ve.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && P1)
    for (var t of P1(l))
      r.indexOf(t) < 0 && fe.call(l, t) && (e[t] = l[t]);
  return e;
}, pn = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = gn(e, ["title", "titleId"]);
  return d("svg", fn(vn({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.712 12.484a1.002 1.002 0 0 1 1.417-.001l2.648 2.654a.25.25 0 0 0 .353 0l6.895-6.894a1 1 0 0 1 1.414 1.414l-7.782 7.781a1 1 0 0 1-1.414 0L6.71 13.9a1.002 1.002 0 0 1 .002-1.416Z", fill: "currentColor" })] }));
}, wn = o(pn), bn = wn;
const mn = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.402 8.931c-.298-.09-.5-.335-.505-.614V8.814c-.018-.34.222-.65.587-.759.389-.132.83-.02 1.08.272a.639.639 0 0 1 .16.432v1.74c0 .564-.013 1.128 0 1.693a.765.765 0 0 1-.325.624.998.998 0 0 1-.755.172 1.389 1.389 0 0 1-.242-.057Zm.383 3.032a.982.982 0 1 1 .008 0h-.008Z",
          fill: "currentColor"
        }
      )
    ]
  }
), xn = o(mn), yn = xn, Cn = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.16 11.988a1.389 1.389 0 0 1-.242-.057c-.298-.09-.5-.335-.505-.614v-3.503c-.018-.34.222-.65.587-.759.389-.132.83-.02 1.08.272a.639.639 0 0 1 .16.432v1.74c0 .564-.013 1.128 0 1.693a.765.765 0 0 1-.325.624.998.998 0 0 1-.755.172Zm.14-6.025a.982.982 0 1 1 .009 0h-.008Z",
          fill: "currentColor"
        }
      )
    ]
  }
), kn = o(Cn), Zn = kn, Mn = {
  default: "mie-1 text-muted-light dark:text-muted-dark",
  error: "mie-1 text-alert-light dark:text-alert-dark",
  info: "mie-1 text-info-light dark:text-info-dark",
  mail: "mie-1 text-info-light dark:text-info-dark",
  success: "mie-1 text-success-light dark:text-success-dark",
  warning: "mie-1 text-caution-light dark:text-caution-dark"
}, Z1 = "flex flex-start items-center justify-start plb-2 pis-2 pie-4 rounded-1 w-full text-base leading-normal box-border gap-sm", zn = {
  default: v(Z1, "bg-gray-10 dark:bg-gray-40"),
  error: v(Z1, "bg-orange-10 dark:bg-orange-50"),
  info: v(Z1, "bg-blue-10 dark:bg-blue-50"),
  mail: v(Z1, "bg-gray-10 dark:bg-gray-40"),
  success: v(Z1, "bg-green-10 dark:bg-green-50"),
  warning: v(Z1, "bg-yellow-10 dark:bg-yellow-40")
}, Rn = {
  default: "text-text-light dark:text-text-dark",
  error: "text-orange-40 dark:text-orange-20",
  info: "text-blue-40 dark:text-blue-20",
  mail: "text-text-light dark:text-text-dark",
  success: "text-green-40 dark:text-green-20",
  warning: "text-yellow-40 dark:text-yellow-20"
};
function hc({ className: l, children: r, variant: e = "default" }) {
  const t = Q(() => {
    if (e === "success")
      return /* @__PURE__ */ n(bn, {});
    if (e === "warning" || e === "error")
      return /* @__PURE__ */ n(yn, {});
    if (e !== "mail")
      return /* @__PURE__ */ n(Zn, {});
  }, [e]);
  return /* @__PURE__ */ d("div", { className: v(zn[e], l), children: [
    /* @__PURE__ */ n("div", { className: Mn[e], children: t }),
    typeof r == "string" ? /* @__PURE__ */ n(V, { className: Rn[e], children: r }) : r
  ] });
}
const In = ({
  children: l,
  component: r = "a",
  className: e,
  disabled: t,
  active: a,
  ...i
}) => /* @__PURE__ */ n(
  V,
  {
    className: v([
      "font-bold text-gray-50 leading-default whitespace-nowrap",
      a ? "underline decoration-yv-red decoration-2 underline-offset-8 text-16 leading-loose" : "text-13",
      t ? "cursor-none pointer-events-none text-text-muted-light dark:text-text-muted-dark" : "",
      e
    ]),
    component: r,
    ...i,
    children: l
  }
);
In.displayName = "Breadcrumb";
var Sn = Object.defineProperty, Bn = Object.defineProperties, Nn = Object.getOwnPropertyDescriptors, j1 = Object.getOwnPropertySymbols, ge = Object.prototype.hasOwnProperty, pe = Object.prototype.propertyIsEnumerable, S0 = (l, r, e) => r in l ? Sn(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, An = (l, r) => {
  for (var e in r || (r = {}))
    ge.call(r, e) && S0(l, e, r[e]);
  if (j1)
    for (var e of j1(r))
      pe.call(r, e) && S0(l, e, r[e]);
  return l;
}, Hn = (l, r) => Bn(l, Nn(r)), Vn = (l, r) => {
  var e = {};
  for (var t in l)
    ge.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && j1)
    for (var t of j1(l))
      r.indexOf(t) < 0 && pe.call(l, t) && (e[t] = l[t]);
  return e;
}, $n = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Vn(e, ["title", "titleId"]);
  return d("svg", Hn(An({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z", fill: "currentColor" })] }));
}, Ln = o($n), we = Ln;
const On = ({ children: l, className: r, ...e }, t) => {
  const a = Ue.toArray(l).filter(J1).map((c) => ({
    type: c.type,
    props: c.props
  })), i = a.findIndex(
    (c) => J1(c) ? c.props.active : !1
  );
  return /* @__PURE__ */ n("div", { className: v(["flex py-0.5 flex-row min-h-[48px] rtl:rotate-180", r]), ref: t, ...e, children: a.map((c, f) => /* @__PURE__ */ d("div", { className: "flex items-center", children: [
    f ? /* @__PURE__ */ n(
      we,
      {
        className: v([
          "mx-1",
          f > i && "text-gray-15",
          f <= i && "text-gray-25"
        ]),
        size: "15"
      }
    ) : null,
    typeof c == "object" && "type" in c ? a1(c.type, {
      ...c.props,
      className: v([
        c.props.className ?? "",
        f < i ? "bg-gray-10 dark:bg-gray-40 py-1 px-2 rounded-3 cursor-pointer" : "px-0.5",
        f > i && "[&>*]:text-gray-15 [&>*]:text-16 [&>*]:leading-loose [&>*]:font-medium",
        "rtl:rotate-180"
      ])
    }) : c
  ] }, `${f}-${c.toString()}`)) });
}, Fn = o(On);
Fn.displayName = "Breadcrumbs";
const uc = {
  lg: "lg",
  md: "md",
  sm: "sm",
  xl: "xl",
  xs: "xs"
}, be = (l) => {
  switch (l) {
    case "start":
      return {
        lg: "rounded-4 text-19 pis-3 pie-5 h-8",
        md: "rounded-3 text-xs pis-2 pie-3 h-6",
        sm: "rounded-3 text-13 pis-1.5 pie-2 h-4",
        xl: "rounded-5 text-23 pis-5 pie-6 h-10",
        xs: "rounded-3 text-11 pis-0.5 pie-1.5 h-3"
      };
    case "end":
      return {
        lg: "rounded-4 text-19 pie-3 pis-5 h-8",
        md: "rounded-3 text-xs pie-2 pis-3 h-6",
        sm: "rounded-3 text-13 pie-1.5 pis-2 h-4",
        xl: "rounded-5 text-23 pie-5 pis-6 h-10",
        xs: "rounded-3 text-11 pie-0.5 pis-1.5 h-3"
      };
    default:
      return {
        lg: "rounded-4 text-19 px-5 h-8",
        md: "rounded-3 text-xs px-3 h-6",
        sm: "rounded-3 text-13 px-2 h-4",
        xl: "rounded-5 text-23 px-6 h-10",
        xs: "rounded-3 text-11 px-1.5 h-3"
      };
  }
}, S1 = {
  lg: 24,
  md: 24,
  sm: 16,
  xl: 36,
  xs: 16
}, me = "relative items-center leading-default font-bold ease-in-out duration-100 focus:outline-2 focus:outline-info-light dark:focus:outline-info-dark hover:shadow-light-2 disabled:bg-gray-10 disabled:text-gray-50 dark:disabled:bg-gray-40 dark:disabled:text-white disabled:hover:shadow-none disabled:opacity-50 disabled:bg-gray-10 disabled:cursor-not-allowed flex w-full max-w-fit", X = {
  // bgColor, outlineColor, disabled, fontColor, hover, pressed, disabled, textTransform
  all_caps: "",
  // Obsolete, superseded by 'borderless'
  borderless: "bg-transparent text-gray-50 dark:text-white active:bg-gray-15 dark:active:bg-gray-45",
  brand: "",
  // Obsolete, superseded by 'filled:brand',
  "filled:brand": "bg-yv-red dark:bg-yv-red-dark text-white",
  "filled:contrast": "bg-gray-40 dark:bg-gray-10 text-white dark:text-gray-50 hover:dark:bg-gray-5 active:bg-gray-50",
  "filled:default": "bg-gray-10 dark:bg-gray-40 text-gray-50 dark:text-white hover:bg-gray-5 dark:hover:bg-gray-35 active:bg-gray-20 dark:active:bg-gray-40",
  "filled:secondary": "bg-gray-15 dark:bg-gray-35 text-gray-50 dark:text-white hover:bg-gray-10 dark:hover:bg-gray-30 active:bg-gray-20 dark:active:bg-gray-40",
  primary: "",
  // Obsolete, superseded by 'filled:default',
  risk: "bg-transparent ring-2 ring-alert dark:ring-alert-dark text-alert dark:text-alert-dark hover:ring-alert-hover dark:hover:ring-alert-dark-hover active:bg-gray-15 dark:active:bg-gray-45 disabled:text-alert dark:disabled:text-alert-dark disabled:ring-0",
  "risk:all_caps": "",
  // Obsolete, superseded by 'risk:borderless'
  "risk:borderless": "bg-transparent text-alert dark:text-alert-dark active:bg-gray-15 dark:active:bg-gray-45 disabled:text-alert dark:disabled:text-alert-dark",
  "risk:stroked": "",
  // Obsolete, superseded by 'risk'
  secondary: "",
  // Obsolete, superseded by 'filled:secondary'
  stroked: "bg-transparent border-1 border-small border-gray-15 dark:border-gray-30 text-gray-50 dark:text-white hover:border-gray-10 dark:hover:border-gray-25 active:bg-gray-15 dark:active:bg-gray-35 disabled:border-0",
  "stroked:contrast": "bg-transparent border-2 border-standard border-gray-50 dark:border-gray-30 text-gray-50 dark:text-white active:bg-gray-15 dark:active:bg-gray-35 disabled:border-0",
  strokedSecondary: "bg-transparent border-1 border-small border-tertiary-light dark:border-tertiary-dark text-text-light dark:text-text-dark hover:bg-gray-10 dark:hover:bg-gray-30 dark:hover:text-gray-50 active:bg-gray-50 disabled:opacity-50 disabled:bg-transparent dark:disabled:bg-transparent disabled:text-gray-50 dark:disabled:text-white"
};
X.primary = X["filled:default"];
X.secondary = X["filled:secondary"];
X.brand = X["filled:brand"];
X.all_caps = v(X.borderless, "uppercase");
X["risk:all_caps"] = v(X["risk:borderless"], "uppercase");
X["risk:stroked"] = v(X.risk, "uppercase");
const Pn = ({
  className: l,
  children: r,
  disabled: e,
  icon: t,
  iconAction: a,
  iconPosition: i,
  isLoading: c,
  loadingSpinnerLabel: f,
  size: g = "md",
  type: p = "button",
  variant: b = "filled:default",
  ...w
}, k) => {
  const m = be(t !== void 0 ? i : void 0), I = v(
    me,
    X[b],
    m[g],
    { "disabled:opacity-100": c },
    l
  );
  return /* @__PURE__ */ d("button", { className: I, disabled: e || c, ref: k, type: p, ...w, children: [
    i === "start" && t !== void 0 ? a1(t, {
      className: g === "xs" ? "mie-0.25" : "mie-0.5",
      onClick: a ?? void 0,
      size: S1[g]
    }) : null,
    /* @__PURE__ */ n("span", { className: "w-full", children: r }),
    i === "end" && t !== void 0 ? a1(t, {
      className: g === "xs" ? "mis-0.25" : "mis-0.5",
      onClick: a ?? void 0,
      size: S1[g]
    }) : null,
    c !== void 0 ? /* @__PURE__ */ n(
      "div",
      {
        className: v(
          "bg-tertiary-light z-100 absolute inset-0 transition-opacity",
          c ? "opacity-100" : "opacity-0 pointer-events-none"
        ),
        children: c ? /* @__PURE__ */ n(A1, { "aria-label": f, color: "text-[#777a7b]", iconSize: S1[g] }) : null
      }
    ) : null
  ] });
}, B1 = o(Pn);
B1.displayName = "Button";
const jn = ({ error: l, className: r, label: e, disabled: t, name: a, labelProps: i, ...c }, f) => {
  const g = qe(), p = Q(() => `checkbox-label-${g}`, [g]), { className: b, ...w } = i ?? {};
  return /* @__PURE__ */ d(
    "div",
    {
      className: v([
        "flex items-baseline rounded-0.5 mie-0.5 w-fit focus-within:border-transparent focus-within:outline-2 focus-within:outline-info focus-within:outline focus-within:dark:border-transparent focus-within:dark:outline-info-dark",
        r
      ]),
      children: [
        /* @__PURE__ */ n(
          "input",
          {
            "aria-labelledby": p,
            className: "w-1.5 h-1.5 flex-none rounded-0.25 focus-within:outline-none peer",
            disabled: t,
            id: a,
            name: a,
            ref: f,
            type: "checkbox",
            ...c
          }
        ),
        /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
          e ? /* @__PURE__ */ n(
            "div",
            {
              className: v(
                "peer-disabled:text-text-muted-light peer-disabled:dark:text-text-muted-dark text-text-light dark:text-text-dark",
                b
              ),
              children: /* @__PURE__ */ n("label", { htmlFor: a, id: p, ...w, children: e })
            }
          ) : null,
          l ? /* @__PURE__ */ n("div", { className: "text-alert-light dark:text-alert-dark text-13", children: l }) : null
        ] })
      ]
    }
  );
}, En = o(jn);
En.displayName = "Checkbox";
const Tn = ({
  className: l,
  disabled: r,
  enableResetButton: e,
  error: t,
  inputContainerClassName: a,
  label: i,
  name: c,
  onChange: f,
  placeholder: g = i,
  resetAriaLabel: p = "Reset color",
  resetValue: b = "#FFFFFF",
  value: w,
  ...k
}, m) => {
  "use client";
  const I = /^#[0-9A-F]{0,6}$/i, x = /^#([0-9A-F]{3}){1,2}$/i, z = q(null), y = q(null), [S, A] = _(!1), H = m ?? z, O = (R) => {
    if (!R.target.value.length)
      return f(R);
    const B = R.target.value.startsWith("#") ? R.target.value : `#${R.target.value}`;
    I.test(B) && (R.target.value = B, f(R));
  };
  function N(R) {
    const B = x.test(b) ? b : "";
    R.target.value = B, R.target.name = c, f(R);
  }
  function M() {
    var R;
    r || (A(!0), (R = H == null ? void 0 : H.current) == null || R.focus());
  }
  function C() {
    A(!1);
  }
  return /* @__PURE__ */ d("div", { className: l, children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: v(
          "flex justify-between h-[56px] pie-1.5 pis-2 rounded-1 text-black border-tertiary-light dark:border-tertiary-dark border-small focus:border-blue-30 cursor-text",
          a,
          r ? "bg-gray-10 dark:bg-overlay-body-dark cursor-default" : "",
          t ? "border-alert dark:border-alert-dark" : "",
          S ? "border-blue-30 border-standard" : ""
        ),
        onClick: M,
        children: [
          /* @__PURE__ */ d("div", { className: "flex flex-col justify-center items-start", id: "labelAndInput", children: [
            w || !w && S ? /* @__PURE__ */ n("label", { className: "text-13 font-medium text-gray-25", htmlFor: `${c}-input`, children: i }) : null,
            /* @__PURE__ */ n("div", { id: "inputWrapper", children: /* @__PURE__ */ n(
              "input",
              {
                className: "text-16 font-regular dark:text-white text-gray-50 focus:outline-none bg-transparent",
                disabled: r,
                id: `${c}-input`,
                maxLength: 7,
                name: c,
                onBlur: C,
                onChange: O,
                placeholder: g ?? i,
                ref: H,
                type: "text",
                value: w
              }
            ) })
          ] }),
          /* @__PURE__ */ d("div", { className: "flex", children: [
            /* @__PURE__ */ d("div", { className: "flex items-center relative", children: [
              /* @__PURE__ */ n(
                "input",
                {
                  className: "w-[40px] h-[40px] bg-transparent cursor-pointer invisible",
                  disabled: r,
                  id: `${c}-picker`,
                  name: c,
                  onChange: O,
                  placeholder: `${c}-picker`,
                  ref: y,
                  type: "color",
                  value: w || b,
                  ...k
                }
              ),
              /* @__PURE__ */ n(
                "div",
                {
                  className: v(
                    "w-[40px] h-[40px] rounded-6 absolute",
                    !w || w.toLowerCase() === "#fff" || w.toLowerCase() === "#ffffff" ? "border-small border-tertiary-light" : "",
                    r ? "cursor-default" : "cursor-pointer"
                  ),
                  onClick: () => {
                    var R;
                    y && y.current && ((R = y.current) == null || R.click());
                  },
                  style: {
                    backgroundColor: w || b
                  }
                }
              )
            ] }),
            e && w && w.toLowerCase() !== b.toLowerCase() ? /* @__PURE__ */ n(
              "button",
              {
                "aria-label": p,
                className: "mis-1",
                disabled: r,
                id: `${c}-reset`,
                onClick: N,
                type: "button",
                children: /* @__PURE__ */ n(ue, { className: "text-gray-25 dark:text-gray-20" })
              }
            ) : null
          ] })
        ]
      }
    ),
    t ? /* @__PURE__ */ n("p", { className: "flex rtl:flex-row-reverse font-regular text-alert text-13", children: t }) : null
  ] });
}, Gn = o(Tn);
Gn.displayName = "Color Select";
var Wn = Object.defineProperty, Dn = Object.defineProperties, Un = Object.getOwnPropertyDescriptors, E1 = Object.getOwnPropertySymbols, xe = Object.prototype.hasOwnProperty, ye = Object.prototype.propertyIsEnumerable, B0 = (l, r, e) => r in l ? Wn(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, qn = (l, r) => {
  for (var e in r || (r = {}))
    xe.call(r, e) && B0(l, e, r[e]);
  if (E1)
    for (var e of E1(r))
      ye.call(r, e) && B0(l, e, r[e]);
  return l;
}, _n = (l, r) => Dn(l, Un(r)), Xn = (l, r) => {
  var e = {};
  for (var t in l)
    xe.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && E1)
    for (var t of E1(l))
      r.indexOf(t) < 0 && ye.call(l, t) && (e[t] = l[t]);
  return e;
}, Yn = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Xn(e, ["title", "titleId"]);
  return d("svg", _n(qn({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M5.74 11.293a1 1 0 0 0-1.415 1.414l6.647 6.646a1.5 1.5 0 0 0 2.121 0l6.647-6.646a1 1 0 0 0-1.415-1.414l-4.898 4.899a.25.25 0 0 1-.427-.177V5a1 1 0 1 0-2 0v10.95a.25.25 0 0 1-.427.177L5.74 11.293Z", fill: "currentColor" })] }));
}, Kn = o(Yn), Qn = Kn, Jn = Object.defineProperty, ed = Object.defineProperties, ld = Object.getOwnPropertyDescriptors, T1 = Object.getOwnPropertySymbols, Ce = Object.prototype.hasOwnProperty, ke = Object.prototype.propertyIsEnumerable, N0 = (l, r, e) => r in l ? Jn(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, td = (l, r) => {
  for (var e in r || (r = {}))
    Ce.call(r, e) && N0(l, e, r[e]);
  if (T1)
    for (var e of T1(r))
      ke.call(r, e) && N0(l, e, r[e]);
  return l;
}, rd = (l, r) => ed(l, ld(r)), id = (l, r) => {
  var e = {};
  for (var t in l)
    Ce.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && T1)
    for (var t of T1(l))
      r.indexOf(t) < 0 && ke.call(l, t) && (e[t] = l[t]);
  return e;
}, ad = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = id(e, ["title", "titleId"]);
  return d("svg", rd(td({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "m15.536 9.05-3.182-3.182a.5.5 0 0 0-.708 0L8.464 9.05A1 1 0 0 1 7.05 7.636l3.89-3.889a1.5 1.5 0 0 1 2.12 0l3.89 3.889a1 1 0 0 1-1.414 1.414ZM8.464 14.95l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 0 1 1.414 1.414l-3.89 3.889a1.5 1.5 0 0 1-2.12 0l-3.89-3.89a1 1 0 1 1 1.414-1.413Z", fill: "currentColor" })] }));
}, nd = o(ad), dd = nd, od = Object.defineProperty, cd = Object.defineProperties, sd = Object.getOwnPropertyDescriptors, G1 = Object.getOwnPropertySymbols, Ze = Object.prototype.hasOwnProperty, Me = Object.prototype.propertyIsEnumerable, A0 = (l, r, e) => r in l ? od(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, hd = (l, r) => {
  for (var e in r || (r = {}))
    Ze.call(r, e) && A0(l, e, r[e]);
  if (G1)
    for (var e of G1(r))
      Me.call(r, e) && A0(l, e, r[e]);
  return l;
}, ud = (l, r) => cd(l, sd(r)), vd = (l, r) => {
  var e = {};
  for (var t in l)
    Ze.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && G1)
    for (var t of G1(l))
      r.indexOf(t) < 0 && Me.call(l, t) && (e[t] = l[t]);
  return e;
}, fd = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = vd(e, ["title", "titleId"]);
  return d("svg", ud(hd({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M18.26 12.707a1 1 0 1 0 1.415-1.414l-6.647-6.647a1.5 1.5 0 0 0-2.121 0L4.26 11.293a1 1 0 1 0 1.415 1.414l4.898-4.898a.25.25 0 0 1 .427.176V19a1 1 0 1 0 2 0V8.05a.25.25 0 0 1 .427-.177l4.833 4.834Z", fill: "currentColor" })] }));
}, gd = o(fd), pd = gd, wd = Object.defineProperty, bd = Object.defineProperties, md = Object.getOwnPropertyDescriptors, W1 = Object.getOwnPropertySymbols, ze = Object.prototype.hasOwnProperty, Re = Object.prototype.propertyIsEnumerable, H0 = (l, r, e) => r in l ? wd(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, xd = (l, r) => {
  for (var e in r || (r = {}))
    ze.call(r, e) && H0(l, e, r[e]);
  if (W1)
    for (var e of W1(r))
      Re.call(r, e) && H0(l, e, r[e]);
  return l;
}, yd = (l, r) => bd(l, md(r)), Cd = (l, r) => {
  var e = {};
  for (var t in l)
    ze.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && W1)
    for (var t of W1(l))
      r.indexOf(t) < 0 && Re.call(l, t) && (e[t] = l[t]);
  return e;
}, kd = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Cd(e, ["title", "titleId"]);
  return d("svg", yd(xd({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { d: "M9.346 14.272c.15.228.499.228 1.194.228h5.628c.81 0 1.215 0 1.36-.262.145-.261-.07-.605-.5-1.292l-.667-1.068c-.386-.618-.58-.928-.861-.928s-.475.31-.861.928l-.453.724-1.252-2.924c-.4-.931-.6-1.397-.934-1.397-.335 0-.534.466-.934 1.397l-1.46 3.406c-.273.64-.41.96-.26 1.188ZM18 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.879 3.379C6 4.257 6 5.672 6 8.5v3c0 2.828 0 4.243.879 5.121.878.879 2.293.879 5.121.879h3c2.828 0 4.243 0 5.121-.879C21 15.743 21 14.328 21 11.5v-3c0-2.828 0-4.243-.879-5.121C19.243 2.5 17.828 2.5 15 2.5h-3c-2.828 0-4.243 0-5.121.879ZM18.02 4.623c-.65-.087-1.55-.092-3.021-.092h-3c-1.472 0-2.371.005-3.021.092-.301.04-.466.09-.554.126a.292.292 0 0 0-.11.066.292.292 0 0 0-.066.11 2.313 2.313 0 0 0-.126.554c-.087.65-.092 1.55-.092 3.021v3c0 1.472.005 2.371.092 3.021.04.301.09.466.126.554.03.072.05.095.066.11a.292.292 0 0 0 .11.066c.088.036.253.085.554.126.65.087 1.55.092 3.021.092h3c1.472 0 2.371-.005 3.021-.092.301-.04.466-.09.554-.126a.292.292 0 0 0 .11-.066.292.292 0 0 0 .066-.11c.036-.088.085-.253.126-.554.087-.65.092-1.55.092-3.021v-3c0-1.472-.005-2.371-.092-3.021a2.313 2.313 0 0 0-.126-.554.292.292 0 0 0-.066-.11.292.292 0 0 0-.11-.066 2.313 2.313 0 0 0-.554-.126Z", fill: "currentColor" }), n("path", { d: "M2 8.5c0-1 1-2 2-2v9a4 4 0 0 0 4 4h9c0 1-.887 2-2 2H8a6 6 0 0 1-6-6v-7Z", fill: "currentColor" })] }));
}, Zd = o(kd), Ie = Zd;
const Md = ({
  children: l,
  className: r,
  disabled: e,
  isLoading: t,
  loadingSpinnerLabel: a,
  type: i = "button",
  variant: c = "borderless",
  ...f
}, g) => /* @__PURE__ */ d(
  "button",
  {
    className: v([
      "overflow-hidden relative rounded-full inline-flex justify-center items-center p-1",
      X[c],
      {
        "disabled:opacity-100": t,
        "pointer-events-none": e || t
      },
      r
    ]),
    disabled: e || t,
    ref: g,
    type: i,
    ...f,
    children: [
      l,
      t !== void 0 ? /* @__PURE__ */ n(
        "div",
        {
          className: v(
            "bg-tertiary-light z-100 absolute inset-0 transition-opacity",
            t ? "opacity-100" : "opacity-0"
          ),
          children: t ? /* @__PURE__ */ n(A1, { "aria-label": a, color: "text-[#777a7b]", iconSize: 30 }) : null
        }
      ) : null
    ]
  }
), H1 = o(Md);
H1.displayName = "IconButton";
const zd = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.5 5.293a1 1 0 0 1 0 1.414l-4.94 4.94a.5.5 0 0 0 0 .707l4.94 4.939a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5 5.293a1 1 0 0 1 0 1.414l-4.94 4.94a.5.5 0 0 0 0 .707l4.94 4.939a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Rd = o(zd), V0 = Rd, Id = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Sd = o(Id), $0 = Sd, Bd = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.707 5.293a1 1 0 0 1 0 1.414l-5.116 5.116a.25.25 0 0 0 0 .354l5.116 5.116a1 1 0 1 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 0Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Nd = o(Bd), L0 = Nd, Ad = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.293 18.707a1 1 0 0 1 0-1.414l4.94-4.94a.5.5 0 0 0 0-.707l-4.94-4.939a1 1 0 0 1 1.414-1.414l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414 0Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Hd = o(Ad), O0 = Hd, Vd = ({ page: l, pages: r, maxPages: e = 5 }) => {
  const t = (e - 1) / 2, a = Math.floor(t), i = Math.ceil(t), c = Math.min(e, r.length);
  let f = l - a;
  return l - a <= 1 ? f = 1 : l + i >= r.length && (f = Math.max(1, r.length - e + 1)), Array.from(Array(c).keys()).map((p) => p + f).map((p) => r[p - 1]);
}, $d = ({
  basePageClassNames: l,
  pages: r,
  currentPage: e,
  onClick: t,
  component: a = "button",
  pageLabel: i = (w) => `Go to page ${w}`,
  nextLabel: c = "Go to next page",
  previousLabel: f = "Go to previous page",
  firstLabel: g = "Go to first page",
  lastLabel: p = "Go to last page",
  selectedPageClassNames: b
}) => {
  const w = "w-4 h-4 mli-0.5 flex justify-center items-center rounded-full cursor-pointer leading-snug", k = v(
    w,
    "bg-transparent hover:bg-gray-35 hover:dark:bg-white hover:dark:!text-gray-50 text-muted-light",
    "dark:text-text-muted-dark hover:!text-canvas-light",
    "border border-transparent focus:border-info focus:dark:border-info",
    "hover:border-transparent hover:dark:border-transparent",
    l
  ), m = k, I = v(
    w,
    "bg-yv-red !text-white dark:!text-white",
    b
  ), x = Q(
    () => Vd({
      page: r.findIndex((z) => z === e) + 1,
      pages: r
    }),
    [r, e]
  );
  return /* @__PURE__ */ d(L, { className: "h-4 flex items-center justify-center", children: [
    e !== r[0] ? /* @__PURE__ */ d(t1, { children: [
      /* @__PURE__ */ d(
        L,
        {
          "aria-label": g,
          className: v(m, "hidden md:flex mli-0"),
          component: a,
          onClick: () => t(r[0]),
          children: [
            /* @__PURE__ */ n(V0, { className: "rtl:hidden", size: "16" }),
            /* @__PURE__ */ n($0, { className: "ltr:hidden", size: "16" })
          ]
        }
      ),
      /* @__PURE__ */ d(
        L,
        {
          "aria-label": f,
          className: v(m, "mli-0"),
          component: a,
          onClick: () => t(r[r.findIndex((z) => z === e) - 1]),
          children: [
            /* @__PURE__ */ n(L0, { className: "rtl:hidden", size: "16" }),
            /* @__PURE__ */ n(O0, { className: "ltr:hidden", size: "16" })
          ]
        }
      )
    ] }) : null,
    x.map((z) => /* @__PURE__ */ n(
      L,
      {
        "aria-label": i(r.findIndex((y) => y === z) + 1),
        className: v(z === e ? I : k, "hidden md:flex"),
        component: a,
        onClick: () => t(z),
        children: /* @__PURE__ */ n(
          V,
          {
            className: v(z === e ? I : k, "hidden md:flex mli-0"),
            size: "sm",
            variant: "fieldLabel",
            children: r.findIndex((y) => y === z) + 1
          }
        )
      },
      z
    )),
    /* @__PURE__ */ n(
      V,
      {
        className: "text-text-muted-light dark:text-text-muted-dark flex items-center md:hidden",
        size: "sm",
        variant: "paragraph",
        children: `${r.indexOf(e) + 1} of ${r.length}`
      }
    ),
    e !== r[r.length - 1] ? /* @__PURE__ */ d(t1, { children: [
      /* @__PURE__ */ d(
        L,
        {
          "aria-label": c,
          className: v(k, m, "mli-0"),
          component: a,
          onClick: () => t(r[r.findIndex((z) => z === e) + 1]),
          children: [
            /* @__PURE__ */ n(O0, { className: "rtl:hidden", size: "16" }),
            /* @__PURE__ */ n(L0, { className: "ltr:hidden", size: "16" })
          ]
        }
      ),
      /* @__PURE__ */ d(
        L,
        {
          "aria-label": p,
          className: v(k, m, "hidden md:flex mli-0"),
          component: a,
          onClick: () => t(r[r.length - 1]),
          children: [
            /* @__PURE__ */ n($0, { className: "rtl:hidden", size: "16" }),
            /* @__PURE__ */ n(V0, { className: "ltr:hidden", size: "16" })
          ]
        }
      )
    ] }) : null
  ] });
};
function Ld({ children: l, className: r, ...e }) {
  return /* @__PURE__ */ n("tbody", { className: v("overflow-auto", r), ...e, children: l });
}
function Od({
  children: l,
  className: r,
  isColumnsBordered: e,
  isRowsBordered: t,
  rowLink: a,
  ...i
}) {
  return /* @__PURE__ */ n(
    "td",
    {
      className: v(
        "align-middle border-tertiary-light dark:border-tertiary-dark [&:not(:last-child)]:border-e-0 group-even:bg-transparent dark:group-even:bg-transparent",
        e ? "[&:not(:last-child)]:border-e-[0.5px] border-tertiary-light dark:border-tertiary-dark" : "",
        t ? "border-b-[1px] border-surface-quaternary-light dark:border-surface-quaternary-dark" : "",
        r
      ),
      ...i,
      children: a ? /* @__PURE__ */ n("a", { href: a, children: l }) : l
    }
  );
}
function F0({ column: l, dataItem: r }) {
  var e, t, a, i, c, f;
  switch (l.type) {
    case "button":
      return /* @__PURE__ */ n("button", { onClick: () => {
        var g;
        return (g = l == null ? void 0 : l.onItemClick) == null ? void 0 : g.call(l, r);
      }, children: /* @__PURE__ */ n(
        V,
        {
          className: v("underline truncate sm:max-w-[110px] md:max-w-[170px]", (e = l == null ? void 0 : l.props) == null ? void 0 : e.textClassName),
          size: "sm",
          variant: "paragraph",
          children: r[l.dataIndex]
        }
      ) });
    case "custom":
      return l != null && l.customRender ? l.customRender(String(r[l.dataIndex]), r) : null;
    case "link":
      return r.linkUrl ? /* @__PURE__ */ n("a", { href: String(r.linkUrl), rel: "noreferrer noopener", target: "_blank", children: /* @__PURE__ */ n(
        V,
        {
          className: v("underline truncate sm:max-w-[110px] md:max-w-[170px]", (t = l == null ? void 0 : l.props) == null ? void 0 : t.textClassName),
          size: "sm",
          variant: "paragraph",
          children: r[l.dataIndex]
        }
      ) }) : /* @__PURE__ */ n(
        V,
        {
          className: v("truncate sm:max-w-[110px] md:max-w-[170px]", (a = l == null ? void 0 : l.props) == null ? void 0 : a.textClassName),
          size: "sm",
          variant: "paragraph",
          children: r[l.dataIndex]
        }
      );
    case "percentage":
      return /* @__PURE__ */ d(
        V,
        {
          className: v("truncate text-success sm:max-w-[110px] md:max-w-[170px]", (i = l == null ? void 0 : l.props) == null ? void 0 : i.textClassName),
          size: "sm",
          variant: "paragraph",
          children: [
            String(r[l.dataIndex]).startsWith("-") ? r[l.dataIndex] : `+${r[l.dataIndex]}`,
            "%"
          ]
        }
      );
    case "text":
      return /* @__PURE__ */ n(
        V,
        {
          className: v("truncate sm:max-w-[110px] md:max-w-[170px]", (c = l == null ? void 0 : l.props) == null ? void 0 : c.textClassName),
          size: "sm",
          variant: "paragraph",
          children: r[l.dataIndex]
        }
      );
    default:
      return /* @__PURE__ */ n(
        V,
        {
          className: v("truncate sm:max-w-[110px] md:max-w-[170px]", (f = l == null ? void 0 : l.props) == null ? void 0 : f.textClassName),
          size: "sm",
          variant: "paragraph",
          children: r[l.dataIndex]
        }
      );
  }
}
function Fd({ children: l, className: r, isSortable: e, onClick: t, ...a }) {
  return /* @__PURE__ */ n(
    "th",
    {
      className: v(
        "bg-surface-quaternary-light dark:bg-surface-quaternary-dark pli-1.5 plb-0.25 text-start text-base",
        e ? "hover:bg-warm-neutral hover:dark:bg-gray-40 cursor-pointer" : "",
        r
      ),
      onClick: t,
      role: "rowheader",
      ...a,
      children: l
    }
  );
}
function Pd({ children: l, className: r, ...e }) {
  return /* @__PURE__ */ n("thead", { className: r, ...e, children: l });
}
function P0({ children: l, className: r, ...e }) {
  return /* @__PURE__ */ n("tr", { className: v("group", r), role: "row", ...e, children: l });
}
const jd = 10, Ed = o(
  ({
    columns: l,
    handleSort: r,
    isBordered: e,
    isColumnsBordered: t,
    isLoading: a,
    isHeaderDisplayed: i = !0,
    isHoverable: c,
    isOrdered: f,
    isRowsBordered: g,
    isStriped: p,
    minHeight: b,
    noDataComponent: w,
    noDataText: k = "-",
    onRowClick: m,
    outerClassNames: I,
    paginationClassNames: x,
    paginationData: z,
    rowEndIcon: y,
    rowImageClassNames: S,
    rowItems: A,
    rowHoverStyles: H,
    rowsPerPage: O = jd,
    selectedPaginationClassNames: N,
    sortSettings: M,
    stripedRowsStyles: C,
    tableClassNames: R,
    tbodyClassNames: B,
    tdClassNames: P,
    thClassNames: $,
    thTextClassNames: j,
    theadClassNames: y1,
    theme: n1,
    trClassNames: g1,
    variant: p1 = "default",
    viewMoreButton: c1,
    ...C1
  }, s1) => {
    switch (p1) {
      case "default": {
        c = c !== !1, P = v("plb-0.5 pli-1.5", P), $ = v("first:rounded-s-0.5 last:rounded-e-0.5", $);
        break;
      }
      case "stats": {
        R = v("border-spacing-y-0.25", R), P = v("first:rounded-s-0.5 last:rounded-e-0.5 plb-0.5 pli-1.5", P), $ = v("first:rounded-s-0.5 last:rounded-e-0.5", $);
        break;
      }
      case "classic": {
        t = t !== !1, f = f !== !1, p = p !== !1, R = v("border-spacing-y-0", R), P = v("first:rounded-s-0.5 last:rounded-e-0.5 pli-1.5 plb-3", P), $ = v("first:rounded-ss-1.5 last:rounded-se-1.5", $), j = v("font-semibold", j);
        break;
      }
    }
    const u1 = H == null ? void 0 : H.split(" ").map((Z) => `hover:${Z}`).join(" "), U = z != null && z.currentPage ? (Number(z.currentPage) - 1) * O : 0, w1 = "text-gray-30 dark:text-white text-base", T = v("bg-warm-neutral dark:bg-gray-40", M == null ? void 0 : M.columnClassName), J = {
      asc: /* @__PURE__ */ n(pd, { className: w1, size: "16" }),
      desc: /* @__PURE__ */ n(Qn, { className: w1, size: "16" }),
      inactive: /* @__PURE__ */ n(dd, { className: w1, size: "16" })
    }, Y = u0["blue-10"], d1 = u0["blue-50"], K = X1(
      (Z) => {
        const G = n1 === "dark" ? d1 : Y;
        return `linear-gradient(to right, ${G} 0%, ${G} ${Z}, transparent ${Z}, transparent 100%)`;
      },
      [Y, d1, n1]
    );
    function r1(Z) {
      const { totalRowsCount: G } = Z, b1 = Math.ceil(G / O);
      return Array.from({ length: b1 ?? 1 }, (D, h1) => (h1 + 1).toString());
    }
    return a ? /* @__PURE__ */ n("div", { className: v("w-full p-0 shadow-none relative"), style: { height: b ?? "400px" }, children: /* @__PURE__ */ n(A1, {}) }) : /* @__PURE__ */ n(t1, { children: /* @__PURE__ */ d("div", { className: v("w-full p-0 flex flex-col justify-center relative", I), children: [
      /* @__PURE__ */ n("div", { className: "overflow-x-auto", children: /* @__PURE__ */ d(
        "table",
        {
          className: v(
            "w-full p-0 shadow-none border-spacing-y-0.5 relative rounded-2",
            e ? "border-[1px] border-gray-10 dark:border-surface-quaternary-dark" : "border-separate",
            g ? "border-collapse" : "",
            R
          ),
          ref: s1,
          ...C1,
          children: [
            i ? /* @__PURE__ */ n(Pd, { className: y1, children: /* @__PURE__ */ n(P0, { className: g1, children: l == null ? void 0 : l.map((Z) => {
              var b1, k1, D;
              const G = (M == null ? void 0 : M.sortBy) === Z.dataIndex;
              return /* @__PURE__ */ n(
                Fd,
                {
                  className: v(
                    $,
                    r ? "bg-surface-tertiary-light last:rounded-e-0 first:rounded-s-0 border-b-small border-t-small border-solid border-surface-quaternary-light dark:border-surface-quaternary-dark" : "",
                    G && Z.isSortable ? T : void 0
                  ),
                  isSortable: Z == null ? void 0 : Z.isSortable,
                  onClick: Z != null && Z.isSortable && r ? () => r(Z.dataIndex, (M == null ? void 0 : M.order) === "desc" ? "asc" : "desc") : () => {
                  },
                  style: {
                    backgroundColor: G && (Z != null && Z.isSortable) ? M.columnBgColor : void 0,
                    width: (b1 = Z == null ? void 0 : Z.props) == null ? void 0 : b1.width
                  },
                  children: /* @__PURE__ */ d(
                    "div",
                    {
                      className: "bg-transparent flex items-center gap-0.5",
                      style: { justifyContent: ((k1 = Z.props) == null ? void 0 : k1.align) ?? "start" },
                      children: [
                        /* @__PURE__ */ n(
                          V,
                          {
                            className: j,
                            size: "sm",
                            style: { textAlign: ((D = Z.props) == null ? void 0 : D.align) ?? "start" },
                            variant: "paragraph",
                            children: Z.title
                          }
                        ),
                        Z != null && Z.isSortable && !G ? J.inactive : null,
                        Z != null && Z.isSortable && G ? J[M.order] : null
                      ]
                    }
                  )
                },
                Z.dataIndex
              );
            }) }) }) : null,
            /* @__PURE__ */ n(Ld, { className: B, children: A == null ? void 0 : A.map((Z, G) => {
              const b1 = !!(y || Z != null && Z.endIcon), k1 = !!m;
              return /* @__PURE__ */ n(
                P0,
                {
                  className: v(
                    "relative z-0",
                    p && G % 2 !== 0 ? (C == null ? void 0 : C[0]) ?? "bg-canvas-secondary-light dark:bg-surface-quaternary-dark" : "",
                    p && G % 2 === 0 ? C == null ? void 0 : C[1] : "",
                    c || Z != null && Z.rowLink || k1 ? v("hover:bg-warm-neutral hover:dark:bg-warm-neutral-dark", u1) : "",
                    Z != null && Z.rowLink || k1 ? "cursor-pointer" : "",
                    g1
                  ),
                  onClick: () => m == null ? void 0 : m(G),
                  style: Z.width ? {
                    background: K(Z.width)
                  } : {},
                  children: l == null ? void 0 : l.map((D, h1) => {
                    var o0, c0, s0;
                    return /* @__PURE__ */ n(
                      Od,
                      {
                        className: P,
                        isColumnsBordered: t,
                        isRowsBordered: g,
                        rowLink: Z == null ? void 0 : Z.rowLink,
                        children: /* @__PURE__ */ d(
                          "div",
                          {
                            className: v(
                              "flex w-full relative z-1 items-center",
                              h1 === 0 ? "gap-1" : "",
                              b1 && h1 === l.length - 1 ? "!pie-3" : ""
                            ),
                            style: { justifyContent: ((o0 = D.props) == null ? void 0 : o0.align) ?? "start" },
                            children: [
                              f && h1 === 0 ? /* @__PURE__ */ n(V, { className: "min-w-[16px] text-end", size: "sm", variant: "paragraph", children: `${U + G + 1}` }) : null,
                              D != null && D.displayImages && (Z != null && Z.imageUrl) && h1 === 0 ? /* @__PURE__ */ n(
                                "img",
                                {
                                  alt: "row-image",
                                  className: v("object-cover h-[32px] w-[32px] rounded-0.25", S),
                                  src: Z == null ? void 0 : Z.imageUrl
                                }
                              ) : null,
                              D != null && D.displayImages && !(Z != null && Z.imageUrl) && h1 === 0 ? /* @__PURE__ */ n(
                                "div",
                                {
                                  className: v(
                                    "h-[32px] w-[32px] rounded-0.25 bg-gray-20 dark:bg-warm-neutral flex justify-center items-center",
                                    S
                                  ),
                                  children: /* @__PURE__ */ n(Ie, { className: "text-warm-neutral dark:text-gray-40", size: "16" })
                                }
                              ) : null,
                              /* @__PURE__ */ n(
                                "div",
                                {
                                  className: "flex-1 flex flex-row",
                                  style: { justifyContent: ((c0 = D.props) == null ? void 0 : c0.align) ?? "start" },
                                  children: Z[D.dataIndex] ? /* @__PURE__ */ n(F0, { column: D, dataItem: Z }) : w ?? /* @__PURE__ */ n(
                                    F0,
                                    {
                                      column: D,
                                      dataItem: { [D.dataIndex]: k }
                                    }
                                  )
                                }
                              ),
                              b1 && h1 === l.length - 1 ? /* @__PURE__ */ n("div", { className: "absolute block-end-0 inline-end-0 h-full", children: /* @__PURE__ */ n(
                                H1,
                                {
                                  className: v(
                                    "text-gray-30 dark:text-white text-base p-0 mlb-auto h-full",
                                    y == null ? void 0 : y.wrapperClassNames
                                  ),
                                  onClick: (Ge) => {
                                    y != null && y.onClick && (Ge.stopPropagation(), y.onClick(G));
                                  },
                                  children: (Z == null ? void 0 : Z.endIcon) ?? (y == null ? void 0 : y.component) ?? /* @__PURE__ */ n(
                                    we,
                                    {
                                      className: "rtl:rotate-180",
                                      size: ((s0 = y == null ? void 0 : y.size) == null ? void 0 : s0.toString()) ?? "16"
                                    }
                                  )
                                }
                              ) }) : null
                            ]
                          }
                        )
                      },
                      `${D.title}-${D.dataIndex}-${h1}`
                    );
                  })
                },
                G
              );
            }) })
          ]
        }
      ) }),
      /* @__PURE__ */ n("div", { className: v("flex flex-row items-center justify-end", x), children: c1 ?? (z ? /* @__PURE__ */ n(
        $d,
        {
          currentPage: z.currentPage,
          label: "",
          onClick: z.handlePaginationChange,
          pages: r1(z),
          selectedPageClassNames: v("bg-blue-30", N)
        }
      ) : null) })
    ] }) });
  }
);
Ed.displayName = "DataTable";
const Td = o(
  ({
    children: l,
    containerClassNames: r,
    customFooter: e,
    customHeader: t,
    footerClassNames: a,
    headerClassNames: i,
    standardHeaderData: c
  }, f) => /* @__PURE__ */ d(
    "div",
    {
      className: v(
        "w-full overflow-x-auto bg-white dark:bg-canvas-secondary-dark shadow-none dark:shadow-none plb-4 pli-3 rounded-2 flex flex-col gap-2",
        r
      ),
      ref: f,
      children: [
        c ?? t ? /* @__PURE__ */ n("div", { className: v("flex flex-row justify-start items-center", i), children: t ?? /* @__PURE__ */ d("div", { className: "w-full flex flex-col justify-center items-start gap-2", children: [
          /* @__PURE__ */ d("div", { className: v("w-full self-between flex flex-row gap-1 justify-between items-center"), children: [
            c != null && c.title ? /* @__PURE__ */ n(V, { className: "mie-0.5", size: "xs", variant: "headline", children: c.title }) : null,
            c != null && c.icon && !(c != null && c.customSelector) ? c.icon : null
          ] }),
          c != null && c.customSelector ? /* @__PURE__ */ d(
            "div",
            {
              className: v(
                "w-full self-between flex flex-row gap-1 items-end",
                c != null && c.customSelector ? "justify-between" : "justify-end"
              ),
              children: [
                c.customSelector,
                c != null && c.icon ? c.icon : null
              ]
            }
          ) : null
        ] }) }) : null,
        l,
        e ? /* @__PURE__ */ n("div", { className: v("flex flex-row justify-center items-center", a), children: e }) : null
      ]
    }
  )
);
Td.displayName = "DataTableContainer";
var Gd = Object.defineProperty, Wd = Object.defineProperties, Dd = Object.getOwnPropertyDescriptors, D1 = Object.getOwnPropertySymbols, Se = Object.prototype.hasOwnProperty, Be = Object.prototype.propertyIsEnumerable, j0 = (l, r, e) => r in l ? Gd(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, Ud = (l, r) => {
  for (var e in r || (r = {}))
    Se.call(r, e) && j0(l, e, r[e]);
  if (D1)
    for (var e of D1(r))
      Be.call(r, e) && j0(l, e, r[e]);
  return l;
}, qd = (l, r) => Wd(l, Dd(r)), _d = (l, r) => {
  var e = {};
  for (var t in l)
    Se.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && D1)
    for (var t of D1(l))
      r.indexOf(t) < 0 && Be.call(l, t) && (e[t] = l[t]);
  return e;
}, Xd = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = _d(e, ["title", "titleId"]);
  return d("svg", qd(Ud({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.768 11.646a.5.5 0 0 0 0 .708l3.182 3.182a1 1 0 0 1-1.414 1.414l-3.182-3.182a.5.5 0 0 0-.708 0L8.464 16.95a1 1 0 1 1-1.414-1.414l3.182-3.182a.5.5 0 0 0 0-.708L7.05 8.464A1 1 0 1 1 8.464 7.05l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 1 1 1.414 1.414l-3.182 3.182Z", fill: "currentColor" })] }));
}, Yd = o(Xd), Kd = Yd;
const Ne = ({ autoFocus: l = !0, children: r, className: e }) => {
  const t = q(null);
  return o1(() => {
    if (t.current) {
      const a = t.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      let i = document.activeElement;
      const c = a[0], f = a[a.length - 1], g = (w) => {
        if (w.key === "Tab") {
          if (w.shiftKey) {
            if (document.activeElement === c)
              w.preventDefault(), f.focus(), i = f;
            else
              for (let k = 0; k < a.length; k++)
                if (a[k] === document.activeElement) {
                  i = a[k - 1];
                  break;
                }
          } else if (!w.shiftKey) {
            if (document.activeElement === f)
              w.preventDefault(), c.focus(), i = c;
            else
              for (let k = 0; k < a.length; k++)
                if (a[k] === document.activeElement) {
                  i = a[k + 1];
                  break;
                }
          }
        }
      };
      l && (() => {
        if (t.current) {
          const w = t.current.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          w && w.focus();
        }
      })();
      const b = (w) => {
        t.current && !t.current.contains(w.target) && i.focus();
      };
      return document.addEventListener("keydown", g), document.addEventListener("click", b), () => {
        document.removeEventListener("keydown", g), document.removeEventListener("click", b);
      };
    }
  }, [l]), /* @__PURE__ */ n("div", { className: e, ref: t, children: r });
}, Qd = ({
  autoFocus: l = !0,
  children: r,
  className: e,
  closeButtonLabel: t,
  closeIconClassName: a,
  confirmationButtons: i,
  confirmationContainerClassName: c,
  dialogType: f = "confirmation",
  heading: g,
  headingClassName: p,
  isDismissableOnOutsideClick: b = !0,
  onClose: w,
  ...k
}, m) => (P2(), /* @__PURE__ */ d("div", { className: "w-full h-screen z-[1400] fixed inset-0", children: [
  /* @__PURE__ */ n(
    "div",
    {
      className: "absolute inset-0 bg-overlay-light dark:bg-overlay-dark",
      "data-testid": "dialog-overlay",
      id: "overlay",
      onClick: b ? w : void 0
    }
  ),
  /* @__PURE__ */ n(Ne, { autoFocus: l, className: "w-full h-full flex items-center justify-center", children: /* @__PURE__ */ d(
    "dialog",
    {
      className: v(
        "z-[1400] relative rounded-2 plb-3 pli-3 mlb-4 mli-2 bg-canvas-light dark:bg-canvas-dark",
        f === "confirmation" ? "max-w-[400px]" : "max-w-[700px]",
        e
      ),
      open: !0,
      ref: m,
      ...k,
      children: [
        f === "modal" ? /* @__PURE__ */ n(
          H1,
          {
            "aria-label": t,
            className: v("absolute inline-end-2 block-start-2", a),
            "data-testid": "close-modal-button",
            onClick: w,
            children: /* @__PURE__ */ n(Kd, {})
          }
        ) : null,
        /* @__PURE__ */ n("div", { children: g ? /* @__PURE__ */ n(M1, { className: v("pbe-1", p), size: "md", variant: "headline", children: g }) : null }),
        /* @__PURE__ */ n("div", { children: r }),
        /* @__PURE__ */ n("div", { className: v("w-full flex justify-end items-center gap-0.5 pbs-2", c), children: i == null ? void 0 : i.map(({ label: x, ...z }, y) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          /* @__PURE__ */ n(B1, { "aria-label": x, size: "sm", variant: "borderless", ...z, children: x }, `${x}${y}`)
        )) })
      ]
    }
  ) })
] })), Jd = o(Qd);
Jd.displayName = "Dialog";
const eo = ({ className: l, ...r }) => /* @__PURE__ */ n("hr", { ...r, className: v("w-full border-gray-15 dark:border-gray-30 border-standard", l) }), lo = ({ children: l, className: r, isOrdered: e = !1, ...t }, a) => a1(e ? "ol" : "ul", {
  children: l,
  className: v(["bg-canvas-light dark:bg-gray-45 rounded-1 py-0.5", r]),
  ref: a,
  ...t
}), d0 = o(lo);
d0.displayName = "List";
function to({ children: l, className: r, position: e }) {
  let t = "";
  return e && (e === "start" ? t = "order-first" : t = "order-last"), /* @__PURE__ */ n("div", { className: v("flex gap-1", t, r), children: l });
}
function ro({ children: l, className: r }) {
  return /* @__PURE__ */ n("div", { className: v("flex-grow", r), children: l });
}
const io = ({
  checkmarkClassNames: l,
  isSelectedItem: r,
  lineSeparatorClassNames: e,
  option: t,
  optionHoverClassNames: a,
  onSelect: i,
  selectedOptionClassNames: c,
  id: f
}) => /* @__PURE__ */ d(t1, { children: [
  /* @__PURE__ */ d(
    z1,
    {
      "aria-selected": r,
      className: v(
        "group p-0 cursor-pointer rounded-0.5 hover:rounded-0.5",
        r ? `bg-warm-neutral dark:bg-warm-neutral-dark ${c ?? ""}` : null
      ),
      componentProps: {
        className: `rounded-0.5 hover:bg-info-light dark:hover:bg-info-dark ${a ?? ""}`
      },
      id: f,
      onClick: () => i(t),
      role: "option",
      children: [
        /* @__PURE__ */ n(ro, { children: t != null && t.labelComponent ? /* @__PURE__ */ n(t1, { children: t.labelComponent }) : /* @__PURE__ */ n(
          V,
          {
            className: "group-hover:text-canvas-light dark:group-hover:text-canvas-light",
            size: "md",
            variant: "paragraph",
            children: t.label
          }
        ) }),
        r && !(t != null && t.hideCheckmarkOnSelected) ? /* @__PURE__ */ n(to, { children: /* @__PURE__ */ n(
          he,
          {
            className: v(
              "group-hover:text-canvas-light dark:group-hover:text-canvas-light",
              l ?? ""
            )
          }
        ) }) : null
      ]
    }
  ),
  t != null && t.hasLineSeparatorBelow ? /* @__PURE__ */ n("hr", { className: v("mli-2 text-gray-15", e) }) : null
] }), ao = ({
  checkmarkClassNames: l,
  isLoading: r = !1,
  label: e,
  name: t,
  hint: a,
  lineSeparatorClassNames: i,
  options: c,
  disabled: f = !1,
  error: g,
  noOptionsText: p,
  onSelect: b,
  optionHoverClassNames: w,
  optionsContainerClassNames: k,
  selectedOptionClassNames: m,
  defaultValue: I,
  ...x
}, z) => {
  const y = q(null), [S, A] = _(I ?? null), [H, O] = _(!1), N = (R) => {
    b(R), A(R), O(!1);
  }, M = X1((R) => {
    y.current && !y.current.contains(R.target) && O(!1);
  }, []), C = (R) => {
    const B = c.find((P) => P.value === R.target.value);
    B && N(B);
  };
  return o1(() => (document.addEventListener("click", M, !0), () => {
    document.removeEventListener("click", M, !0);
  }), [M]), /* @__PURE__ */ n(L, { children: /* @__PURE__ */ d(L, { className: "relative", ref: y, children: [
    r ? /* @__PURE__ */ n(A1, { className: "absolute z-1" }) : null,
    /* @__PURE__ */ n(
      n0,
      {
        "aria-controls": `${t ?? e}-options`,
        "aria-expanded": H,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        disabled: f || r,
        editable: !1,
        endIcon: /* @__PURE__ */ n(Y1, { size: "24" }),
        error: g,
        hint: a,
        label: e,
        name: t ?? e ?? "",
        onFocus: () => O((R) => !R),
        ref: z,
        role: "combobox",
        spellCheck: "false",
        value: (S == null ? void 0 : S.label) ?? "",
        ...x
      }
    ),
    H ? /* @__PURE__ */ n(L, { className: v("absolute top-0 right-0 left-0 z-50", k), children: /* @__PURE__ */ n(L, { className: "rounded-1 shadow-light-2 dark:shadow-dark-2", children: /* @__PURE__ */ n(d0, { className: v("p-1 rounded-1", "max-h-[288px] overflow-y-auto"), role: "listbox", children: c.length ? c.map((R, B) => /* @__PURE__ */ n(
      io,
      {
        checkmarkClassNames: l,
        id: `${R.value}-${B}`,
        isSelectedItem: (S == null ? void 0 : S.value) === R.value,
        lineSeparatorClassNames: i,
        onSelect: N,
        option: R,
        optionHoverClassNames: w,
        selectedOptionClassNames: m
      },
      `${R.value}-${B}`
    )) : /* @__PURE__ */ n(z1, { children: p }, "no-options") }) }) }) : null,
    /* @__PURE__ */ n(
      "select",
      {
        "aria-hidden": !0,
        autoComplete: "off",
        className: "sr-only",
        disabled: f,
        name: t,
        onChange: C,
        tabIndex: -1,
        value: S == null ? void 0 : S.value,
        children: c.map((R, B) => /* @__PURE__ */ n("option", { value: R.value, children: R.label }, `${R.value}${B}`))
      }
    )
  ] }) });
}, no = o(ao);
no.displayName = "Dropdown";
var oo = Object.defineProperty, co = Object.defineProperties, so = Object.getOwnPropertyDescriptors, U1 = Object.getOwnPropertySymbols, Ae = Object.prototype.hasOwnProperty, He = Object.prototype.propertyIsEnumerable, E0 = (l, r, e) => r in l ? oo(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, ho = (l, r) => {
  for (var e in r || (r = {}))
    Ae.call(r, e) && E0(l, e, r[e]);
  if (U1)
    for (var e of U1(r))
      He.call(r, e) && E0(l, e, r[e]);
  return l;
}, uo = (l, r) => co(l, so(r)), vo = (l, r) => {
  var e = {};
  for (var t in l)
    Ae.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && U1)
    for (var t of U1(l))
      r.indexOf(t) < 0 && He.call(l, t) && (e[t] = l[t]);
  return e;
}, fo = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = vo(e, ["title", "titleId"]);
  return d("svg", uo(ho({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.334 15.666a1 1 0 0 0 1 1h1.364a1 1 0 0 0 .707-.293l7.898-7.899-2.777-2.777-7.899 7.899a1 1 0 0 0-.293.707v1.363Zm13.117-9.34a.738.738 0 0 0 0-1.044L14.718 3.55a.738.738 0 0 0-1.044 0l-1.356 1.356 2.778 2.777 1.355-1.355Z", fill: "currentColor" })] }));
}, go = o(fo), T0 = go;
const po = ({ className: l, children: r, component: e = "a", variant: t = "borderless", ...a }, i) => a1(
  e,
  {
    ...a,
    className: v([
      "rounded-full inline-flex justify-center items-center p-1 no-underline cursor-pointer",
      X[t],
      l
    ]),
    ref: i
  },
  r
), Ve = o(po);
Ve.displayName = "IconLinkButton";
const wo = ({
  children: l,
  editLinkComponent: r = "a",
  titleSize: e = "md",
  href: t,
  onClick: a,
  title: i,
  editIconLabel: c,
  className: f,
  ...g
}, p) => /* @__PURE__ */ d(
  L,
  {
    className: v(
      "flex gap-2 rounded-2 md:rounded-1.5 p-3 md:p-2 shadow-light-2 dark:shadow-dark-2 bg-white dark:bg-[#1F2122]",
      f
    ),
    elevation: 4,
    ref: p,
    ...g,
    children: [
      /* @__PURE__ */ d("div", { className: "flex flex-col flex-1 gap-2", children: [
        i ? /* @__PURE__ */ n(V, { component: "h1", size: e, variant: "headline", children: i }) : null,
        l
      ] }),
      /* @__PURE__ */ d("div", { className: "self-start", children: [
        t ? /* @__PURE__ */ n(
          Ve,
          {
            "aria-label": c,
            className: "w-4 h-4",
            component: r,
            href: t,
            variant: "strokedSecondary",
            children: /* @__PURE__ */ n(T0, {})
          }
        ) : null,
        a ? /* @__PURE__ */ n(H1, { "aria-label": c, className: "w-4 h-4", onClick: a, variant: "strokedSecondary", children: /* @__PURE__ */ n(T0, {}) }) : null
      ] })
    ]
  }
), bo = o(wo);
bo.displayName = "EditableWell";
const mo = ({ children: l, className: r, ...e }, t) => /* @__PURE__ */ n(
  L,
  {
    className: v("w-[320px] h-[620px] bg-white border-gray-50 rounded-6 overflow-hidden border-[12px]", r),
    elevation: 12,
    ref: t,
    ...e,
    children: l
  }
), xo = o(mo);
xo.displayName = "FauxPhone";
const vc = ({ children: l, className: r, ...e }) => /* @__PURE__ */ n(
  "div",
  {
    ...e,
    className: v(
      r,
      "rounded-2 bg-blue-30 flex sm:flex-col-reverse md:flex-row items-center justify-center pli-4 plb-4"
    ),
    children: l
  }
), fc = ({ children: l, className: r, size: e = "md" }) => /* @__PURE__ */ n("div", { className: r, children: /* @__PURE__ */ n(B1, { className: "bg-white text-gray-40 hover:text-white", size: e, children: l }) }), gc = ({ children: l, className: r, ...e }) => /* @__PURE__ */ n("div", { ...e, className: v("flex flex-col items-center justify-between", r), children: l }), pc = ({ alt: l, className: r, src: e }) => /* @__PURE__ */ n("div", { className: v(["flex items-center justify-between sm:mbe-5 md:mbe-0 md:mis-6", r]), children: /* @__PURE__ */ n("img", { alt: l ?? "Image", src: e }) }), wc = ({ children: l, className: r, size: e = "md" }) => /* @__PURE__ */ n("div", { className: v(["flex items-center justify-between break-words", r]), children: /* @__PURE__ */ n(V, { className: "text-white font-regular mbe-2 text-center", size: e, variant: "label", children: l }) });
function yo({ align: l = "fill", className: r, start: e = 1, width: t = 1, children: a }, i) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: v("grid", r),
      ref: i,
      style: {
        gridColumnEnd: e + t,
        gridColumnStart: e,
        placeContent: l !== "fill" ? l : void 0
      },
      children: a
    }
  );
}
const Co = o(yo);
Co.displayName = "Column";
function ko({ className: l, children: r, rowSpacing: e = "gap-y-1", ...t }, a) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: v("max-w-[1200px] pli-3 lg:pli-5 flex flex-col", e, l),
      ref: a,
      ...t,
      children: r
    }
  );
}
const Zo = o(ko);
Zo.displayName = "Grid";
function Mo({ children: l, className: r, ...e }, t) {
  return /* @__PURE__ */ n("div", { className: v("grid grid-cols-12 gap-x-2 lg:gap-x-3 grid-rows-1", r), ref: t, ...e, children: l });
}
const zo = o(Mo);
zo.displayName = "Row";
function bc({ className: l, height: r, progress: e, progressClassName: t }) {
  return /* @__PURE__ */ n("div", { className: v([`w-full bg-gray-15 h-${r} rounded-3 overflow-hidden`, l]), children: /* @__PURE__ */ n(
    "div",
    {
      className: v([`bg-yv-red h-${r} ease-in-out duration-300`, t]),
      style: {
        transitionProperty: "width",
        width: `${e}%`
      }
    }
  ) });
}
var Ro = Object.defineProperty, Io = Object.defineProperties, So = Object.getOwnPropertyDescriptors, q1 = Object.getOwnPropertySymbols, $e = Object.prototype.hasOwnProperty, Le = Object.prototype.propertyIsEnumerable, G0 = (l, r, e) => r in l ? Ro(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, Bo = (l, r) => {
  for (var e in r || (r = {}))
    $e.call(r, e) && G0(l, e, r[e]);
  if (q1)
    for (var e of q1(r))
      Le.call(r, e) && G0(l, e, r[e]);
  return l;
}, No = (l, r) => Io(l, So(r)), Ao = (l, r) => {
  var e = {};
  for (var t in l)
    $e.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && q1)
    for (var t of q1(l))
      r.indexOf(t) < 0 && Le.call(l, t) && (e[t] = l[t]);
  return e;
}, Ho = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Ao(e, ["title", "titleId"]);
  return d("svg", No(Bo({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.768 11.646a.5.5 0 0 0 0 .708l3.182 3.182a1 1 0 0 1-1.414 1.414l-3.182-3.182a.5.5 0 0 0-.708 0L8.464 16.95a1 1 0 1 1-1.414-1.414l3.182-3.182a.5.5 0 0 0 0-.708L7.05 8.464A1 1 0 0 1 8.464 7.05l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 1 1 1.414 1.414l-3.182 3.182Z", fill: "currentColor" })] }));
}, Vo = o(Ho), Oe = Vo;
const $o = ({
  acceptedFileTypes: l = ["image/*"],
  changeImageButtonLabel: r = "Change",
  chooseImageButtonLabel: e = "Choose Image",
  className: t,
  disabled: a = !1,
  dismissCallback: i,
  dismissImageAriaLabel: c = "Remove Image",
  error: f = "",
  fileMaxKbSizeError: g = (B, P) => `${B} is too big to upload, the maximum size is ${P}kb. Please try again.`,
  fileMaxSizeError: p = (B) => `${B} is too large to upload. The maximum dimensions are ${C == null ? void 0 : C.maxWidth}x${C == null ? void 0 : C.maxHeight}. Please try again.`,
  fileMinSizeError: b = (B) => `${B} is too small to upload. The minimum dimensions are ${C == null ? void 0 : C.minWidth}x${C == null ? void 0 : C.minHeight}. Please try again.`,
  fileRatioError: w = (B) => `${B} must have a ratio of, ${C == null ? void 0 : C.imageRatio}. Please try again.`,
  fileCallback: k,
  hero: m = !1,
  hideDismissIcon: I = !1,
  hint: x,
  imageWidth: z = 160,
  imageSrc: y,
  inputContainerClassName: S,
  label: A = "Upload Image",
  name: H = "imageUpload",
  onBlur: O,
  preProcessing: N,
  shape: M = "circle",
  validation: C
}, R) => {
  const B = q(null), P = N1({ forwardedRef: R, innerRef: B }), [$, j] = _({ error: f, status: y ? "resolved" : "idle" }), y1 = () => B != null && B.current ? B.current.click() : void 0;
  o1(() => {
    j(y ? (T) => ({ ...T, status: "resolved" }) : (T) => ({ ...T, status: "idle" }));
  }, [y]);
  const n1 = Q(() => $.file && $.status !== "rejected" ? (j((T) => ({ ...T, status: "resolved" })), $.file.imageSrc) : y && $.status === "resolved" ? (j((T) => ({ ...T, status: "resolved" })), y) : null, [$.file, $.status, y]), g1 = Q(() => {
    var J;
    const T = () => {
      i && i(y), j((Y) => ({ ...Y, file: void 0, status: "idle" }));
    };
    switch ($.status) {
      case "pending":
        return /* @__PURE__ */ n(L, { className: "animate-spin", children: /* @__PURE__ */ n(oe, { className: "text-info-light dark:text-info-dark", "data-testid": "loading spinner", size: "32" }) });
      case "resolved":
        return /* @__PURE__ */ d(t1, { children: [
          /* @__PURE__ */ n(
            "img",
            {
              alt: `${(J = $.file) == null ? void 0 : J.id} preview`,
              className: v([
                "object-fit w-full h-full",
                M === "circle" ? "rounded-full" : "rounded-0.5",
                M !== "unset" || !m ? "aspect-square" : "",
                M === "unset" && m ? "aspect-video" : "",
                M === "unset" && !m ? "!aspect-auto" : ""
              ]),
              onLoad: () => {
                var Y;
                return (Y = $ == null ? void 0 : $.file) != null && Y.imageSrc ? URL.revokeObjectURL($.file.imageSrc) : void 0;
              },
              src: n1 || void 0,
              width: z
            }
          ),
          !a && !I ? /* @__PURE__ */ n(
            B1,
            {
              "aria-label": c,
              className: "absolute -top-0.5 -right-0.5 rounded-3 !p-0 !text-text-muted-light dark:text-text-muted-dark bg-white dark:bg-gray-40 dark:hover:bg-white dark:hover:!text-gray-45 hover:!text-white shadow-light-1 dark:shadow-dark-1",
              "data-testid": "remove image",
              onClick: T,
              children: /* @__PURE__ */ n(Oe, {})
            }
          ) : null
        ] });
      default:
        return /* @__PURE__ */ n(L, { className: "gray-10 dark:gray-30", children: /* @__PURE__ */ n(Ie, { "data-testid": "placeholder image", size: "32" }) });
    }
  }, [
    $,
    i,
    y,
    M,
    m,
    n1,
    z,
    a,
    I,
    c
  ]), p1 = ({ file: T, imageUrl: J }) => new Promise((Y, d1) => {
    var Z;
    const K = new Image(), r1 = (Z = C == null ? void 0 : C.imageRatio) == null ? void 0 : Z.split("/");
    K.onload = async () => {
      if (C)
        if (C != null && C.maxByteSize && T.size > C.maxByteSize) {
          const G = g(T.name, Math.round(C.maxByteSize / 1e3));
          return j({ error: G, file: void 0, status: "rejected" }), d1(!1);
        } else {
          if (C != null && C.minWidth && K.width < (C == null ? void 0 : C.minWidth) || C != null && C.minHeight && K.height < (C == null ? void 0 : C.minHeight))
            return j({ error: b(T.name), file: void 0, status: "rejected" }), d1(!1);
          if (C != null && C.maxHeight && K.height > (C == null ? void 0 : C.maxHeight) || C != null && C.maxWidth && K.width > (C == null ? void 0 : C.maxWidth))
            return j({ error: p(T.name), file: void 0, status: "rejected" }), d1(!1);
          if (C != null && C.imageRatio && (r1 == null ? void 0 : r1.length) === 2 && parseInt(r1[0]) / parseInt(r1[1]) !== K.width / K.height)
            return j({ error: w(T.name), file: void 0, status: "rejected" }), d1(!1);
        }
      return z = K.width, typeof k == "function" && await k(T, K), j((G) => ({ ...G, error: "" })), Y(!0);
    }, K.src = J;
  }), c1 = async (T) => {
    try {
      const { files: J } = T.target;
      if (J) {
        const Y = J[0], d1 = URL.createObjectURL(Y);
        let K = !0;
        j((r1) => ({ ...r1, status: "pending" })), N && await N(Y), K = await p1({
          file: Y,
          imageUrl: d1
        }), K && j((r1) => ({
          ...r1,
          file: { file: Y, id: Y.name, imageSrc: d1 },
          status: "resolved"
        }));
      }
    } catch (J) {
      if (J instanceof Error)
        throw J;
    }
  }, C1 = v([M === "circle" && !m ? "rounded-full aspect-square" : ""]), s1 = v([M === "square" && !m ? "aspect-square rounded-1" : ""]), u1 = v([
    M === "unset" && !m ? "rounded-1" : "",
    M === "unset" && $.status !== "idle" && !m ? "aspect-auto" : "",
    M === "unset" && $.status !== "resolved" && !m ? "aspect-square" : ""
  ]), U = v([m ? "rounded-1 aspect-video" : ""]), w1 = f || $.error;
  return /* @__PURE__ */ d(L, { className: v([t]), children: [
    /* @__PURE__ */ d(
      L,
      {
        className: v([
          "relative border-small border-solid rounded-1 mbe-0.5 pbs-1 pbe-2 px-2 text-text-muted-light dark:text-text-muted-dark",
          S,
          w1 ? "border-alert-light dark:border-alert-dark" : "border-tertiary-light dark:border-tertiary-dark",
          a ? "select-none bg-gray-10 dark:bg-gray-40 pointer-events-none" : ""
        ]),
        children: [
          /* @__PURE__ */ n(V, { className: "pbe-1.5 text-text-muted-light dark:text-text-muted-dark", children: /* @__PURE__ */ n("label", { htmlFor: H, children: A }) }),
          /* @__PURE__ */ d(L, { className: "flex relative flex-wrap justify-center md:justify-start", children: [
            /* @__PURE__ */ n(
              L,
              {
                className: v([
                  "flex justify-center items-center relative mbe-2 md:mbe-0 md:mie-2",
                  m ? "w-full" : "md:w-1/2 w-4/5",
                  a ? "border-small border-solid border-tertiary-light" : "",
                  $.status !== "resolved" ? "bg-gray-10 dark:bg-gray-40" : "",
                  C1,
                  s1,
                  u1,
                  U
                ]),
                children: g1
              }
            ),
            /* @__PURE__ */ n(
              B1,
              {
                className: v([
                  "my-auto !border-gray-15 dark:!border-gray-30 !border-1 disabled:!bg-gray-15 disabled:!border-none",
                  m ? "!mbs-2" : ""
                ]),
                disabled: a,
                onClick: y1,
                size: "sm",
                variant: "stroked",
                children: $.status === "resolved" ? r : e
              }
            ),
            /* @__PURE__ */ n(
              "input",
              {
                accept: l.toString(),
                className: "hidden",
                disabled: a,
                id: H,
                name: H,
                onBlur: O,
                onChange: c1,
                ref: P,
                title: "",
                type: "file",
                value: ""
              }
            )
          ] })
        ]
      }
    ),
    w1 ? /* @__PURE__ */ n(V, { className: "dark:!text-alert-dark !text-alert-light text-13", children: w1 }) : null,
    x ? /* @__PURE__ */ n(V, { className: "text-text-muted-light dark:text-text-muted-dark text-13", children: x }) : null
  ] });
}, Lo = o($o);
Lo.displayName = "ImageUpload";
const Oo = ({
  className: l,
  children: r,
  component: e = "a",
  icon: t,
  iconPosition: a,
  variant: i = "primary",
  size: c = "md",
  ...f
}, g) => {
  const p = be(t !== void 0 ? a : void 0);
  return /* @__PURE__ */ d(({ children: w }) => a1(
    e,
    {
      ...f,
      className: v([
        me,
        X[i],
        p[c],
        "no-underline cursor-pointer",
        l
      ]),
      ref: g
    },
    w
  ), { children: [
    a === "start" && t !== void 0 ? a1(t, {
      className: v("flex-shrink-0", c === "xs" ? "mie-0.25" : "mie-0.5"),
      size: S1[c]
    }) : null,
    a1("span", { className: "" }, r),
    a === "end" && t !== void 0 ? a1(t, {
      className: v("flex-shrink-0", c === "xs" ? "mis-0.25" : "mis-0.5"),
      size: S1[c]
    }) : null
  ] });
}, Fo = o(Oo);
Fo.displayName = "LinkButton";
function mc({ order: l, className: r, size: e = "sm" }) {
  return /* @__PURE__ */ n("div", { className: r, children: /* @__PURE__ */ n(V, { className: typeof l == "number" ? "lining-nums" : "", size: e, variant: "label", children: l }) });
}
const xc = ({
  children: l,
  className: r,
  endText: e,
  endTextProps: t,
  size: a = "sm",
  subHeadline: i,
  subHeadlineProps: c
}) => /* @__PURE__ */ d("div", { className: v(["flex items-center justify-between break-words", r]), children: [
  /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ n(V, { size: a, variant: "label", children: l }),
    i ? (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ n(V, { ...c, children: i })
    ) : null
  ] }),
  e ? /* @__PURE__ */ n(V, { ...t, children: e }) : null
] });
var Po = Object.defineProperty, jo = Object.defineProperties, Eo = Object.getOwnPropertyDescriptors, _1 = Object.getOwnPropertySymbols, Fe = Object.prototype.hasOwnProperty, Pe = Object.prototype.propertyIsEnumerable, W0 = (l, r, e) => r in l ? Po(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e, To = (l, r) => {
  for (var e in r || (r = {}))
    Fe.call(r, e) && W0(l, e, r[e]);
  if (_1)
    for (var e of _1(r))
      Pe.call(r, e) && W0(l, e, r[e]);
  return l;
}, Go = (l, r) => jo(l, Eo(r)), Wo = (l, r) => {
  var e = {};
  for (var t in l)
    Fe.call(l, t) && r.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && _1)
    for (var t of _1(l))
      r.indexOf(t) < 0 && Pe.call(l, t) && (e[t] = l[t]);
  return e;
}, Do = (l, r) => {
  var e = l, { title: t, titleId: a } = e, i = Wo(e, ["title", "titleId"]);
  return d("svg", Go(To({ width: i.size || "24", height: i.size || "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": a }, i), { children: [t ? n("title", { id: a, children: t }) : null, n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 12a6.969 6.969 0 1 0 13.938 0A6.969 6.969 0 0 0 5.03 12ZM3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z", fill: "currentColor" }), n("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m10.914 12 2.829-2.828a1 1 0 1 0-1.415-1.415L9.146 10.94a1.5 1.5 0 0 0 0 2.122l3.182 3.182a1 1 0 1 0 1.415-1.415L10.914 12Z", fill: "currentColor" })] }));
}, Uo = o(Do), qo = Uo;
function yc({ breadcrumb: l, children: r, className: e }) {
  return /* @__PURE__ */ d(L, { "aria-describedby": "pageTitleText", className: e, children: [
    l ? /* @__PURE__ */ d(_o, { breadcrumb: l, children: [
      /* @__PURE__ */ n(qo, {}),
      /* @__PURE__ */ n(V, { className: "mbs-px mis-0.25", children: l.title })
    ] }) : null,
    typeof r == "string" ? /* @__PURE__ */ n(M1, { id: "pageTitleText", size: "xl", variant: "headline", children: r }) : r
  ] });
}
function _o({ breadcrumb: l, children: r }) {
  return We.createElement(
    l.component ?? "a",
    {
      ...l,
      className: v(
        "flex text-text-muted-light hover:text-text-light dark:text-text-muted-dark dark:hover:text-text-dark transition-colors",
        l.className
      )
    },
    r
  );
}
const Cc = ({ children: l, className: r, ...e }) => /* @__PURE__ */ n("div", { className: v(["relative", r]), ...e, children: l }), Xo = ({
  align: l,
  children: r,
  className: e,
  fullScreenMobile: t,
  ...a
}) => {
  const i = Q(() => {
    const { horizontal: c, vertical: f } = l, g = t ? {
      center: "left-1/2 -translate-x-1/2",
      end: "left-1/2 -translate-x-1/2 lg:inline-end-0 lg:left-auto lg:translate-x-0",
      start: "left-1/2 -translate-x-1/2 lg:inline-start-0 lg:left-auto lg:translate-x-0"
    } : {
      center: "left-1/2 -translate-x-1/2",
      end: "inline-end-0",
      start: "inline-start-0"
    }, p = {
      bottom: "",
      top: "bottom-full"
    };
    return `${g[c]} ${p[f]}`;
  }, [l, t]);
  return /* @__PURE__ */ n(
    "div",
    {
      className: v([
        "absolute shadow-light-2 dark:shadow-dark-2 rounded-1 bg-canvas-light dark:bg-overlay-body-dark mbe-0.5 w-max overflow-y-scroll min-h-[200px] max-h-[400px] scrollbar-hide z-10",
        i,
        t ? "fixed w-11/12 lg:absolute lg:w-max" : "",
        e
      ]),
      ...a,
      children: r
    }
  );
}, Yo = ({ open: l, children: r }) => /* @__PURE__ */ n(t1, { children: l ? r : null }), kc = ({
  align: l = { horizontal: "start", vertical: "bottom" },
  autoFocus: r = !0,
  children: e,
  className: t,
  closeOnClickInside: a = !0,
  fullScreenMobile: i = !1,
  isDismissible: c,
  isOpen: f,
  onClose: g,
  ...p
}) => {
  function b(m) {
    c && m.key === "Escape" && g();
  }
  function w() {
    c && g();
  }
  const k = q(null);
  return re({ handler: w, ref: k }), /* @__PURE__ */ n(Yo, { open: f, children: /* @__PURE__ */ n(Ne, { autoFocus: r, children: /* @__PURE__ */ n(
    Xo,
    {
      align: l,
      className: t,
      fullScreenMobile: i,
      onClose: g,
      ...p,
      children: /* @__PURE__ */ n("div", { onClick: a ? g : () => {
      }, onKeyDown: b, ref: k, children: e })
    }
  ) }) });
}, Zc = ({ onToggle: l, children: r, className: e, disabled: t }) => {
  const a = (f) => {
    f.preventDefault(), f.stopPropagation(), l();
  }, i = q(null);
  if (!J1(r))
    return null;
  const c = _e(r, {
    className: e,
    disabled: t,
    onClick: a,
    ref: i
  });
  return /* @__PURE__ */ n(t1, { children: c });
}, Ko = ({ children: l, className: r, error: e, hint: t, heading: a, headingProps: i, hintProps: c, errorProps: f, ...g }, p) => /* @__PURE__ */ d("div", { ...g, className: v("flex-col rounded-0.5 w-fit", r), ref: p, children: [
  a ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ n(M1, { size: "md", variant: "fieldLabel", ...i, children: a })
  ) : null,
  e ? /* @__PURE__ */ n(
    M1,
    {
      className: v("text-alert-light dark:text-alert-dark", f == null ? void 0 : f.className),
      size: "md",
      variant: "caption",
      ...f,
      children: e
    }
  ) : null,
  t ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ n(M1, { size: "md", variant: "caption", ...c, children: t })
  ) : null,
  l
] }), Qo = o(Ko);
Qo.displayName = "Radio Set";
const Jo = ({ children: l, className: r, disabled: e, id: t, name: a, value: i, verticalAlign: c, ...f }, g) => /* @__PURE__ */ d(
  "div",
  {
    className: v([
      "flex items-baseline rounded-0.5 w-fit",
      {
        "items-baseline": c === "start",
        "items-center": c === "center"
      },
      r
    ]),
    children: [
      /* @__PURE__ */ n(
        "input",
        {
          ...f,
          className: "w-1.5 h-1.5 mie-0.5 flex-none rounded-0.25 peer inline",
          disabled: e,
          id: t,
          name: a,
          ref: g,
          type: "radio",
          value: i
        }
      ),
      /* @__PURE__ */ n(
        "label",
        {
          className: "peer-disabled:text-text-muted-light peer-disabled:dark:text-text-muted-dark text-text-light dark:text-text-dark",
          htmlFor: t,
          children: l
        }
      )
    ]
  }
), e9 = o(Jo);
e9.displayName = "RadioSetItem";
const l9 = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5 19a7.5 7.5 0 1 1 5.963-2.95l3.336 3.335a1 1 0 0 1-1.414 1.414l-3.336-3.336A7.467 7.467 0 0 1 10.5 19Zm0-2.031a5.469 5.469 0 1 1 0-10.938 5.469 5.469 0 0 1 0 10.938Z",
          fill: "currentColor"
        }
      )
    ]
  }
), t9 = o(l9), r9 = t9, i9 = ({ title: l, titleId: r, ...e }, t) => /* @__PURE__ */ d(
  "svg",
  {
    width: e.size || "24",
    height: e.size || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: t,
    "aria-labelledby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ n("title", { id: r, children: l }) : null,
      /* @__PURE__ */ n(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.768 11.646a.5.5 0 0 0 0 .708l3.182 3.182a1 1 0 0 1-1.414 1.414l-3.182-3.182a.5.5 0 0 0-.708 0L8.464 16.95a1 1 0 1 1-1.414-1.414l3.182-3.182a.5.5 0 0 0 0-.708L7.05 8.464A1 1 0 1 1 8.464 7.05l3.182 3.182a.5.5 0 0 0 .707 0l3.183-3.182a1 1 0 1 1 1.414 1.414l-3.182 3.182Z",
          fill: "currentColor"
        }
      )
    ]
  }
), a9 = o(i9), je = a9, n9 = ({
  className: l,
  disabled: r,
  error: e,
  hint: t,
  label: a,
  name: i,
  onChange: c,
  placeholder: f,
  value: g,
  dismissButtonLabel: p,
  ...b
}, w) => {
  const k = q(null), m = N1({ forwardedRef: w, innerRef: k }), I = (z) => {
    c && c(z.target.value);
  }, x = () => {
    c && c("");
  };
  return /* @__PURE__ */ d("div", { className: v(["flex items-start flex-col gap-0.5", l]), children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: v([
          "items-center self-stretch rounded-10 border-small border-solid cursor-text flex flex-row relative focus-within:border-transparent focus-within:outline-2 focus-within:outline-info focus-within:outline focus-within:dark:border-transparent focus-within:dark:outline-info-dark",
          r ? "bg-gray-10 dark:bg-gray-40" : null,
          e ? "border-alert dark:border-alert-dark" : "border-tertiary-light dark:border-tertiary-dark"
        ]),
        children: [
          /* @__PURE__ */ n("div", { className: "text-text-muted-light dark:text-text-muted-dark pis-1.5", children: /* @__PURE__ */ n(r9, {}) }),
          /* @__PURE__ */ n(
            "input",
            {
              className: v(["self-stretch bg-transparent flex-auto outline-none overflow-hidden h-[56px] pis-1 pie-1"]),
              disabled: r,
              id: i,
              name: i,
              onChange: I,
              placeholder: f,
              ref: m,
              type: "search",
              value: g,
              ...b
            }
          ),
          /* @__PURE__ */ n("label", { className: "sr-only", htmlFor: i, children: a }),
          g ? /* @__PURE__ */ n(
            H1,
            {
              "aria-label": p,
              className: "mie-1.5 p-0.25 bg-text-muted-light hover:bg-gray-20 dark:bg-text-muted-dark dark:hover:bg-gray-25 text-canvas-light dark:text-canvas-dark dark:hover:text-canvas-dark",
              onClick: x,
              variant: "primary",
              children: /* @__PURE__ */ n(je, {})
            }
          ) : null
        ]
      }
    ),
    e || t ? /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
      e ? /* @__PURE__ */ n("span", { className: "text-alert dark:text-alert-dark", children: e }) : null,
      t ? /* @__PURE__ */ n("span", { className: "text-text-muted-light dark:text-text-muted-dark text-13 leading-default", children: t }) : null
    ] }) : null
  ] });
}, Ee = o(n9);
Ee.displayName = "Search";
const d9 = ({
  label: l,
  name: r,
  options: e,
  disabled: t = !1,
  error: a,
  hint: i,
  noOptionsText: c,
  onChange: f,
  onSelect: g,
  value: p,
  ...b
}, w) => {
  const k = q(null), m = q(null), [I, x] = _(p), [z, y] = _(!1);
  U0(
    w,
    () => ({
      clearSelection() {
        x(null), f("");
      },
      ...k.current
    }),
    [f]
  );
  const S = (N) => {
    z || y(!0), !N.length && I && x(null), f(N);
  }, A = (N) => {
    g(N), f(N.label), x(N.label), y(!1);
  }, H = X1(() => {
    !I && p && f(""), I && p && f(I), y(!1);
  }, [f, I, p]), O = Q(() => {
    const N = p.toLowerCase();
    return e.filter((M) => M.label.toLowerCase().includes(N));
  }, [e, p]);
  return re({
    handler: H,
    ref: m
  }), /* @__PURE__ */ d(
    L,
    {
      className: v("relative p-1", {
        "bg-canvas-light dark:bg-canvas-secondary-dark rounded-t-1": z
      }),
      ref: m,
      children: [
        /* @__PURE__ */ n(
          Ee,
          {
            disabled: t,
            error: a,
            hint: i,
            label: l,
            name: r ?? l,
            onChange: (N) => {
              S(N);
            },
            onFocus: () => y(!0),
            ref: k,
            value: p,
            ...b
          }
        ),
        z ? /* @__PURE__ */ n(L, { className: "absolute top-full inset-x-0 z-50", children: /* @__PURE__ */ n(d0, { className: "max-h-[300px] rounded-t-0 px-0.5 overflow-y-auto", children: O.length ? O.map((N, M) => /* @__PURE__ */ n(z1, { onClick: () => A(N), children: N.label }, `${N.value}-${M}`)) : /* @__PURE__ */ n(z1, { children: c }, "no-options") }) }) : null
      ]
    }
  );
}, o9 = o(d9);
o9.displayName = "SearchableSelect";
function c9({
  className: l,
  defaultValue: r,
  onChange: e = () => {
  },
  values: t,
  size: a = "lg",
  itemClassName: i,
  activeItemClassName: c,
  ...f
}, g) {
  const [p, b] = _(r ?? 0), w = p > 0 ? p - 1 : 0, k = (m) => {
    b(m), e(m);
  };
  return /* @__PURE__ */ n(
    "div",
    {
      ...f,
      className: `inline-flex overflow-hidden text-gray-40 dark:text-white ${l}`,
      ref: g,
      children: t.map((m, I) => /* @__PURE__ */ n(
        h9,
        {
          activeIndex: p,
          activeItemClassName: c,
          className: i,
          currentIndex: I,
          lastIndex: t.length - 1,
          onSelectedValue: k,
          prevIndex: w,
          size: a,
          value: m
        },
        m
      ))
    }
  );
}
const s9 = o(c9);
s9.displayName = "SegmentedControl";
function h9({
  activeIndex: l,
  currentIndex: r,
  lastIndex: e,
  onSelectedValue: t,
  prevIndex: a,
  value: i,
  size: c,
  className: f,
  activeItemClassName: g = ""
}) {
  return /* @__PURE__ */ d(t1, { children: [
    /* @__PURE__ */ n(
      "button",
      {
        className: v(
          `font-bold text-center hover:cursor-pointer p-2 leading-tight border-y-small border-tertiary-light dark:border-tertiary-dark border-solid
            ${r === l ? " bg-gray-40 dark:bg-white text-white dark:text-gray-40 border-gray-40 dark:border-white" : ""}
          `,
          r === 0 ? "border-s-small rounded-ss-1 rounded-es-1" : "",
          r === e ? "border-e-small rounded-se-1 rounded-ee-1" : "",
          c === "md" ? "py-1.5" : "",
          c === "sm" ? "py-0.5 text-14" : "",
          f,
          r === l ? g : ""
        ),
        onClick: r !== l ? () => t(r) : void 0,
        type: "button",
        children: i
      }
    ),
    a === r || l === r || e === r ? null : /* @__PURE__ */ n("span", { className: "inline-block w-px bg-tertiary-light dark:bg-tertiary-dark" })
  ] });
}
const Mc = ({ className: l, ...r }) => /* @__PURE__ */ n(
  "option",
  {
    className: v("bg-canvas-light dark:bg-overlay-body-dark text-black dark:text-white", l),
    ...r
  }
), u9 = "_select_1dwiy_1";
const v9 = "appearance-none outline-none bg-transparent disabled:bg-gray-10 dark:disabled:bg-gray-40 rounded-1 border-solid border-small font-aktiv-grotesk text-16 leading-loose w-full mlb-0 truncate", f9 = "border-alert-light dark:border-alert-dark", g9 = "border-gray-10 dark:border-gray-40", l0 = "text-text-muted-light dark:text-text-muted-dark", D0 = v(
  l0,
  " font-medium text-13 absolute inline-start-2 block-start-[22px] pointer-events-none opacity-0 h-1.5"
), p9 = "-translate-y-1 opacity-100", w9 = "text-overlay-text dark:text-text-dark", b9 = "!pbs-[30px] !pbe-1", m9 = "absolute inset-block-0 grid place-content-center inline-end-0 leading-0 pointer-events-none text-text-muted-light dark:text-text-muted-dark", x9 = ({
  autoWidth: l = !1,
  children: r,
  className: e,
  disabled: t = !1,
  error: a,
  hint: i,
  icon: c,
  label: f,
  name: g,
  onChange: p,
  selectClassName: b,
  size: w = "md",
  value: k,
  ...m
}, I) => {
  var C;
  const x = v(u9, v9), z = q(null), y = N1({ forwardedRef: I, innerRef: z }), [S, A] = _(!!(k || (C = y == null ? void 0 : y.current) != null && C.value));
  o1(() => {
    var R;
    A(!!((R = y == null ? void 0 : y.current) != null && R.value || k));
  }, [k, y]);
  const H = w !== "sm" && (!!f || !!c), O = Q(() => {
    const R = v(
      x,
      w9,
      H ? b9 : null
    ), B = v(x, l0);
    return S ? R : B;
  }, [x, S, H]), N = Q(() => {
    const R = v(D0, p9), B = v(D0);
    return S ? R : B;
  }, [S]), M = (R) => {
    var B;
    A(!!((B = y == null ? void 0 : y.current) != null && B.value || k)), p && p(R);
  };
  return /* @__PURE__ */ d("div", { className: v("flex flex-col", e, l && "min-w-max"), children: [
    /* @__PURE__ */ d("div", { className: "relative border-none", children: [
      /* @__PURE__ */ n(
        "select",
        {
          ...m,
          className: v(
            [O, a ? f9 : g9],
            {
              "!pbs-[40px]": w === "lg" && H,
              "pis-2 plb-2 pie-5": w === "md",
              "plb-3 pis-3 pie-6 text-19": w === "lg",
              "plb-0.5 pis-1 pie-4 text-11": w === "sm"
            },
            b
          ),
          disabled: t,
          id: g,
          name: g,
          onChange: M,
          ref: y,
          value: k,
          children: r
        }
      ),
      w !== "sm" ? /* @__PURE__ */ d(
        "label",
        {
          className: v([
            N,
            "flex items-center",
            {
              "inline-start-3 block-start-[30px]": w === "lg"
            }
          ]),
          htmlFor: g,
          children: [
            c ? /* @__PURE__ */ n("div", { className: "mie-0.25", children: c }) : null,
            f
          ]
        }
      ) : null,
      /* @__PURE__ */ n(
        "div",
        {
          className: v(m9, {
            "pie-0.5": w === "sm",
            "pie-1": w === "md",
            "pie-1.5": w === "lg"
          }),
          children: /* @__PURE__ */ n(Y1, { size: "24" })
        }
      )
    ] }),
    a || i ? /* @__PURE__ */ d("div", { className: "mbs-0.5", children: [
      a ? /* @__PURE__ */ n("p", { className: "text-alert-light dark:text-alert-dark text-13 m-0", children: a }) : null,
      i ? /* @__PURE__ */ n("p", { className: v(l0, "text-13 m-0"), children: i }) : null
    ] }) : null
  ] });
}, zc = o(x9), y9 = o(({ className: l, children: r, state: e, ...t }, a) => /* @__PURE__ */ d(
  "div",
  {
    className: v(
      "group lg:block bg-canvas-light dark:bg-canvas-secondary-dark h-screen w-full lg:w-[216px] absolute lg:sticky z-1 border-gray-10 dark:border-gray-40 border-solid border-e-small whitespace-nowrap duration-200 transition-[left,width] ease-linear",
      e.isOpen ? "grid grid-cols-12" : "hidden",
      l
    ),
    ref: a,
    ...t,
    children: [
      /* @__PURE__ */ n("div", { className: "h-full col-start-1 col-end-11 md:col-start-1 md:col-end-5 flex flex-col", "data-sidebar": "sidebar", children: r }),
      /* @__PURE__ */ n(
        "div",
        {
          className: "lg:hidden bg-overlay-light dark:bg-overlay-dark col-start-11 col-span-full md:col-start-5 md:col-span-full",
          onClick: e.close,
          children: /* @__PURE__ */ n("button", { className: "text-white leading-0 p-2 opacity-50 hover:opacity-100", children: /* @__PURE__ */ n(Oe, { size: "32px" }) })
        }
      )
    ]
  }
));
y9.displayName = "Side Nav";
const C9 = o(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n(
    "div",
    {
      className: v("flex min-h-0 flex-1 flex-col overflow-auto gap-1 p-1", l),
      "data-sidebar": "content",
      ref: e,
      ...r
    }
  )
);
C9.displayName = "SideNavContent";
const k9 = o(({ className: l, ...r }, e) => {
  const [t, a] = _(!1);
  return o1(() => {
    const i = document.querySelector('[data-sidebar="content"]');
    if (!i)
      return;
    const c = new ResizeObserver(() => {
      a(i.scrollHeight > i.clientHeight);
    });
    return c.observe(i), () => {
      c.unobserve(i);
    };
  }, []), /* @__PURE__ */ n(
    "div",
    {
      className: v(
        "flex flex-col gap-2 p-1 transition-shadow duration-300",
        { "shadow-[rgba(0,0,0,0.5)_2px_-4px_6px_-5px]": t },
        l
      ),
      "data-sidebar": "footer",
      ref: e,
      ...r
    }
  );
});
k9.displayName = "SideNavFooter";
const Z9 = o(({ className: l, ...r }, e) => /* @__PURE__ */ n("div", { className: v("relative flex w-full min-w-0 flex-col", l), "data-sidebar": "group", ref: e, ...r }));
Z9.displayName = "SideNavGroup";
const M9 = () => /* @__PURE__ */ n(eo, { className: "w-auto border-gray-10 dark:border-gray-40 border-small border-b-none" });
M9.displayName = "SideNavGroupDivider";
const z9 = o(({ className: l, ...r }, e) => /* @__PURE__ */ n(
  V,
  {
    className: v("uppercase m-1 text-11 text-text-muted-light dark:text-text-muted-dark tracking-wider", l),
    ref: e,
    size: "xs",
    variant: "buttonLabel",
    ...r
  }
));
z9.displayName = "SideNavGroupLabel";
const R9 = o(({ className: l, ...r }, e) => /* @__PURE__ */ n("div", { className: v("flex flex-col gap-1 p-1", l), "data-sidebar": "header", ref: e, ...r }));
R9.displayName = "SideNavHeader";
function I9(l, r) {
  typeof l == "function" ? l(r) : l != null && (l.current = r);
}
function S9(...l) {
  return (r) => l.forEach((e) => I9(e, r));
}
var Te = W.forwardRef((l, r) => {
  const { children: e, ...t } = l, a = W.Children.toArray(e), i = a.find(N9);
  if (i) {
    const c = i.props.children, f = a.map((g) => g === i ? W.Children.count(c) > 1 ? W.Children.only(null) : W.isValidElement(c) ? c.props.children : null : g);
    return /* @__PURE__ */ n(t0, { ...t, ref: r, children: W.isValidElement(c) ? W.cloneElement(c, void 0, f) : null });
  }
  return /* @__PURE__ */ n(t0, { ...t, ref: r, children: e });
});
Te.displayName = "Slot";
var t0 = W.forwardRef((l, r) => {
  const { children: e, ...t } = l;
  if (W.isValidElement(e)) {
    const a = H9(e);
    return W.cloneElement(e, {
      ...A9(t, e.props),
      // @ts-ignore
      ref: r ? S9(r, a) : a
    });
  }
  return W.Children.count(e) > 1 ? W.Children.only(null) : null;
});
t0.displayName = "SlotClone";
var B9 = ({ children: l }) => /* @__PURE__ */ n(t1, { children: l });
function N9(l) {
  return W.isValidElement(l) && l.type === B9;
}
function A9(l, r) {
  const e = { ...r };
  for (const t in r) {
    const a = l[t], i = r[t];
    /^on[A-Z]/.test(t) ? a && i ? e[t] = (...f) => {
      i(...f), a(...f);
    } : a && (e[t] = a) : t === "style" ? e[t] = { ...a, ...i } : t === "className" && (e[t] = [a, i].filter(Boolean).join(" "));
  }
  return { ...l, ...e };
}
function H9(l) {
  var t, a;
  let r = (t = Object.getOwnPropertyDescriptor(l.props, "ref")) == null ? void 0 : t.get, e = r && "isReactWarning" in r && r.isReactWarning;
  return e ? l.ref : (r = (a = Object.getOwnPropertyDescriptor(l, "ref")) == null ? void 0 : a.get, e = r && "isReactWarning" in r && r.isReactWarning, e ? l.props.ref : l.props.ref || l.ref);
}
const V9 = ({
  isActive: l = !1,
  isDisabled: r = !1,
  className: e,
  children: t,
  asChild: a
}) => /* @__PURE__ */ n(
  a ? Te : "li",
  {
    className: v(
      "group/menu-item rounded-0.5 flex flex-row w-full items-center whitespace-normal leading-[1.2] p-1 gap-1 outline-none transition-[width,height,padding] active:bg-warm-neutral active:dark:bg-warm-neutral-dark data-[active=true]:bg-warm-neutral dark:data-[active=true]:dark:bg-warm-neutral-dark [&>svg]:size-4 [&>svg]:shrink-0",
      "hover:bg-warm-neutral hover:dark:bg-warm-neutral-dark",
      "text-15 md:text-13 text-text-light dark:text-text-dark data-[active=true]:font-medium font-regular fill-black dark:fill-white",
      "disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[disabled=true]:opacity-50 data-[disabled=true]:pointer-events-none",
      e
    ),
    "data-active": l,
    "data-disabled": r,
    "data-sidebar": "menu-item",
    children: t
  }
);
V9.displayName = "SideNavItem";
const $9 = ({ icon: l }) => W.isValidElement(l) ? l : typeof l == "object" && "filled" in l && "outlined" in l ? /* @__PURE__ */ d(t1, { children: [
  /* @__PURE__ */ n("div", { className: "hidden group-data-[active=true]/menu-item:block", children: l.filled }),
  /* @__PURE__ */ n("div", { className: "block group-data-[active=true]/menu-item:hidden", children: l.outlined })
] }) : null;
$9.displayName = "SideNavItem";
const L9 = o(({ className: l, ...r }, e) => /* @__PURE__ */ n("ul", { className: v("flex w-full min-w-0 flex-col", l), "data-sidebar": "menu", ref: e, ...r }));
L9.displayName = "SideNavItems";
function O9({
  checked: l,
  disabled: r,
  label: e,
  error: t,
  wrapperClassName: a,
  containerClassName: i,
  circleClassName: c,
  hint: f,
  ...g
}, p) {
  return /* @__PURE__ */ d("label", { className: v("flex cursor-pointer select-none items-start flex-col", i), children: [
    /* @__PURE__ */ n("span", { className: "text-13 font-medium text-gray-25", children: e }),
    /* @__PURE__ */ d(L, { className: v("relative w-8", r ? "opacity-50" : ""), children: [
      /* @__PURE__ */ n("input", { checked: l, className: "sr-only", disabled: r, ref: p, type: "checkbox", ...g }),
      /* @__PURE__ */ n(
        L,
        {
          className: v(
            "box block h-[34px] w-full rounded-2 focus:border-0.25 focus:border-blue-30 focus:border-solid",
            l ? "bg-blue-30" : "bg-gray-15",
            t ? "border-[1px] border-solid border-orange-30" : "",
            a
          ),
          type: "button"
        }
      ),
      /* @__PURE__ */ n(
        L,
        {
          className: v(
            "absolute block-start-0.25 h-[30px] w-[30px] items-center justify-center rounded-full bg-white transition-all",
            l ? "inline-start-4" : "inline-start-0.25",
            c
          )
        }
      )
    ] }),
    /* @__PURE__ */ d(L, { children: [
      t ? /* @__PURE__ */ n("p", { className: "text-alert-light dark:text-alert-dark text-13 font-regular", children: t }) : null,
      f ? /* @__PURE__ */ n("p", { className: "text-text-muted-light dark:text-text-muted-dark text-13 font-regular", children: f }) : null
    ] })
  ] });
}
const F9 = o(O9);
F9.displayName = "Switch";
function P9({ active: l, children: r, component: e = "a", className: t, href: a, onTabChange: i, tabKey: c }, f) {
  return /* @__PURE__ */ n(
    V,
    {
      className: v(
        "text-gray-50 whitespace-nowrap text-16 leading-loose mie-2 cursor-pointer",
        l ? "font-bold underline decoration-yv-red decoration-2 underline-offset-8" : "text-text-muted-light dark:text-text-muted-dark",
        t
      ),
      component: e,
      href: a,
      onClick: () => {
        i && c && i(c);
      },
      ref: f,
      children: r
    }
  );
}
const Rc = o(P9);
function j9({
  active: l,
  children: r,
  component: e = "a",
  className: t,
  href: a,
  iconName: i,
  ...c
}) {
  const f = cn[i];
  return /* @__PURE__ */ d(
    V,
    {
      className: v(
        "text-gray-50 text-xs flex flex-col justify-center items-center px-3",
        l ? "opacity-100" : "opacity-50",
        t
      ),
      component: e,
      href: a,
      ...c,
      children: [
        /* @__PURE__ */ n(f, { size: "24" }),
        r
      ]
    }
  );
}
function Ic({ activeTab: l, className: r, tabs: e, ...t }) {
  return /* @__PURE__ */ n("div", { className: v("h-8 flex w-full justify-between rtl:flex-row-reverse dark:bg-gray-40", r), ...t, children: e.map((a) => /* @__PURE__ */ n(j9, { active: l.includes(a.label), href: a.href, iconName: a.iconName, children: a.label }, a.label)) });
}
const E9 = W.forwardRef(({ className: l, outerStyles: r, ...e }, t) => /* @__PURE__ */ n(
  "div",
  {
    className: v(
      "w-full overflow-auto pbs-1 pis-1 pie-1 pbe-1.5 bg-white dark:bg-canvas-secondary-dark rounded-3 shadow-light-2 dark:shadow-dark-2",
      r
    ),
    children: /* @__PURE__ */ n("table", { className: v("w-full", l), ref: t, ...e })
  }
));
E9.displayName = "Table";
const T9 = W.forwardRef(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n("tbody", { className: v(l), ref: e, ...r })
);
T9.displayName = "TableBody";
const G9 = W.forwardRef(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n(
    "td",
    {
      className: v(
        "p-1 align-middle first:rounded-s-1 last:rounded-e-1 group-even:bg-canvas-secondary-light dark:group-even:bg-canvas-dark [&:not(:last-child)]:border-e-[0.5px] border-tertiary-light dark:border-tertiary-dark",
        l
      ),
      ref: e,
      ...r
    }
  )
);
G9.displayName = "TableCell";
const W9 = W.forwardRef(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n(
    "th",
    {
      className: v(
        "first:rounded-ss-1.5 last:rounded-se-1.5 bg-canvas-secondary-light dark:bg-canvas-secondary-dark text-center text-13 p-0.5",
        l
      ),
      ref: e,
      ...r
    }
  )
);
W9.displayName = "TableHead";
const D9 = W.forwardRef(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n("thead", { className: v(l), ref: e, ...r })
);
D9.displayName = "TableHeader";
const U9 = W.forwardRef(
  ({ className: l, ...r }, e) => /* @__PURE__ */ n("tr", { className: v("group", l), ref: e, ...r })
);
U9.displayName = "TableRow";
const q9 = {
  caution: "bg-yellow-10 dark:bg-yellow-50 text-yellow-40 dark:text-yellow-20",
  default: "bg-gray-10 dark:bg-gray-40 text-light dark:text-dark",
  error: "bg-orange-10 dark:bg-orange-50 text-orange-40 dark:text-orange-20",
  info: "bg-blue-10 dark:bg-blue-50 text-blue-40 dark:text-blue-20",
  secondary: "bg-gray-10 dark:bg-gray-35 text-light dark:text-dark",
  success: "bg-green-10 dark:bg-green-50 text-green-40 dark:text-green-20",
  vibrantSuccess: "bg-success-light dark:bg-success-dark text-surface-secondary-light"
}, _9 = {
  lg: "text-16 w-fit h-fit rounded-0.5 plb-0.5 pli-1",
  sm: "text-11 w-fit h-fit rounded-0.5 plb-0.25 pli-0.5"
}, Sc = ({ message: l, variant: r = "default", size: e = "sm", className: t }) => {
  const a = q9[r], i = _9[e];
  return /* @__PURE__ */ n("div", { className: v(a, i, t), children: /* @__PURE__ */ n(V, { className: "text-inherit dark:text-inherit", children: l }) });
}, X9 = ({
  className: l,
  disabled: r,
  disableResize: e,
  error: t,
  hint: a,
  inputClassName: i,
  inputContainerClassName: c,
  label: f,
  name: g,
  onChange: p,
  placeholder: b,
  value: w,
  ...k
}, m) => {
  const I = q(null), x = N1({ forwardedRef: m, innerRef: I }), [z, y] = _(!!(w || b)), [S, A] = _(!1), H = (M) => {
    y(!!(M.target.value || b)), p && p(M);
  }, O = () => {
    r || !x.current || (x.current.focus(), A(!0));
  }, N = () => {
    A(!1);
  };
  return /* @__PURE__ */ d("div", { className: v(["flex items-start flex-col gap-0.5", l]), children: [
    /* @__PURE__ */ n(
      "div",
      {
        className: v([
          "items-center self-stretch rounded-1 border-small border-solid cursor-text flex flex-row relative focus-within:border-transparent focus-within:outline-2 focus-within:outline-info focus-within:outline focus-within:dark:border-transparent focus-within:dark:outline-info-dark",
          c,
          r ? "bg-gray-10 dark:bg-gray-40" : null,
          t ? "border-alert dark:border-alert-dark" : "border-tertiary-light dark:border-tertiary-dark"
        ]),
        onFocus: O,
        children: /* @__PURE__ */ d("span", { className: "relative flex flex-1 overflow-hidden", children: [
          /* @__PURE__ */ n(
            "textarea",
            {
              className: v([
                "self-stretch bg-transparent flex-auto outline-none overflow-hidden pis-2 pie-2",
                f ? "mbs-3 pbe-1" : "pbs-2 pbe-2 min-h-[56px]",
                e && "resize-none",
                i
              ]),
              disabled: r,
              id: g,
              onBlur: N,
              onChange: H,
              placeholder: b,
              ref: x,
              value: w,
              ...k
            }
          ),
          f ? /* @__PURE__ */ n(
            "label",
            {
              className: v(
                "inline-start-2 items-center text-text-muted-light dark:text-text-muted-dark flex font-regular leading-loose pointer-events-none absolute block-start-2 select-none",
                S || z ? "text-13 -translate-y-1.5" : "text-16"
              ),
              htmlFor: g,
              children: f
            }
          ) : null
        ] })
      }
    ),
    t || a ? /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
      t ? /* @__PURE__ */ n(V, { className: "text-alert dark:text-alert-dark", children: t }) : null,
      a ? /* @__PURE__ */ n(V, { className: "text-text-muted-light dark:text-text-muted-dark text-13 leading-default", children: a }) : null
    ] }) : null
  ] });
}, Y9 = o(X9);
Y9.displayName = "TextArea";
const K9 = "_inputIcon_1pzdd_1", Q9 = {
  inputIcon: K9
}, J9 = ({ className: l, error: r, name: e, ...t }, a) => /* @__PURE__ */ d(t1, { children: [
  /* @__PURE__ */ n(
    "input",
    {
      className: v([
        "rounded-1 text-black dark:text-white p-2 border-small border-tertiary-light dark:border-tertiary-dark hover:cursor-pointer bg-transparent disabled:bg-gray-10 disabled:dark:bg-gray-40 disabled:cursor-auto h-[58px]",
        Q9.inputIcon,
        l
      ]),
      id: e,
      name: e,
      ref: a,
      role: "textbox",
      type: "time",
      ...t
    }
  ),
  r ? /* @__PURE__ */ n("div", { className: "text-alert-light dark:text-alert-dark text-13", children: r }) : null
] }), ec = o(J9);
ec.displayName = "TimePicker";
const lc = {
  caution: "bg-yellow-30",
  default: "bg-gray-30",
  error: "bg-orange-30",
  info: "bg-blue-30",
  success: "bg-green-30"
}, l1 = {
  DISMISS: "dismiss",
  REMOVE: "remove",
  SHOW: "show",
  START: "start"
}, Bc = ({
  className: l,
  children: r,
  dismiss: e,
  duration: t,
  hideDismissButton: a = !1,
  variant: i = "default",
  position: c = "inlineEnd"
}) => {
  const f = q(null), [g, p] = _(l1.START);
  o1(() => {
    if (g === l1.START) {
      const x = setTimeout(() => p(l1.SHOW), 100);
      return () => clearTimeout(x);
    } else if (g === l1.DISMISS) {
      const x = setTimeout(() => {
        e && e(), p(l1.REMOVE);
      }, 1e3);
      return () => clearTimeout(x);
    } else if (t && g !== l1.REMOVE) {
      const x = setTimeout(() => p(l1.DISMISS), t);
      return () => clearTimeout(x);
    }
  }, [t, g, e]);
  const b = Q(() => {
    var x;
    return g === l1.DISMISS && ((x = f == null ? void 0 : f.current) != null && x.clientHeight) ? `-${f.current.clientHeight}px` : "0px";
  }, [f, g]), w = () => p(l1.DISMISS), k = Q(() => {
    const x = "flex items-start justify-start p-2 text-white rounded-1 width-full max-w-[400px] border-0 opacity-0 transition-[opacity, transform] duration-1000 ease-in-out min-w-[276px]";
    switch (c) {
      case "inlineEnd":
        return g === l1.SHOW ? `${x} translate-x-0 opacity-1` : `${x} translate-x-[400px]`;
      case "inlineStart":
      default:
        return g === l1.SHOW ? `${x} translate-x-[-400px]` : `${x} opacity-1 translate-x-0`;
    }
  }, [c, g]), m = Q(() => {
    const x = "flex flex-col transition-[margin] duration-500 ease-in-out overflow-hidden";
    return c === "inlineEnd" ? `${x} items-end` : `${x} items-start`;
  }, [c]), I = Q(() => lc[i], [i]);
  return g === l1.REMOVE ? null : /* @__PURE__ */ n("div", { className: v(m), style: { marginBlockEnd: b }, children: /* @__PURE__ */ d("div", { className: v(k, I, l), ref: f, children: [
    !a && /* @__PURE__ */ n("button", { "aria-label": "Dismiss", className: "mie-1", onClick: w, children: /* @__PURE__ */ n(je, {}) }),
    r
  ] }) });
}, Nc = ({ content: l, className: r, ...e }) => /* @__PURE__ */ n(
  "div",
  {
    className: v(
      "max-w-[460px] w-max shadow-light-1 rounded-1 plb-1 pli-1.5 leading-loose text-13 not-italic text-overlay-text bg-white dark:text-text-dark dark:bg-overlay-body-dark dark:shadow-dark-1",
      r
    ),
    ...e,
    children: l
  }
);
function tc({ className: l, label: r, theme: e, userAvatar: t, userName: a, variant: i, ...c }, f) {
  let g = {
    border: "border-tertiary-light dark:border-tertiary-dark",
    icon: "",
    text: ""
  };
  switch (e) {
    case "white":
      g = {
        border: "border-white/25 hover:bg-white/10",
        icon: "text-white/25 hover:text-white",
        text: "text-white"
      };
      break;
  }
  return /* @__PURE__ */ d(
    "button",
    {
      "aria-label": r,
      className: v("flex items-center p-1 max-w-fit rounded-4 gap-1 border-standard", g.border, l),
      ref: f,
      ...c,
      children: [
        /* @__PURE__ */ n("div", { className: "w-4 h-4", children: t }),
        /* @__PURE__ */ n(V, { className: v("font-bold", g.text, { "hidden md:block": i === "header" }), children: a }),
        /* @__PURE__ */ n(Y1, { className: g.icon })
      ]
    }
  );
}
const rc = o(tc);
rc.displayName = "UserProfileButton";
const ic = {
  scale: 1
}, ac = (l, r) => {
  const e = document.createElement("canvas");
  return e.width = l, e.height = r, e.getContext("2d");
}, nc = (l, r) => {
  const { scale: e } = r, t = new Image();
  return t.crossOrigin = "*", new Promise((a, i) => {
    const c = () => i(new Error("An error occurred loading the image."));
    t.onload = function() {
      const f = t.width * e, g = t.height * e, p = ac(f, g);
      if (p) {
        p.drawImage(t, 0, 0, f, g);
        const { data: b } = p.getImageData(0, 0, f, g);
        a(b);
      } else
        c();
    }, t.onerror = c, t.onabort = c, t.src = l;
  });
}, dc = (l) => {
  const r = /* @__PURE__ */ new Map();
  for (let t = 0; t < l.length; t += 4) {
    if (l[t + 3] === 0)
      continue;
    const i = Array.from(l.subarray(t, t + 3)), c = i.every((g) => g === i[0]), f = `rgb(${i.join(",")})`;
    r.set(f, c ? 0 : (r.get(f) ?? 0) + 1);
  }
  return Array.from(r, ([t, a]) => ({ color: t, count: a })).sort((t, a) => a.count - t.count);
}, Ac = async (l, r) => {
  const e = { ...ic, ...r }, t = await nc(l, e);
  return dc(t);
};
export {
  el as AutocompleteSelect,
  hc as Banner,
  L as Box,
  In as Breadcrumb,
  Fn as Breadcrumbs,
  B1 as Button,
  Pn as ButtonComponent,
  En as Checkbox,
  Gn as ColorSelect,
  Co as Column,
  Ed as DataTable,
  Ld as DataTableBody,
  Od as DataTableCell,
  F0 as DataTableCellContent,
  Td as DataTableContainer,
  Fd as DataTableHead,
  Pd as DataTableHeader,
  P0 as DataTableRow,
  Jd as Dialog,
  eo as Divider,
  no as Dropdown,
  bo as EditableWell,
  xo as FauxPhone,
  vc as FeatureWell,
  fc as FeatureWellButton,
  gc as FeatureWellColumn,
  pc as FeatureWellImage,
  wc as FeatureWellText,
  Ne as FocusTrap,
  Zo as Grid,
  M1 as Heading,
  bc as HorizontalLoader,
  H1 as IconButton,
  Ve as IconLinkButton,
  Lo as ImageUpload,
  n0 as Input,
  Fo as LinkButton,
  Oo as LinkButtonComponent,
  d0 as List,
  z1 as ListItem,
  to as ListItemActions,
  ro as ListItemContent,
  mc as ListItemOrderMarker,
  xc as ListItemText,
  A1 as LoadingSpinner,
  Mc as Option,
  yc as PageTitle,
  $d as Pagination,
  Cc as Popover,
  kc as PopoverBody,
  Zc as PopoverTrigger,
  Qo as RadioSet,
  e9 as RadioSetItem,
  zo as Row,
  Ee as Search,
  o9 as SearchableSelect,
  s9 as SegmentedControl,
  h9 as SegmentedControlItem,
  zc as Select,
  y9 as SideNav,
  C9 as SideNavContent,
  k9 as SideNavFooter,
  Z9 as SideNavGroup,
  M9 as SideNavGroupDivider,
  z9 as SideNavGroupLabel,
  R9 as SideNavHeader,
  V9 as SideNavItem,
  $9 as SideNavItemIcon,
  L9 as SideNavItems,
  F9 as Switch,
  Rc as Tab,
  Ic as TabBar,
  j9 as TabBarItem,
  E9 as Table,
  T9 as TableBody,
  G9 as TableCell,
  W9 as TableHead,
  D9 as TableHeader,
  U9 as TableRow,
  Sc as Tag,
  V as Text,
  Y9 as TextArea,
  ec as TimePicker,
  Bc as Toast,
  Nc as Tooltip,
  rc as UserProfileButton,
  uc as buttonSizeOptions,
  v as cn,
  me as defaultButtonClasses,
  be as determineSizeClasses,
  S1 as iconSizes,
  Ac as palettize,
  N1 as useCombinedRefs,
  P2 as useLockBodyScroll,
  re as useOnClickOutside,
  X as variantClasses
};
